// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { dateRangeFromJson, dateRangeToJson, fieldMaskFromJson, fieldMaskToJson } from '../../vendastatypes/codec';
export function acquisitionDataToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    if (m.origin !== undefined)
        o['origin'] = m.origin;
    if (m.visitorIdCookie !== undefined)
        o['visitorIdCookie'] = m.visitorIdCookie;
    if (m.conquerLocalAcademyVisitorId !== undefined)
        o['conquerLocalAcademyVisitorId'] = m.conquerLocalAcademyVisitorId;
    if (m.conversionPoint !== undefined)
        o['conversionPoint'] = m.conversionPoint;
    if (m.numberOfEmployees !== undefined)
        o['numberOfEmployees'] = m.numberOfEmployees;
    if (m.affiliateId !== undefined)
        o['affiliateId'] = m.affiliateId;
    if (m.referrerId !== undefined)
        o['referrerId'] = m.referrerId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.clearbitCollectedSignupDataId !== undefined)
        o['clearbitCollectedSignupDataId'] = m.clearbitCollectedSignupDataId;
    return o;
}
export function acquisitionDataFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        tags: ((_b = o['tags']) !== null && _b !== void 0 ? _b : []).map(e => e),
        origin: (_c = o['origin']) !== null && _c !== void 0 ? _c : '',
        visitorIdCookie: (_d = o['visitorIdCookie']) !== null && _d !== void 0 ? _d : '',
        conquerLocalAcademyVisitorId: (_e = o['conquerLocalAcademyVisitorId']) !== null && _e !== void 0 ? _e : '',
        conversionPoint: (_f = o['conversionPoint']) !== null && _f !== void 0 ? _f : '',
        numberOfEmployees: (_g = o['numberOfEmployees']) !== null && _g !== void 0 ? _g : '',
        affiliateId: (_h = o['affiliateId']) !== null && _h !== void 0 ? _h : '',
        referrerId: (_j = o['referrerId']) !== null && _j !== void 0 ? _j : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        clearbitCollectedSignupDataId: (_k = o['clearbitCollectedSignupDataId']) !== null && _k !== void 0 ? _k : '',
    };
}
export function getAcquisitionDataRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getAcquisitionDataRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getAcquisitionDataResponseToJson(m) {
    const o = {};
    if (m.acquisitionData !== undefined)
        o['acquisitionData'] = acquisitionDataToJson(m.acquisitionData);
    return o;
}
export function getAcquisitionDataResponseFromJson(o) {
    return {
        acquisitionData: o['acquisitionData'] ? acquisitionDataFromJson(o['acquisitionData']) : undefined,
    };
}
export function addonActivationToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.addonId !== undefined)
        o['addonId'] = m.addonId;
    if (m.activationId !== undefined)
        o['activationId'] = m.activationId;
    if (m.quantity !== undefined)
        o['quantity'] = m.quantity;
    if (m.start !== undefined)
        o['start'] = m.start.toISOString();
    if (m.end !== undefined)
        o['end'] = m.end.toISOString();
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.activationFailureReason !== undefined)
        o['activationFailureReason'] = m.activationFailureReason;
    return o;
}
export function addonActivationFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        addonId: (_b = o['addonId']) !== null && _b !== void 0 ? _b : '',
        activationId: (_c = o['activationId']) !== null && _c !== void 0 ? _c : '',
        quantity: (_d = o['quantity']) !== null && _d !== void 0 ? _d : 0,
        start: o['start'] ? new Date(o['start']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        end: o['end'] ? new Date(o['end']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        status: (_e = o['status']) !== null && _e !== void 0 ? _e : 'ADDON_ACTIVATION_STATUS_PENDING',
        activationFailureReason: (_f = o['activationFailureReason']) !== null && _f !== void 0 ? _f : '',
    };
}
export function partnerAddonToJson(m) {
    const o = {};
    if (m.sku !== undefined)
        o['sku'] = m.sku;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.supportsBulkActivation !== undefined)
        o['supportsBulkActivation'] = m.supportsBulkActivation;
    return o;
}
export function partnerAddonFromJson(o) {
    var _a, _b, _c;
    return {
        sku: (_a = o['sku']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        supportsBulkActivation: (_c = o['supportsBulkActivation']) !== null && _c !== void 0 ? _c : false,
    };
}
export function trialToJson(m) {
    const o = {};
    if (m.trialId !== undefined)
        o['trialId'] = m.trialId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.subscriptionLevel !== undefined)
        o['subscriptionLevel'] = m.subscriptionLevel;
    if (m.start !== undefined)
        o['start'] = m.start.toISOString();
    if (m.end !== undefined)
        o['end'] = m.end.toISOString();
    if (m.cancel !== undefined)
        o['cancel'] = m.cancel.toISOString();
    if (m.createdBy !== undefined)
        o['createdBy'] = m.createdBy;
    if (m.modifiedBy !== undefined)
        o['modifiedBy'] = m.modifiedBy;
    if (m.subscriptionTierId !== undefined)
        o['subscriptionTierId'] = m.subscriptionTierId;
    return o;
}
export function trialFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        trialId: (_a = o['trialId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        subscriptionLevel: (_c = o['subscriptionLevel']) !== null && _c !== void 0 ? _c : 'SUBSCRIPTION_LEVEL_BASIC',
        start: o['start'] ? new Date(o['start']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        end: o['end'] ? new Date(o['end']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        cancel: o['cancel'] ? new Date(o['cancel']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        createdBy: (_d = o['createdBy']) !== null && _d !== void 0 ? _d : '',
        modifiedBy: (_e = o['modifiedBy']) !== null && _e !== void 0 ? _e : '',
        subscriptionTierId: (_f = o['subscriptionTierId']) !== null && _f !== void 0 ? _f : '',
    };
}
export function listTopRequestToJson(m) {
    const o = {};
    if (m.partnerType !== undefined)
        o['partnerType'] = m.partnerType;
    return o;
}
export function listTopRequestFromJson(o) {
    var _a;
    return {
        partnerType: (_a = o['partnerType']) !== null && _a !== void 0 ? _a : 'PARTNER_TYPE_UNSPECIFIED',
    };
}
export function partnerStatsToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.companyName !== undefined)
        o['companyName'] = m.companyName;
    if (m.accountingStatus !== undefined)
        o['accountingStatus'] = m.accountingStatus;
    if (m.notPayedTerms !== undefined)
        o['notPayedTerms'] = m.notPayedTerms;
    if (m.outstandingBalance !== undefined)
        o['outstandingBalance'] = m.outstandingBalance;
    if (m.currentlyAssignedSalesPerson !== undefined)
        o['currentlyAssignedSalesPerson'] = m.currentlyAssignedSalesPerson;
    if (m.additionalSalesPerson !== undefined)
        o['additionalSalesPerson'] = m.additionalSalesPerson;
    if (m.recurringMeetingTime !== undefined)
        o['recurringMeetingTime'] = m.recurringMeetingTime;
    if (m.recurringMeetingDay !== undefined)
        o['recurringMeetingDay'] = m.recurringMeetingDay;
    if (m.recurringMeetingFrequency !== undefined)
        o['recurringMeetingFrequency'] = m.recurringMeetingFrequency;
    if (m.subscriptionLevel !== undefined)
        o['subscriptionLevel'] = m.subscriptionLevel;
    if (m.partnerCohortSize !== undefined)
        o['partnerCohortSize'] = m.partnerCohortSize;
    if (m.isMultiLocation !== undefined)
        o['isMultiLocation'] = m.isMultiLocation;
    if (m.latestMonthRevenue !== undefined)
        o['latestMonthRevenue'] = m.latestMonthRevenue;
    if (m.oneMonthEarlierRevenue !== undefined)
        o['oneMonthEarlierRevenue'] = m.oneMonthEarlierRevenue;
    if (m.twoMonthEarlierRevenue !== undefined)
        o['twoMonthEarlierRevenue'] = m.twoMonthEarlierRevenue;
    if (m.ytdRevenue !== undefined)
        o['ytdRevenue'] = m.ytdRevenue;
    if (m.revGrowthSinceLastMonth !== undefined)
        o['revGrowthSinceLastMonth'] = m.revGrowthSinceLastMonth;
    if (m.percentageRevGrowthFromLastMonth !== undefined)
        o['percentageRevGrowthFromLastMonth'] = m.percentageRevGrowthFromLastMonth;
    if (m.uniqueBilledProductsLast6Months !== undefined)
        o['uniqueBilledProductsLast6Months'] = m.uniqueBilledProductsLast6Months;
    if (m.logoUrl !== undefined)
        o['logoUrl'] = m.logoUrl;
    if (m.associatedPid !== undefined)
        o['associatedPid'] = m.associatedPid;
    return o;
}
export function partnerStatsFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        companyName: (_b = o['companyName']) !== null && _b !== void 0 ? _b : '',
        accountingStatus: (_c = o['accountingStatus']) !== null && _c !== void 0 ? _c : '',
        notPayedTerms: (_d = o['notPayedTerms']) !== null && _d !== void 0 ? _d : 0,
        outstandingBalance: (_e = o['outstandingBalance']) !== null && _e !== void 0 ? _e : 0,
        currentlyAssignedSalesPerson: (_f = o['currentlyAssignedSalesPerson']) !== null && _f !== void 0 ? _f : '',
        additionalSalesPerson: (_g = o['additionalSalesPerson']) !== null && _g !== void 0 ? _g : '',
        recurringMeetingTime: (_h = o['recurringMeetingTime']) !== null && _h !== void 0 ? _h : '',
        recurringMeetingDay: (_j = o['recurringMeetingDay']) !== null && _j !== void 0 ? _j : '',
        recurringMeetingFrequency: (_k = o['recurringMeetingFrequency']) !== null && _k !== void 0 ? _k : '',
        subscriptionLevel: (_l = o['subscriptionLevel']) !== null && _l !== void 0 ? _l : '',
        partnerCohortSize: (_m = o['partnerCohortSize']) !== null && _m !== void 0 ? _m : '',
        isMultiLocation: (_o = o['isMultiLocation']) !== null && _o !== void 0 ? _o : false,
        latestMonthRevenue: (_p = o['latestMonthRevenue']) !== null && _p !== void 0 ? _p : 0,
        oneMonthEarlierRevenue: (_q = o['oneMonthEarlierRevenue']) !== null && _q !== void 0 ? _q : 0,
        twoMonthEarlierRevenue: (_r = o['twoMonthEarlierRevenue']) !== null && _r !== void 0 ? _r : 0,
        ytdRevenue: (_s = o['ytdRevenue']) !== null && _s !== void 0 ? _s : 0,
        revGrowthSinceLastMonth: (_t = o['revGrowthSinceLastMonth']) !== null && _t !== void 0 ? _t : 0,
        percentageRevGrowthFromLastMonth: (_u = o['percentageRevGrowthFromLastMonth']) !== null && _u !== void 0 ? _u : 0,
        uniqueBilledProductsLast6Months: (_v = o['uniqueBilledProductsLast6Months']) !== null && _v !== void 0 ? _v : 0,
        logoUrl: (_w = o['logoUrl']) !== null && _w !== void 0 ? _w : '',
        associatedPid: (_x = o['associatedPid']) !== null && _x !== void 0 ? _x : '',
    };
}
export function listTopResponseToJson(m) {
    const o = {};
    if (m.partnerStats !== undefined) {
        o['partnerStats'] = m.partnerStats.map(e => partnerStatsToJson(e));
    }
    return o;
}
export function listTopResponseFromJson(o) {
    var _a;
    return {
        partnerStats: ((_a = o['partnerStats']) !== null && _a !== void 0 ? _a : []).map(e => partnerStatsFromJson(e)),
    };
}
export function updateSubscriptionTierRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.tierId !== undefined)
        o['tierId'] = m.tierId;
    if (m.frequency !== undefined)
        o['frequency'] = m.frequency;
    if (m.updateType !== undefined)
        o['updateType'] = m.updateType;
    return o;
}
export function updateSubscriptionTierRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        tierId: (_b = o['tierId']) !== null && _b !== void 0 ? _b : '',
        frequency: (_c = o['frequency']) !== null && _c !== void 0 ? _c : 'BILLING_FREQUENCY_INVALID',
        updateType: (_d = o['updateType']) !== null && _d !== void 0 ? _d : 'SUBSCRIPTION_TIER_UPDATE_TYPE_INVALID',
    };
}
export function getUpdateSubscriptionTierStatusRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getUpdateSubscriptionTierStatusRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getUpdateSubscriptionTierStatusResponseToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.modified !== undefined)
        o['modified'] = m.modified.toISOString();
    return o;
}
export function getUpdateSubscriptionTierStatusResponseFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'UPDATE_SUBSCRIPTION_TIER_STATUS_INVALID',
        reason: (_c = o['reason']) !== null && _c !== void 0 ? _c : '',
        modified: o['modified'] ? new Date(o['modified']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function initiateSubscriptionTierUpdateRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.tierId !== undefined)
        o['tierId'] = m.tierId;
    return o;
}
export function initiateSubscriptionTierUpdateRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        tierId: (_b = o['tierId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getPartnerLeadStatsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.dateRange !== undefined)
        o['dateRange'] = dateRangeToJson(m.dateRange);
    return o;
}
export function getPartnerLeadStatsRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        dateRange: o['dateRange'] ? dateRangeFromJson(o['dateRange']) : undefined,
    };
}
export function getPartnerLeadStatsResponseToJson(m) {
    const o = {};
    if (m.leadsCount !== undefined)
        o['leadsCount'] = m.leadsCount;
    return o;
}
export function getPartnerLeadStatsResponseFromJson(o) {
    var _a;
    return {
        leadsCount: (_a = o['leadsCount']) !== null && _a !== void 0 ? _a : 0,
    };
}
export function partnerAccessToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketIds !== undefined) {
        o['marketIds'] = m.marketIds.map(e => e);
    }
    return o;
}
export function partnerAccessFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketIds: ((_b = o['marketIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function selectionCriteriaToJson(m) {
    const o = {};
    if (m.subscriptionTierIds !== undefined) {
        o['subscriptionTierIds'] = m.subscriptionTierIds.map(e => e);
    }
    if (m.partnerCreatedAfterDate !== undefined)
        o['partnerCreatedAfterDate'] = m.partnerCreatedAfterDate.toISOString();
    return o;
}
export function selectionCriteriaFromJson(o) {
    var _a;
    return {
        subscriptionTierIds: ((_a = o['subscriptionTierIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        partnerCreatedAfterDate: o['partnerCreatedAfterDate'] ? new Date(o['partnerCreatedAfterDate']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function experimentSettingToJson(m) {
    const o = {};
    if (m.variantRatio !== undefined)
        o['variantRatio'] = m.variantRatio;
    if (m.selectionCriteria !== undefined)
        o['selectionCriteria'] = selectionCriteriaToJson(m.selectionCriteria);
    if (m.metricsDashboardUrl !== undefined)
        o['metricsDashboardUrl'] = m.metricsDashboardUrl;
    return o;
}
export function experimentSettingFromJson(o) {
    var _a, _b;
    return {
        variantRatio: (_a = o['variantRatio']) !== null && _a !== void 0 ? _a : 0,
        selectionCriteria: o['selectionCriteria'] ? selectionCriteriaFromJson(o['selectionCriteria']) : undefined,
        metricsDashboardUrl: (_b = o['metricsDashboardUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function featureFlagToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.accessLevel !== undefined)
        o['accessLevel'] = m.accessLevel;
    if (m.accessLevelChangedDate !== undefined)
        o['accessLevelChangedDate'] = m.accessLevelChangedDate.toISOString();
    if (m.accessLevelChangedByEmail !== undefined)
        o['accessLevelChangedByEmail'] = m.accessLevelChangedByEmail;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.createdByEmail !== undefined)
        o['createdByEmail'] = m.createdByEmail;
    if (m.moreInfoUrl !== undefined)
        o['moreInfoUrl'] = m.moreInfoUrl;
    if (m.archived !== undefined)
        o['archived'] = m.archived;
    if (m.whitelist !== undefined) {
        o['whitelist'] = m.whitelist.map(e => partnerAccessToJson(e));
    }
    if (m.blacklist !== undefined) {
        o['blacklist'] = m.blacklist.map(e => partnerAccessToJson(e));
    }
    if (m.experimentSettings !== undefined)
        o['experimentSettings'] = experimentSettingToJson(m.experimentSettings);
    if (m.ownerName !== undefined)
        o['ownerName'] = m.ownerName;
    if (m.expiration !== undefined)
        o['expiration'] = m.expiration;
    if (m.expiryStart !== undefined)
        o['expiryStart'] = m.expiryStart.toISOString();
    if (m.expiryFinish !== undefined)
        o['expiryFinish'] = m.expiryFinish.toISOString();
    if (m.isExpired !== undefined)
        o['isExpired'] = m.isExpired;
    return o;
}
export function featureFlagFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        accessLevel: (_d = o['accessLevel']) !== null && _d !== void 0 ? _d : 'ACCESS_LEVEL_ALPHA',
        accessLevelChangedDate: o['accessLevelChangedDate'] ? new Date(o['accessLevelChangedDate']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        accessLevelChangedByEmail: (_e = o['accessLevelChangedByEmail']) !== null && _e !== void 0 ? _e : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        createdByEmail: (_f = o['createdByEmail']) !== null && _f !== void 0 ? _f : '',
        moreInfoUrl: (_g = o['moreInfoUrl']) !== null && _g !== void 0 ? _g : '',
        archived: (_h = o['archived']) !== null && _h !== void 0 ? _h : false,
        whitelist: ((_j = o['whitelist']) !== null && _j !== void 0 ? _j : []).map(e => partnerAccessFromJson(e)),
        blacklist: ((_k = o['blacklist']) !== null && _k !== void 0 ? _k : []).map(e => partnerAccessFromJson(e)),
        experimentSettings: o['experimentSettings'] ? experimentSettingFromJson(o['experimentSettings']) : undefined,
        ownerName: (_l = o['ownerName']) !== null && _l !== void 0 ? _l : '',
        expiration: (_m = o['expiration']) !== null && _m !== void 0 ? _m : 'EXPIRATION_INVALID',
        expiryStart: o['expiryStart'] ? new Date(o['expiryStart']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        expiryFinish: o['expiryFinish'] ? new Date(o['expiryFinish']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        isExpired: (_o = o['isExpired']) !== null && _o !== void 0 ? _o : false,
    };
}
export function reportAccessToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.idType !== undefined)
        o['idType'] = m.idType;
    if (m.scope !== undefined)
        o['scope'] = m.scope;
    return o;
}
export function reportAccessFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        idType: (_b = o['idType']) !== null && _b !== void 0 ? _b : 'REPORT_ACCESS_ID_TYPE_UNSET',
        scope: (_c = o['scope']) !== null && _c !== void 0 ? _c : 'REPORT_ACCESS_SCOPE_UNSET',
    };
}
export function partnerAdminPermissionsToJson(m) {
    const o = {};
    if (m.canAccessBilling !== undefined)
        o['canAccessBilling'] = m.canAccessBilling;
    if (m.canAccessRetailBilling !== undefined)
        o['canAccessRetailBilling'] = m.canAccessRetailBilling;
    if (m.canAccessAccounts !== undefined)
        o['canAccessAccounts'] = m.canAccessAccounts;
    if (m.canAccessMarketing !== undefined)
        o['canAccessMarketing'] = m.canAccessMarketing;
    if (m.canAccessSales !== undefined)
        o['canAccessSales'] = m.canAccessSales;
    if (m.canAccessConcierge !== undefined)
        o['canAccessConcierge'] = m.canAccessConcierge;
    if (m.canAccessBrands !== undefined)
        o['canAccessBrands'] = m.canAccessBrands;
    if (m.canAccessDashboard !== undefined)
        o['canAccessDashboard'] = m.canAccessDashboard;
    if (m.canAccessOrders !== undefined)
        o['canAccessOrders'] = m.canAccessOrders;
    if (m.canAccessMarketplace !== undefined)
        o['canAccessMarketplace'] = m.canAccessMarketplace;
    if (m.canAccessCompanyProfile !== undefined)
        o['canAccessCompanyProfile'] = m.canAccessCompanyProfile;
    if (m.canAccessAutomations !== undefined)
        o['canAccessAutomations'] = m.canAccessAutomations;
    if (m.defaultReportAccessScope !== undefined)
        o['defaultReportAccessScope'] = m.defaultReportAccessScope;
    if (m.reportAccess !== undefined) {
        o['reportAccess'] = m.reportAccess.map(e => reportAccessToJson(e));
    }
    return o;
}
export function partnerAdminPermissionsFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        canAccessBilling: (_a = o['canAccessBilling']) !== null && _a !== void 0 ? _a : false,
        canAccessRetailBilling: (_b = o['canAccessRetailBilling']) !== null && _b !== void 0 ? _b : false,
        canAccessAccounts: (_c = o['canAccessAccounts']) !== null && _c !== void 0 ? _c : false,
        canAccessMarketing: (_d = o['canAccessMarketing']) !== null && _d !== void 0 ? _d : false,
        canAccessSales: (_e = o['canAccessSales']) !== null && _e !== void 0 ? _e : false,
        canAccessConcierge: (_f = o['canAccessConcierge']) !== null && _f !== void 0 ? _f : false,
        canAccessBrands: (_g = o['canAccessBrands']) !== null && _g !== void 0 ? _g : false,
        canAccessDashboard: (_h = o['canAccessDashboard']) !== null && _h !== void 0 ? _h : false,
        canAccessOrders: (_j = o['canAccessOrders']) !== null && _j !== void 0 ? _j : false,
        canAccessMarketplace: (_k = o['canAccessMarketplace']) !== null && _k !== void 0 ? _k : false,
        canAccessCompanyProfile: (_l = o['canAccessCompanyProfile']) !== null && _l !== void 0 ? _l : false,
        canAccessAutomations: (_m = o['canAccessAutomations']) !== null && _m !== void 0 ? _m : false,
        defaultReportAccessScope: (_o = o['defaultReportAccessScope']) !== null && _o !== void 0 ? _o : 'REPORT_ACCESS_SCOPE_UNSET',
        reportAccess: ((_p = o['reportAccess']) !== null && _p !== void 0 ? _p : []).map(e => reportAccessFromJson(e)),
    };
}
export function partnerHealthToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.subState !== undefined)
        o['subState'] = m.subState;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.changedOn !== undefined)
        o['changedOn'] = m.changedOn.toISOString();
    if (m.changedBy !== undefined)
        o['changedBy'] = m.changedBy;
    if (m.inRetention !== undefined)
        o['inRetention'] = m.inRetention;
    return o;
}
export function partnerHealthFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        state: (_b = o['state']) !== null && _b !== void 0 ? _b : 'PARTNER_HEALTH_STATE_HEALTHY',
        subState: (_c = o['subState']) !== null && _c !== void 0 ? _c : 'PARTNER_HEALTH_SUB_STATE_UNSPECIFIED',
        reason: (_d = o['reason']) !== null && _d !== void 0 ? _d : '',
        changedOn: o['changedOn'] ? new Date(o['changedOn']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        changedBy: (_e = o['changedBy']) !== null && _e !== void 0 ? _e : '',
        inRetention: (_f = o['inRetention']) !== null && _f !== void 0 ? _f : false,
    };
}
export function partnerUserToJson(m) {
    const o = {};
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    if (m.email !== undefined)
        o['email'] = m.email;
    return o;
}
export function partnerUserFromJson(o) {
    var _a, _b, _c;
    return {
        firstName: (_a = o['firstName']) !== null && _a !== void 0 ? _a : '',
        lastName: (_b = o['lastName']) !== null && _b !== void 0 ? _b : '',
        email: (_c = o['email']) !== null && _c !== void 0 ? _c : '',
    };
}
export function partnerAcquisitionDataToJson(m) {
    const o = {};
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    if (m.origin !== undefined)
        o['origin'] = m.origin;
    if (m.visitorIdCookie !== undefined)
        o['visitorIdCookie'] = m.visitorIdCookie;
    if (m.conquerLocalAcademyVisitorId !== undefined)
        o['conquerLocalAcademyVisitorId'] = m.conquerLocalAcademyVisitorId;
    if (m.conversionPoint !== undefined)
        o['conversionPoint'] = m.conversionPoint;
    if (m.affiliateId !== undefined)
        o['affiliateId'] = m.affiliateId;
    if (m.numberOfEmployees !== undefined)
        o['numberOfEmployees'] = m.numberOfEmployees;
    if (m.referrerId !== undefined)
        o['referrerId'] = m.referrerId;
    if (m.clearbitCollectedSignupDataId !== undefined)
        o['clearbitCollectedSignupDataId'] = m.clearbitCollectedSignupDataId;
    if (m.useCase !== undefined)
        o['useCase'] = m.useCase;
    if (m.industry !== undefined)
        o['industry'] = m.industry;
    if (m.numberOfClients !== undefined)
        o['numberOfClients'] = m.numberOfClients;
    if (m.lastPageVisited !== undefined)
        o['lastPageVisited'] = m.lastPageVisited;
    return o;
}
export function partnerAcquisitionDataFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        tags: ((_a = o['tags']) !== null && _a !== void 0 ? _a : []).map(e => e),
        origin: (_b = o['origin']) !== null && _b !== void 0 ? _b : 'PARTNER_ORIGIN_INVALID',
        visitorIdCookie: (_c = o['visitorIdCookie']) !== null && _c !== void 0 ? _c : '',
        conquerLocalAcademyVisitorId: (_d = o['conquerLocalAcademyVisitorId']) !== null && _d !== void 0 ? _d : '',
        conversionPoint: (_e = o['conversionPoint']) !== null && _e !== void 0 ? _e : '',
        affiliateId: (_f = o['affiliateId']) !== null && _f !== void 0 ? _f : '',
        numberOfEmployees: (_g = o['numberOfEmployees']) !== null && _g !== void 0 ? _g : '',
        referrerId: (_h = o['referrerId']) !== null && _h !== void 0 ? _h : '',
        clearbitCollectedSignupDataId: (_j = o['clearbitCollectedSignupDataId']) !== null && _j !== void 0 ? _j : '',
        useCase: (_k = o['useCase']) !== null && _k !== void 0 ? _k : '',
        industry: (_l = o['industry']) !== null && _l !== void 0 ? _l : '',
        numberOfClients: (_m = o['numberOfClients']) !== null && _m !== void 0 ? _m : '',
        lastPageVisited: (_o = o['lastPageVisited']) !== null && _o !== void 0 ? _o : '',
    };
}
export function companyProfileToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.address !== undefined)
        o['address'] = m.address;
    if (m.address2 !== undefined)
        o['address2'] = m.address2;
    if (m.city !== undefined)
        o['city'] = m.city;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.country !== undefined)
        o['country'] = m.country;
    if (m.postalCode !== undefined)
        o['postalCode'] = m.postalCode;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.websiteAddress !== undefined)
        o['websiteAddress'] = m.websiteAddress;
    if (m.emailAddress !== undefined)
        o['emailAddress'] = m.emailAddress;
    if (m.crmCompanyId !== undefined)
        o['crmCompanyId'] = m.crmCompanyId;
    return o;
}
export function companyProfileFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        address: (_b = o['address']) !== null && _b !== void 0 ? _b : '',
        address2: (_c = o['address2']) !== null && _c !== void 0 ? _c : '',
        city: (_d = o['city']) !== null && _d !== void 0 ? _d : '',
        state: (_e = o['state']) !== null && _e !== void 0 ? _e : '',
        country: (_f = o['country']) !== null && _f !== void 0 ? _f : '',
        postalCode: (_g = o['postalCode']) !== null && _g !== void 0 ? _g : '',
        phoneNumber: (_h = o['phoneNumber']) !== null && _h !== void 0 ? _h : '',
        websiteAddress: (_j = o['websiteAddress']) !== null && _j !== void 0 ? _j : '',
        emailAddress: (_k = o['emailAddress']) !== null && _k !== void 0 ? _k : '',
        crmCompanyId: (_l = o['crmCompanyId']) !== null && _l !== void 0 ? _l : '',
    };
}
export function termOfServiceToJson(m) {
    const o = {};
    if (m.accepted !== undefined)
        o['accepted'] = m.accepted;
    if (m.browserIpAddress !== undefined)
        o['browserIpAddress'] = m.browserIpAddress;
    return o;
}
export function termOfServiceFromJson(o) {
    var _a, _b;
    return {
        accepted: (_a = o['accepted']) !== null && _a !== void 0 ? _a : false,
        browserIpAddress: (_b = o['browserIpAddress']) !== null && _b !== void 0 ? _b : '',
    };
}
export function createPartnerRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.companyProfile !== undefined)
        o['companyProfile'] = companyProfileToJson(m.companyProfile);
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.initialUser !== undefined)
        o['initialUser'] = partnerUserToJson(m.initialUser);
    if (m.billingCurrencyCode !== undefined)
        o['billingCurrencyCode'] = m.billingCurrencyCode;
    if (m.termsOfService !== undefined)
        o['termsOfService'] = termOfServiceToJson(m.termsOfService);
    if (m.startOnTutorialCampaign !== undefined)
        o['startOnTutorialCampaign'] = m.startOnTutorialCampaign;
    if (m.acquisitionData !== undefined)
        o['acquisitionData'] = partnerAcquisitionDataToJson(m.acquisitionData);
    if (m.subdomain !== undefined)
        o['subdomain'] = m.subdomain;
    if (m.subscriptionTierId !== undefined)
        o['subscriptionTierId'] = m.subscriptionTierId;
    if (m.stripeToken !== undefined)
        o['stripeToken'] = m.stripeToken;
    return o;
}
export function createPartnerRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        companyProfile: o['companyProfile'] ? companyProfileFromJson(o['companyProfile']) : undefined,
        accountGroupId: (_c = o['accountGroupId']) !== null && _c !== void 0 ? _c : '',
        initialUser: o['initialUser'] ? partnerUserFromJson(o['initialUser']) : undefined,
        billingCurrencyCode: (_d = o['billingCurrencyCode']) !== null && _d !== void 0 ? _d : '',
        termsOfService: o['termsOfService'] ? termOfServiceFromJson(o['termsOfService']) : undefined,
        startOnTutorialCampaign: (_e = o['startOnTutorialCampaign']) !== null && _e !== void 0 ? _e : false,
        acquisitionData: o['acquisitionData'] ? partnerAcquisitionDataFromJson(o['acquisitionData']) : undefined,
        subdomain: (_f = o['subdomain']) !== null && _f !== void 0 ? _f : '',
        subscriptionTierId: (_g = o['subscriptionTierId']) !== null && _g !== void 0 ? _g : '',
        stripeToken: (_h = o['stripeToken']) !== null && _h !== void 0 ? _h : '',
    };
}
export function getCreatePartnerStatusRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    return o;
}
export function getCreatePartnerStatusRequestFromJson(o) {
    var _a;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getCreatePartnerStatusResponseToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function getCreatePartnerStatusResponseFromJson(o) {
    var _a, _b, _c;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'STATUS_INVALID',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getUpdatePartnerStatusRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    return o;
}
export function getUpdatePartnerStatusRequestFromJson(o) {
    var _a;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getUpdatePartnerStatusResponseToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function getUpdatePartnerStatusResponseFromJson(o) {
    var _a, _b;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'STATUS_INVALID',
        errorMessage: (_b = o['errorMessage']) !== null && _b !== void 0 ? _b : '',
    };
}
export function updateCompanyProfileRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.companyProfileInfo !== undefined)
        o['companyProfileInfo'] = companyProfileToJson(m.companyProfileInfo);
    return o;
}
export function updateCompanyProfileRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        companyProfileInfo: o['companyProfileInfo'] ? companyProfileFromJson(o['companyProfileInfo']) : undefined,
    };
}
export function partnerInfoToJson(m) {
    const o = {};
    if (m.partnerName !== undefined)
        o['partnerName'] = m.partnerName;
    if (m.partnerApiKey !== undefined)
        o['partnerApiKey'] = m.partnerApiKey;
    if (m.partnerType !== undefined)
        o['partnerType'] = m.partnerType;
    if (m.serviceLevel !== undefined)
        o['serviceLevel'] = m.serviceLevel;
    if (m.accountExecutive !== undefined)
        o['accountExecutive'] = m.accountExecutive;
    if (m.stripeBillingFlag !== undefined)
        o['stripeBillingFlag'] = m.stripeBillingFlag;
    if (m.excludeFromKpisFlag !== undefined)
        o['excludeFromKpisFlag'] = m.excludeFromKpisFlag;
    if (m.vbcFlag !== undefined)
        o['vbcFlag'] = m.vbcFlag;
    if (m.campaignSubscriptionEnabledFlag !== undefined)
        o['campaignSubscriptionEnabledFlag'] = m.campaignSubscriptionEnabledFlag;
    if (m.vbcKey !== undefined)
        o['vbcKey'] = m.vbcKey;
    if (m.rmPid !== undefined)
        o['rmPid'] = m.rmPid;
    if (m.rmKey !== undefined)
        o['rmKey'] = m.rmKey;
    if (m.msPid !== undefined)
        o['msPid'] = m.msPid;
    if (m.msKey !== undefined)
        o['msKey'] = m.msKey;
    if (m.smPid !== undefined)
        o['smPid'] = m.smPid;
    if (m.smKey !== undefined)
        o['smKey'] = m.smKey;
    if (m.nbPid !== undefined)
        o['nbPid'] = m.nbPid;
    if (m.nbKey !== undefined)
        o['nbKey'] = m.nbKey;
    if (m.armPid !== undefined)
        o['armPid'] = m.armPid;
    if (m.armKey !== undefined)
        o['armKey'] = m.armKey;
    if (m.enableProductMarketplaceFlag !== undefined)
        o['enableProductMarketplaceFlag'] = m.enableProductMarketplaceFlag;
    if (m.hidePricingFlag !== undefined)
        o['hidePricingFlag'] = m.hidePricingFlag;
    if (m.stDefaultCampaignId !== undefined)
        o['stDefaultCampaignId'] = m.stDefaultCampaignId;
    if (m.oauthKey !== undefined)
        o['oauthKey'] = m.oauthKey;
    if (m.oauthSecret !== undefined)
        o['oauthSecret'] = m.oauthSecret;
    if (m.rmMaxCompetitors !== undefined)
        o['rmMaxCompetitors'] = m.rmMaxCompetitors;
    if (m.rmMaxServices !== undefined)
        o['rmMaxServices'] = m.rmMaxServices;
    if (m.enableListingDistributionFlag !== undefined)
        o['enableListingDistributionFlag'] = m.enableListingDistributionFlag;
    if (m.showExpiryFlag !== undefined)
        o['showExpiryFlag'] = m.showExpiryFlag;
    if (m.wholesalePrice !== undefined)
        o['wholesalePrice'] = m.wholesalePrice;
    if (m.enableForAdminFlag !== undefined)
        o['enableForAdminFlag'] = m.enableForAdminFlag;
    if (m.enableListingSyncProFlag !== undefined)
        o['enableListingSyncProFlag'] = m.enableListingSyncProFlag;
    if (m.listingSyncProServiceProvider !== undefined)
        o['listingSyncProServiceProvider'] = m.listingSyncProServiceProvider;
    if (m.enableListingSyncProDiscountFlag !== undefined)
        o['enableListingSyncProDiscountFlag'] = m.enableListingSyncProDiscountFlag;
    if (m.pausedFlag !== undefined)
        o['pausedFlag'] = m.pausedFlag;
    if (m.cancelledFlag !== undefined)
        o['cancelledFlag'] = m.cancelledFlag;
    if (m.premiumSupportFlag !== undefined)
        o['premiumSupportFlag'] = m.premiumSupportFlag;
    if (m.standardPrioritySupportFlag !== undefined)
        o['standardPrioritySupportFlag'] = m.standardPrioritySupportFlag;
    if (m.priorityChatSupportFlag !== undefined)
        o['priorityChatSupportFlag'] = m.priorityChatSupportFlag;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    return o;
}
export function partnerInfoFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
    return {
        partnerName: (_a = o['partnerName']) !== null && _a !== void 0 ? _a : '',
        partnerApiKey: (_b = o['partnerApiKey']) !== null && _b !== void 0 ? _b : '',
        partnerType: (_c = o['partnerType']) !== null && _c !== void 0 ? _c : '',
        serviceLevel: (_d = o['serviceLevel']) !== null && _d !== void 0 ? _d : '',
        accountExecutive: (_e = o['accountExecutive']) !== null && _e !== void 0 ? _e : '',
        stripeBillingFlag: (_f = o['stripeBillingFlag']) !== null && _f !== void 0 ? _f : false,
        excludeFromKpisFlag: (_g = o['excludeFromKpisFlag']) !== null && _g !== void 0 ? _g : false,
        vbcFlag: (_h = o['vbcFlag']) !== null && _h !== void 0 ? _h : false,
        campaignSubscriptionEnabledFlag: (_j = o['campaignSubscriptionEnabledFlag']) !== null && _j !== void 0 ? _j : false,
        vbcKey: (_k = o['vbcKey']) !== null && _k !== void 0 ? _k : '',
        rmPid: (_l = o['rmPid']) !== null && _l !== void 0 ? _l : '',
        rmKey: (_m = o['rmKey']) !== null && _m !== void 0 ? _m : '',
        msPid: (_o = o['msPid']) !== null && _o !== void 0 ? _o : '',
        msKey: (_p = o['msKey']) !== null && _p !== void 0 ? _p : '',
        smPid: (_q = o['smPid']) !== null && _q !== void 0 ? _q : '',
        smKey: (_r = o['smKey']) !== null && _r !== void 0 ? _r : '',
        nbPid: (_s = o['nbPid']) !== null && _s !== void 0 ? _s : '',
        nbKey: (_t = o['nbKey']) !== null && _t !== void 0 ? _t : '',
        armPid: (_u = o['armPid']) !== null && _u !== void 0 ? _u : '',
        armKey: (_v = o['armKey']) !== null && _v !== void 0 ? _v : '',
        enableProductMarketplaceFlag: (_w = o['enableProductMarketplaceFlag']) !== null && _w !== void 0 ? _w : false,
        hidePricingFlag: (_x = o['hidePricingFlag']) !== null && _x !== void 0 ? _x : false,
        stDefaultCampaignId: (_y = o['stDefaultCampaignId']) !== null && _y !== void 0 ? _y : '',
        oauthKey: (_z = o['oauthKey']) !== null && _z !== void 0 ? _z : '',
        oauthSecret: (_0 = o['oauthSecret']) !== null && _0 !== void 0 ? _0 : '',
        rmMaxCompetitors: (_1 = o['rmMaxCompetitors']) !== null && _1 !== void 0 ? _1 : 0,
        rmMaxServices: (_2 = o['rmMaxServices']) !== null && _2 !== void 0 ? _2 : 0,
        enableListingDistributionFlag: (_3 = o['enableListingDistributionFlag']) !== null && _3 !== void 0 ? _3 : false,
        showExpiryFlag: (_4 = o['showExpiryFlag']) !== null && _4 !== void 0 ? _4 : false,
        wholesalePrice: (_5 = o['wholesalePrice']) !== null && _5 !== void 0 ? _5 : 0,
        enableForAdminFlag: (_6 = o['enableForAdminFlag']) !== null && _6 !== void 0 ? _6 : false,
        enableListingSyncProFlag: (_7 = o['enableListingSyncProFlag']) !== null && _7 !== void 0 ? _7 : false,
        listingSyncProServiceProvider: (_8 = o['listingSyncProServiceProvider']) !== null && _8 !== void 0 ? _8 : '',
        enableListingSyncProDiscountFlag: (_9 = o['enableListingSyncProDiscountFlag']) !== null && _9 !== void 0 ? _9 : false,
        pausedFlag: (_10 = o['pausedFlag']) !== null && _10 !== void 0 ? _10 : false,
        cancelledFlag: (_11 = o['cancelledFlag']) !== null && _11 !== void 0 ? _11 : false,
        premiumSupportFlag: (_12 = o['premiumSupportFlag']) !== null && _12 !== void 0 ? _12 : 'SUPPORT_FLAG_INVALID',
        standardPrioritySupportFlag: (_13 = o['standardPrioritySupportFlag']) !== null && _13 !== void 0 ? _13 : 'SUPPORT_FLAG_INVALID',
        priorityChatSupportFlag: (_14 = o['priorityChatSupportFlag']) !== null && _14 !== void 0 ? _14 : 'SUPPORT_FLAG_INVALID',
        tags: ((_15 = o['tags']) !== null && _15 !== void 0 ? _15 : []).map(e => e),
    };
}
export function updatePartnerRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.partnerInfo !== undefined)
        o['partnerInfo'] = partnerInfoToJson(m.partnerInfo);
    return o;
}
export function updatePartnerRequestFromJson(o) {
    var _a, _b;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        partnerInfo: o['partnerInfo'] ? partnerInfoFromJson(o['partnerInfo']) : undefined,
    };
}
export function deletePartnerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function deletePartnerRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getSignUpAddPaymentCardResultRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getSignUpAddPaymentCardResultRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getSignUpAddPaymentCardResultResponseToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.error !== undefined)
        o['error'] = m.error;
    return o;
}
export function getSignUpAddPaymentCardResultResponseFromJson(o) {
    var _a, _b;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'GET_SIGN_UP_ADD_PAYMENT_CARD_RESULT_RESPONSE_STATUS_INVALID',
        error: (_b = o['error']) !== null && _b !== void 0 ? _b : '',
    };
}
export function isEmailInUseRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.visitorId !== undefined)
        o['visitorId'] = m.visitorId;
    if (m.recaptchaToken !== undefined) {
        if (m.recaptchaToken.type === 'recaptchaV2Token') {
            o['recaptchaV2Token'] = m.recaptchaToken.recaptchaV2Token;
        }
        if (m.recaptchaToken.type === 'recaptchaV3Token') {
            o['recaptchaV3Token'] = m.recaptchaToken.recaptchaV3Token;
        }
    }
    else {
        if (m.recaptchaV2Token !== undefined)
            o['recaptchaV2Token'] = m.recaptchaV2Token;
        if (m.recaptchaV3Token !== undefined)
            o['recaptchaV3Token'] = m.recaptchaV3Token;
    }
    return o;
}
export function isEmailInUseRequestFromJson(o) {
    var _a, _b;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
        visitorId: (_b = o['visitorId']) !== null && _b !== void 0 ? _b : '',
        recaptchaToken: (() => {
            if (o['recaptchaV2Token'] !== undefined)
                return { type: 'recaptchaV2Token', recaptchaV2Token: o['recaptchaV2Token'] };
            if (o['recaptchaV3Token'] !== undefined)
                return { type: 'recaptchaV3Token', recaptchaV3Token: o['recaptchaV3Token'] };
            return undefined;
        })(),
        recaptchaV2Token: o['recaptchaV2Token'] !== undefined ? o['recaptchaV2Token'] : undefined,
        recaptchaV3Token: o['recaptchaV3Token'] !== undefined ? o['recaptchaV3Token'] : undefined,
    };
}
export function isEmailInUseResponseToJson(m) {
    const o = {};
    if (m.subjects !== undefined) {
        o['subjects'] = m.subjects.map(e => e);
    }
    return o;
}
export function isEmailInUseResponseFromJson(o) {
    var _a;
    return {
        subjects: ((_a = o['subjects']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function isEmailDisposableRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.recaptchaToken !== undefined) {
        if (m.recaptchaToken.type === 'recaptchaV2Token') {
            o['recaptchaV2Token'] = m.recaptchaToken.recaptchaV2Token;
        }
        if (m.recaptchaToken.type === 'recaptchaV3Token') {
            o['recaptchaV3Token'] = m.recaptchaToken.recaptchaV3Token;
        }
    }
    else {
        if (m.recaptchaV2Token !== undefined)
            o['recaptchaV2Token'] = m.recaptchaV2Token;
        if (m.recaptchaV3Token !== undefined)
            o['recaptchaV3Token'] = m.recaptchaV3Token;
    }
    return o;
}
export function isEmailDisposableRequestFromJson(o) {
    var _a;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
        recaptchaToken: (() => {
            if (o['recaptchaV2Token'] !== undefined)
                return { type: 'recaptchaV2Token', recaptchaV2Token: o['recaptchaV2Token'] };
            if (o['recaptchaV3Token'] !== undefined)
                return { type: 'recaptchaV3Token', recaptchaV3Token: o['recaptchaV3Token'] };
            return undefined;
        })(),
        recaptchaV2Token: o['recaptchaV2Token'] !== undefined ? o['recaptchaV2Token'] : undefined,
        recaptchaV3Token: o['recaptchaV3Token'] !== undefined ? o['recaptchaV3Token'] : undefined,
    };
}
export function isEmailDisposableResponseToJson(m) {
    const o = {};
    if (m.isDisposable !== undefined)
        o['isDisposable'] = m.isDisposable;
    return o;
}
export function isEmailDisposableResponseFromJson(o) {
    var _a;
    return {
        isDisposable: (_a = o['isDisposable']) !== null && _a !== void 0 ? _a : false,
    };
}
export function selfSignUpRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    if (m.initialUser !== undefined)
        o['initialUser'] = partnerUserToJson(m.initialUser);
    if (m.websiteOptOutFlag !== undefined)
        o['websiteOptOutFlag'] = m.websiteOptOutFlag;
    if (m.billingCurrencyCode !== undefined)
        o['billingCurrencyCode'] = m.billingCurrencyCode;
    if (m.companyProfile !== undefined)
        o['companyProfile'] = companyProfileToJson(m.companyProfile);
    if (m.acquisitionData !== undefined)
        o['acquisitionData'] = partnerAcquisitionDataToJson(m.acquisitionData);
    if (m.termsOfService !== undefined)
        o['termsOfService'] = termOfServiceToJson(m.termsOfService);
    if (m.userPassword !== undefined)
        o['userPassword'] = m.userPassword;
    if (m.recaptchaToken !== undefined) {
        if (m.recaptchaToken.type === 'recaptchaResponse') {
            o['recaptchaResponse'] = m.recaptchaToken.recaptchaResponse;
        }
        if (m.recaptchaToken.type === 'recaptchaV3Token') {
            o['recaptchaV3Token'] = m.recaptchaToken.recaptchaV3Token;
        }
    }
    else {
        if (m.recaptchaResponse !== undefined)
            o['recaptchaResponse'] = m.recaptchaResponse;
        if (m.recaptchaV3Token !== undefined)
            o['recaptchaV3Token'] = m.recaptchaV3Token;
    }
    return o;
}
export function selfSignUpRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
        initialUser: o['initialUser'] ? partnerUserFromJson(o['initialUser']) : undefined,
        websiteOptOutFlag: (_b = o['websiteOptOutFlag']) !== null && _b !== void 0 ? _b : false,
        billingCurrencyCode: (_c = o['billingCurrencyCode']) !== null && _c !== void 0 ? _c : '',
        companyProfile: o['companyProfile'] ? companyProfileFromJson(o['companyProfile']) : undefined,
        acquisitionData: o['acquisitionData'] ? partnerAcquisitionDataFromJson(o['acquisitionData']) : undefined,
        termsOfService: o['termsOfService'] ? termOfServiceFromJson(o['termsOfService']) : undefined,
        userPassword: (_d = o['userPassword']) !== null && _d !== void 0 ? _d : '',
        recaptchaToken: (() => {
            if (o['recaptchaResponse'] !== undefined)
                return { type: 'recaptchaResponse', recaptchaResponse: o['recaptchaResponse'] };
            if (o['recaptchaV3Token'] !== undefined)
                return { type: 'recaptchaV3Token', recaptchaV3Token: o['recaptchaV3Token'] };
            return undefined;
        })(),
        recaptchaResponse: o['recaptchaResponse'] !== undefined ? o['recaptchaResponse'] : undefined,
        recaptchaV3Token: o['recaptchaV3Token'] !== undefined ? o['recaptchaV3Token'] : undefined,
    };
}
export function selfSignUpWithGoogleRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    if (m.googleToken !== undefined)
        o['googleToken'] = m.googleToken;
    if (m.acquisitionData !== undefined)
        o['acquisitionData'] = partnerAcquisitionDataToJson(m.acquisitionData);
    if (m.companyProfile !== undefined)
        o['companyProfile'] = companyProfileToJson(m.companyProfile);
    if (m.websiteOptOutFlag !== undefined)
        o['websiteOptOutFlag'] = m.websiteOptOutFlag;
    if (m.billingCurrencyCode !== undefined)
        o['billingCurrencyCode'] = m.billingCurrencyCode;
    if (m.termsOfService !== undefined)
        o['termsOfService'] = termOfServiceToJson(m.termsOfService);
    if (m.recaptchaToken !== undefined) {
        if (m.recaptchaToken.type === 'recaptchaResponse') {
            o['recaptchaResponse'] = m.recaptchaToken.recaptchaResponse;
        }
        if (m.recaptchaToken.type === 'recaptchaV3Token') {
            o['recaptchaV3Token'] = m.recaptchaToken.recaptchaV3Token;
        }
    }
    else {
        if (m.recaptchaResponse !== undefined)
            o['recaptchaResponse'] = m.recaptchaResponse;
        if (m.recaptchaV3Token !== undefined)
            o['recaptchaV3Token'] = m.recaptchaV3Token;
    }
    return o;
}
export function selfSignUpWithGoogleRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
        googleToken: (_b = o['googleToken']) !== null && _b !== void 0 ? _b : '',
        acquisitionData: o['acquisitionData'] ? partnerAcquisitionDataFromJson(o['acquisitionData']) : undefined,
        companyProfile: o['companyProfile'] ? companyProfileFromJson(o['companyProfile']) : undefined,
        websiteOptOutFlag: (_c = o['websiteOptOutFlag']) !== null && _c !== void 0 ? _c : false,
        billingCurrencyCode: (_d = o['billingCurrencyCode']) !== null && _d !== void 0 ? _d : '',
        termsOfService: o['termsOfService'] ? termOfServiceFromJson(o['termsOfService']) : undefined,
        recaptchaToken: (() => {
            if (o['recaptchaResponse'] !== undefined)
                return { type: 'recaptchaResponse', recaptchaResponse: o['recaptchaResponse'] };
            if (o['recaptchaV3Token'] !== undefined)
                return { type: 'recaptchaV3Token', recaptchaV3Token: o['recaptchaV3Token'] };
            return undefined;
        })(),
        recaptchaResponse: o['recaptchaResponse'] !== undefined ? o['recaptchaResponse'] : undefined,
        recaptchaV3Token: o['recaptchaV3Token'] !== undefined ? o['recaptchaV3Token'] : undefined,
    };
}
export function selfSignUpWithLinkedRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    if (m.linkedinToken !== undefined)
        o['linkedinToken'] = m.linkedinToken;
    if (m.acquisitionData !== undefined)
        o['acquisitionData'] = partnerAcquisitionDataToJson(m.acquisitionData);
    if (m.companyProfile !== undefined)
        o['companyProfile'] = companyProfileToJson(m.companyProfile);
    if (m.websiteOptOutFlag !== undefined)
        o['websiteOptOutFlag'] = m.websiteOptOutFlag;
    if (m.billingCurrencyCode !== undefined)
        o['billingCurrencyCode'] = m.billingCurrencyCode;
    if (m.termsOfService !== undefined)
        o['termsOfService'] = termOfServiceToJson(m.termsOfService);
    if (m.recaptchaToken !== undefined) {
        if (m.recaptchaToken.type === 'recaptchaResponse') {
            o['recaptchaResponse'] = m.recaptchaToken.recaptchaResponse;
        }
        if (m.recaptchaToken.type === 'recaptchaV3Token') {
            o['recaptchaV3Token'] = m.recaptchaToken.recaptchaV3Token;
        }
    }
    else {
        if (m.recaptchaResponse !== undefined)
            o['recaptchaResponse'] = m.recaptchaResponse;
        if (m.recaptchaV3Token !== undefined)
            o['recaptchaV3Token'] = m.recaptchaV3Token;
    }
    return o;
}
export function selfSignUpWithLinkedRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
        linkedinToken: (_b = o['linkedinToken']) !== null && _b !== void 0 ? _b : '',
        acquisitionData: o['acquisitionData'] ? partnerAcquisitionDataFromJson(o['acquisitionData']) : undefined,
        companyProfile: o['companyProfile'] ? companyProfileFromJson(o['companyProfile']) : undefined,
        websiteOptOutFlag: (_c = o['websiteOptOutFlag']) !== null && _c !== void 0 ? _c : false,
        billingCurrencyCode: (_d = o['billingCurrencyCode']) !== null && _d !== void 0 ? _d : '',
        termsOfService: o['termsOfService'] ? termOfServiceFromJson(o['termsOfService']) : undefined,
        recaptchaToken: (() => {
            if (o['recaptchaResponse'] !== undefined)
                return { type: 'recaptchaResponse', recaptchaResponse: o['recaptchaResponse'] };
            if (o['recaptchaV3Token'] !== undefined)
                return { type: 'recaptchaV3Token', recaptchaV3Token: o['recaptchaV3Token'] };
            return undefined;
        })(),
        recaptchaResponse: o['recaptchaResponse'] !== undefined ? o['recaptchaResponse'] : undefined,
        recaptchaV3Token: o['recaptchaV3Token'] !== undefined ? o['recaptchaV3Token'] : undefined,
    };
}
export function getSelfSignUpStatusRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    return o;
}
export function getSelfSignUpStatusRequestFromJson(o) {
    var _a;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getSelfSignUpStatusResponseToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function getSelfSignUpStatusResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'STATUS_INVALID',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
        accountGroupId: (_d = o['accountGroupId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function userCredentialToJson(m) {
    const o = {};
    if (m.user !== undefined)
        o['user'] = partnerUserToJson(m.user);
    if (m.password !== undefined)
        o['password'] = m.password;
    return o;
}
export function userCredentialFromJson(o) {
    var _a;
    return {
        user: o['user'] ? partnerUserFromJson(o['user']) : undefined,
        password: (_a = o['password']) !== null && _a !== void 0 ? _a : '',
    };
}
export function emailPasswordCredentialToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.password !== undefined)
        o['password'] = m.password;
    return o;
}
export function emailPasswordCredentialFromJson(o) {
    var _a, _b;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
        password: (_b = o['password']) !== null && _b !== void 0 ? _b : '',
    };
}
export function googleTokenCredentialToJson(m) {
    const o = {};
    if (m.googleToken !== undefined)
        o['googleToken'] = m.googleToken;
    return o;
}
export function googleTokenCredentialFromJson(o) {
    var _a;
    return {
        googleToken: (_a = o['googleToken']) !== null && _a !== void 0 ? _a : '',
    };
}
export function linkedInTokenCredentialToJson(m) {
    const o = {};
    if (m.linkedinAccessToken !== undefined)
        o['linkedinAccessToken'] = m.linkedinAccessToken;
    return o;
}
export function linkedInTokenCredentialFromJson(o) {
    var _a;
    return {
        linkedinAccessToken: (_a = o['linkedinAccessToken']) !== null && _a !== void 0 ? _a : '',
    };
}
export function microsoftTokenCredentialToJson(m) {
    const o = {};
    if (m.microsoftIdToken !== undefined)
        o['microsoftIdToken'] = m.microsoftIdToken;
    return o;
}
export function microsoftTokenCredentialFromJson(o) {
    var _a;
    return {
        microsoftIdToken: (_a = o['microsoftIdToken']) !== null && _a !== void 0 ? _a : '',
    };
}
export function selfSignUpExistingAccountGroupRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    if (m.termsOfService !== undefined)
        o['termsOfService'] = termOfServiceToJson(m.termsOfService);
    if (m.acquisitionData !== undefined)
        o['acquisitionData'] = partnerAcquisitionDataToJson(m.acquisitionData);
    if (m.recaptchaToken !== undefined) {
        if (m.recaptchaToken.type === 'recaptchaResponse') {
            o['recaptchaResponse'] = m.recaptchaToken.recaptchaResponse;
        }
        if (m.recaptchaToken.type === 'recaptchaV3Token') {
            o['recaptchaV3Token'] = m.recaptchaToken.recaptchaV3Token;
        }
    }
    else {
        if (m.recaptchaResponse !== undefined)
            o['recaptchaResponse'] = m.recaptchaResponse;
        if (m.recaptchaV3Token !== undefined)
            o['recaptchaV3Token'] = m.recaptchaV3Token;
    }
    if (m.userCredential !== undefined) {
        if (m.userCredential.type === 'googleToken') {
            o['googleToken'] = googleTokenCredentialToJson(m.userCredential.googleToken);
        }
        if (m.userCredential.type === 'initialUser') {
            o['initialUser'] = emailPasswordCredentialToJson(m.userCredential.initialUser);
        }
    }
    else {
        if (m.googleToken !== undefined)
            o['googleToken'] = googleTokenCredentialToJson(m.googleToken);
        if (m.initialUser !== undefined)
            o['initialUser'] = emailPasswordCredentialToJson(m.initialUser);
    }
    return o;
}
export function selfSignUpExistingAccountGroupRequestFromJson(o) {
    var _a;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
        termsOfService: o['termsOfService'] ? termOfServiceFromJson(o['termsOfService']) : undefined,
        acquisitionData: o['acquisitionData'] ? partnerAcquisitionDataFromJson(o['acquisitionData']) : undefined,
        recaptchaToken: (() => {
            if (o['recaptchaResponse'] !== undefined)
                return { type: 'recaptchaResponse', recaptchaResponse: o['recaptchaResponse'] };
            if (o['recaptchaV3Token'] !== undefined)
                return { type: 'recaptchaV3Token', recaptchaV3Token: o['recaptchaV3Token'] };
            return undefined;
        })(),
        recaptchaResponse: o['recaptchaResponse'] !== undefined ? o['recaptchaResponse'] : undefined,
        recaptchaV3Token: o['recaptchaV3Token'] !== undefined ? o['recaptchaV3Token'] : undefined,
        userCredential: (() => {
            if (o['googleToken'] !== undefined)
                return { type: 'googleToken', googleToken: o['googleToken'] ? googleTokenCredentialFromJson(o['googleToken']) : undefined };
            if (o['initialUser'] !== undefined)
                return { type: 'initialUser', initialUser: o['initialUser'] ? emailPasswordCredentialFromJson(o['initialUser']) : undefined };
            return undefined;
        })(),
        googleToken: o['googleToken'] !== undefined ? o['googleToken'] ? googleTokenCredentialFromJson(o['googleToken']) : undefined : undefined,
        initialUser: o['initialUser'] !== undefined ? o['initialUser'] ? emailPasswordCredentialFromJson(o['initialUser']) : undefined : undefined,
    };
}
export function loginRequestToJson(m) {
    const o = {};
    if (m.nextUrl !== undefined)
        o['nextUrl'] = m.nextUrl;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.credential !== undefined) {
        if (m.credential.type === 'emailPasswordCredential') {
            o['emailPasswordCredential'] = emailPasswordCredentialToJson(m.credential.emailPasswordCredential);
        }
        if (m.credential.type === 'tokenCredential') {
            o['tokenCredential'] = googleTokenCredentialToJson(m.credential.tokenCredential);
        }
        if (m.credential.type === 'linkedinCredential') {
            o['linkedinCredential'] = linkedInTokenCredentialToJson(m.credential.linkedinCredential);
        }
        if (m.credential.type === 'microsoftCredential') {
            o['microsoftCredential'] = microsoftTokenCredentialToJson(m.credential.microsoftCredential);
        }
    }
    else {
        if (m.emailPasswordCredential !== undefined)
            o['emailPasswordCredential'] = emailPasswordCredentialToJson(m.emailPasswordCredential);
        if (m.tokenCredential !== undefined)
            o['tokenCredential'] = googleTokenCredentialToJson(m.tokenCredential);
        if (m.linkedinCredential !== undefined)
            o['linkedinCredential'] = linkedInTokenCredentialToJson(m.linkedinCredential);
        if (m.microsoftCredential !== undefined)
            o['microsoftCredential'] = microsoftTokenCredentialToJson(m.microsoftCredential);
    }
    return o;
}
export function loginRequestFromJson(o) {
    var _a, _b;
    return {
        nextUrl: (_a = o['nextUrl']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        credential: (() => {
            if (o['emailPasswordCredential'] !== undefined)
                return { type: 'emailPasswordCredential', emailPasswordCredential: o['emailPasswordCredential'] ? emailPasswordCredentialFromJson(o['emailPasswordCredential']) : undefined };
            if (o['tokenCredential'] !== undefined)
                return { type: 'tokenCredential', tokenCredential: o['tokenCredential'] ? googleTokenCredentialFromJson(o['tokenCredential']) : undefined };
            if (o['linkedinCredential'] !== undefined)
                return { type: 'linkedinCredential', linkedinCredential: o['linkedinCredential'] ? linkedInTokenCredentialFromJson(o['linkedinCredential']) : undefined };
            if (o['microsoftCredential'] !== undefined)
                return { type: 'microsoftCredential', microsoftCredential: o['microsoftCredential'] ? microsoftTokenCredentialFromJson(o['microsoftCredential']) : undefined };
            return undefined;
        })(),
        emailPasswordCredential: o['emailPasswordCredential'] !== undefined ? o['emailPasswordCredential'] ? emailPasswordCredentialFromJson(o['emailPasswordCredential']) : undefined : undefined,
        tokenCredential: o['tokenCredential'] !== undefined ? o['tokenCredential'] ? googleTokenCredentialFromJson(o['tokenCredential']) : undefined : undefined,
        linkedinCredential: o['linkedinCredential'] !== undefined ? o['linkedinCredential'] ? linkedInTokenCredentialFromJson(o['linkedinCredential']) : undefined : undefined,
        microsoftCredential: o['microsoftCredential'] !== undefined ? o['microsoftCredential'] ? microsoftTokenCredentialFromJson(o['microsoftCredential']) : undefined : undefined,
    };
}
export function loginResponseToJson(m) {
    const o = {};
    if (m.nextUrl !== undefined)
        o['nextUrl'] = m.nextUrl;
    return o;
}
export function loginResponseFromJson(o) {
    var _a;
    return {
        nextUrl: (_a = o['nextUrl']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getGoogleProfileRequestToJson(m) {
    const o = {};
    if (m.googleCode !== undefined)
        o['googleCode'] = m.googleCode;
    if (m.redirectUrl !== undefined)
        o['redirectUrl'] = m.redirectUrl;
    return o;
}
export function getGoogleProfileRequestFromJson(o) {
    var _a, _b;
    return {
        googleCode: (_a = o['googleCode']) !== null && _a !== void 0 ? _a : '',
        redirectUrl: (_b = o['redirectUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getGoogleProfileResponseToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.emailVerified !== undefined)
        o['emailVerified'] = m.emailVerified;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.picture !== undefined)
        o['picture'] = m.picture;
    if (m.givenName !== undefined)
        o['givenName'] = m.givenName;
    if (m.familyName !== undefined)
        o['familyName'] = m.familyName;
    if (m.locale !== undefined)
        o['locale'] = m.locale;
    if (m.token !== undefined)
        o['token'] = m.token;
    return o;
}
export function getGoogleProfileResponseFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
        emailVerified: (_b = o['emailVerified']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        picture: (_d = o['picture']) !== null && _d !== void 0 ? _d : '',
        givenName: (_e = o['givenName']) !== null && _e !== void 0 ? _e : '',
        familyName: (_f = o['familyName']) !== null && _f !== void 0 ? _f : '',
        locale: (_g = o['locale']) !== null && _g !== void 0 ? _g : '',
        token: (_h = o['token']) !== null && _h !== void 0 ? _h : '',
    };
}
export function getLinkedinProfileRequestToJson(m) {
    const o = {};
    if (m.authorizationCode !== undefined)
        o['authorizationCode'] = m.authorizationCode;
    if (m.redirectUrl !== undefined)
        o['redirectUrl'] = m.redirectUrl;
    return o;
}
export function getLinkedinProfileRequestFromJson(o) {
    var _a, _b;
    return {
        authorizationCode: (_a = o['authorizationCode']) !== null && _a !== void 0 ? _a : '',
        redirectUrl: (_b = o['redirectUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getLinkedinProfileResponseToJson(m) {
    const o = {};
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.profilePictureUrn !== undefined)
        o['profilePictureUrn'] = m.profilePictureUrn;
    if (m.token !== undefined)
        o['token'] = m.token;
    return o;
}
export function getLinkedinProfileResponseFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        firstName: (_a = o['firstName']) !== null && _a !== void 0 ? _a : '',
        lastName: (_b = o['lastName']) !== null && _b !== void 0 ? _b : '',
        email: (_c = o['email']) !== null && _c !== void 0 ? _c : '',
        profilePictureUrn: (_d = o['profilePictureUrn']) !== null && _d !== void 0 ? _d : '',
        token: (_e = o['token']) !== null && _e !== void 0 ? _e : '',
    };
}
export function getMicrosoftProfileRequestToJson(m) {
    const o = {};
    if (m.authorizationCode !== undefined)
        o['authorizationCode'] = m.authorizationCode;
    if (m.redirectUrl !== undefined)
        o['redirectUrl'] = m.redirectUrl;
    return o;
}
export function getMicrosoftProfileRequestFromJson(o) {
    var _a, _b;
    return {
        authorizationCode: (_a = o['authorizationCode']) !== null && _a !== void 0 ? _a : '',
        redirectUrl: (_b = o['redirectUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getMicrosoftProfileResponseToJson(m) {
    const o = {};
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.picture !== undefined)
        o['picture'] = m.picture;
    if (m.idToken !== undefined)
        o['idToken'] = m.idToken;
    return o;
}
export function getMicrosoftProfileResponseFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        firstName: (_a = o['firstName']) !== null && _a !== void 0 ? _a : '',
        lastName: (_b = o['lastName']) !== null && _b !== void 0 ? _b : '',
        email: (_c = o['email']) !== null && _c !== void 0 ? _c : '',
        picture: (_d = o['picture']) !== null && _d !== void 0 ? _d : '',
        idToken: (_e = o['idToken']) !== null && _e !== void 0 ? _e : '',
    };
}
export function signUpCredentialToJson(m) {
    const o = {};
    if (m.userCredential !== undefined) {
        if (m.userCredential.type === 'googleToken') {
            o['googleToken'] = googleTokenCredentialToJson(m.userCredential.googleToken);
        }
        if (m.userCredential.type === 'user') {
            o['user'] = userCredentialToJson(m.userCredential.user);
        }
        if (m.userCredential.type === 'linkedinToken') {
            o['linkedinToken'] = linkedInTokenCredentialToJson(m.userCredential.linkedinToken);
        }
        if (m.userCredential.type === 'microsoftToken') {
            o['microsoftToken'] = microsoftTokenCredentialToJson(m.userCredential.microsoftToken);
        }
    }
    else {
        if (m.googleToken !== undefined)
            o['googleToken'] = googleTokenCredentialToJson(m.googleToken);
        if (m.user !== undefined)
            o['user'] = userCredentialToJson(m.user);
        if (m.linkedinToken !== undefined)
            o['linkedinToken'] = linkedInTokenCredentialToJson(m.linkedinToken);
        if (m.microsoftToken !== undefined)
            o['microsoftToken'] = microsoftTokenCredentialToJson(m.microsoftToken);
    }
    return o;
}
export function signUpCredentialFromJson(o) {
    return {
        userCredential: (() => {
            if (o['googleToken'] !== undefined)
                return { type: 'googleToken', googleToken: o['googleToken'] ? googleTokenCredentialFromJson(o['googleToken']) : undefined };
            if (o['user'] !== undefined)
                return { type: 'user', user: o['user'] ? userCredentialFromJson(o['user']) : undefined };
            if (o['linkedinToken'] !== undefined)
                return { type: 'linkedinToken', linkedinToken: o['linkedinToken'] ? linkedInTokenCredentialFromJson(o['linkedinToken']) : undefined };
            if (o['microsoftToken'] !== undefined)
                return { type: 'microsoftToken', microsoftToken: o['microsoftToken'] ? microsoftTokenCredentialFromJson(o['microsoftToken']) : undefined };
            return undefined;
        })(),
        googleToken: o['googleToken'] !== undefined ? o['googleToken'] ? googleTokenCredentialFromJson(o['googleToken']) : undefined : undefined,
        user: o['user'] !== undefined ? o['user'] ? userCredentialFromJson(o['user']) : undefined : undefined,
        linkedinToken: o['linkedinToken'] !== undefined ? o['linkedinToken'] ? linkedInTokenCredentialFromJson(o['linkedinToken']) : undefined : undefined,
        microsoftToken: o['microsoftToken'] !== undefined ? o['microsoftToken'] ? microsoftTokenCredentialFromJson(o['microsoftToken']) : undefined : undefined,
    };
}
export function newAccountToJson(m) {
    const o = {};
    if (m.credential !== undefined)
        o['credential'] = signUpCredentialToJson(m.credential);
    if (m.companyProfile !== undefined)
        o['companyProfile'] = companyProfileToJson(m.companyProfile);
    return o;
}
export function newAccountFromJson(o) {
    return {
        credential: o['credential'] ? signUpCredentialFromJson(o['credential']) : undefined,
        companyProfile: o['companyProfile'] ? companyProfileFromJson(o['companyProfile']) : undefined,
    };
}
export function existingAccountToJson(m) {
    const o = {};
    if (m.credential !== undefined)
        o['credential'] = signUpCredentialToJson(m.credential);
    return o;
}
export function existingAccountFromJson(o) {
    return {
        credential: o['credential'] ? signUpCredentialFromJson(o['credential']) : undefined,
    };
}
export function signUpRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    if (m.acquisitionData !== undefined)
        o['acquisitionData'] = partnerAcquisitionDataToJson(m.acquisitionData);
    if (m.termsOfService !== undefined)
        o['termsOfService'] = termOfServiceToJson(m.termsOfService);
    if (m.billingCurrencyCode !== undefined)
        o['billingCurrencyCode'] = m.billingCurrencyCode;
    if (m.websiteOptOutFlag !== undefined)
        o['websiteOptOutFlag'] = m.websiteOptOutFlag;
    if (m.subscriptionTierId !== undefined)
        o['subscriptionTierId'] = m.subscriptionTierId;
    if (m.stripeToken !== undefined)
        o['stripeToken'] = m.stripeToken;
    if (m.nextUrl !== undefined)
        o['nextUrl'] = m.nextUrl;
    if (m.signUpType !== undefined) {
        if (m.signUpType.type === 'newAccount') {
            o['newAccount'] = newAccountToJson(m.signUpType.newAccount);
        }
        if (m.signUpType.type === 'existingAccount') {
            o['existingAccount'] = existingAccountToJson(m.signUpType.existingAccount);
        }
    }
    else {
        if (m.newAccount !== undefined)
            o['newAccount'] = newAccountToJson(m.newAccount);
        if (m.existingAccount !== undefined)
            o['existingAccount'] = existingAccountToJson(m.existingAccount);
    }
    if (m.recaptchaToken !== undefined) {
        if (m.recaptchaToken.type === 'recaptchaV2Token') {
            o['recaptchaV2Token'] = m.recaptchaToken.recaptchaV2Token;
        }
        if (m.recaptchaToken.type === 'recaptchaV3Token') {
            o['recaptchaV3Token'] = m.recaptchaToken.recaptchaV3Token;
        }
    }
    else {
        if (m.recaptchaV2Token !== undefined)
            o['recaptchaV2Token'] = m.recaptchaV2Token;
        if (m.recaptchaV3Token !== undefined)
            o['recaptchaV3Token'] = m.recaptchaV3Token;
    }
    return o;
}
export function signUpRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
        acquisitionData: o['acquisitionData'] ? partnerAcquisitionDataFromJson(o['acquisitionData']) : undefined,
        termsOfService: o['termsOfService'] ? termOfServiceFromJson(o['termsOfService']) : undefined,
        billingCurrencyCode: (_b = o['billingCurrencyCode']) !== null && _b !== void 0 ? _b : '',
        websiteOptOutFlag: (_c = o['websiteOptOutFlag']) !== null && _c !== void 0 ? _c : false,
        subscriptionTierId: (_d = o['subscriptionTierId']) !== null && _d !== void 0 ? _d : '',
        stripeToken: (_e = o['stripeToken']) !== null && _e !== void 0 ? _e : '',
        nextUrl: (_f = o['nextUrl']) !== null && _f !== void 0 ? _f : '',
        signUpType: (() => {
            if (o['newAccount'] !== undefined)
                return { type: 'newAccount', newAccount: o['newAccount'] ? newAccountFromJson(o['newAccount']) : undefined };
            if (o['existingAccount'] !== undefined)
                return { type: 'existingAccount', existingAccount: o['existingAccount'] ? existingAccountFromJson(o['existingAccount']) : undefined };
            return undefined;
        })(),
        newAccount: o['newAccount'] !== undefined ? o['newAccount'] ? newAccountFromJson(o['newAccount']) : undefined : undefined,
        existingAccount: o['existingAccount'] !== undefined ? o['existingAccount'] ? existingAccountFromJson(o['existingAccount']) : undefined : undefined,
        recaptchaToken: (() => {
            if (o['recaptchaV2Token'] !== undefined)
                return { type: 'recaptchaV2Token', recaptchaV2Token: o['recaptchaV2Token'] };
            if (o['recaptchaV3Token'] !== undefined)
                return { type: 'recaptchaV3Token', recaptchaV3Token: o['recaptchaV3Token'] };
            return undefined;
        })(),
        recaptchaV2Token: o['recaptchaV2Token'] !== undefined ? o['recaptchaV2Token'] : undefined,
        recaptchaV3Token: o['recaptchaV3Token'] !== undefined ? o['recaptchaV3Token'] : undefined,
    };
}
export function signUpAgentRequestToJson(m) {
    const o = {};
    if (m.idempotentKey !== undefined)
        o['idempotentKey'] = m.idempotentKey;
    if (m.user !== undefined)
        o['user'] = partnerUserToJson(m.user);
    if (m.companyProfile !== undefined)
        o['companyProfile'] = companyProfileToJson(m.companyProfile);
    if (m.acquisitionData !== undefined)
        o['acquisitionData'] = partnerAcquisitionDataToJson(m.acquisitionData);
    if (m.billingCurrencyCode !== undefined)
        o['billingCurrencyCode'] = m.billingCurrencyCode;
    return o;
}
export function signUpAgentRequestFromJson(o) {
    var _a, _b;
    return {
        idempotentKey: (_a = o['idempotentKey']) !== null && _a !== void 0 ? _a : '',
        user: o['user'] ? partnerUserFromJson(o['user']) : undefined,
        companyProfile: o['companyProfile'] ? companyProfileFromJson(o['companyProfile']) : undefined,
        acquisitionData: o['acquisitionData'] ? partnerAcquisitionDataFromJson(o['acquisitionData']) : undefined,
        billingCurrencyCode: (_b = o['billingCurrencyCode']) !== null && _b !== void 0 ? _b : '',
    };
}
export function moneyToJson(m) {
    const o = {};
    if (m.valueInCents !== undefined)
        o['valueInCents'] = m.valueInCents;
    if (m.currencyCode !== undefined)
        o['currencyCode'] = m.currencyCode;
    return o;
}
export function moneyFromJson(o) {
    var _a, _b;
    return {
        valueInCents: (_a = o['valueInCents']) !== null && _a !== void 0 ? _a : 0,
        currencyCode: (_b = o['currencyCode']) !== null && _b !== void 0 ? _b : '',
    };
}
export function claimedToJson(m) {
    const o = {};
    if (m.date !== undefined)
        o['date'] = m.date.toISOString();
    return o;
}
export function claimedFromJson(o) {
    return {
        date: o['date'] ? new Date(o['date']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function rewardToJson(m) {
    const o = {};
    if (m.rewardId !== undefined)
        o['rewardId'] = m.rewardId;
    if (m.amount !== undefined)
        o['amount'] = moneyToJson(m.amount);
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.claimed !== undefined)
        o['claimed'] = claimedToJson(m.claimed);
    return o;
}
export function rewardFromJson(o) {
    var _a, _b;
    return {
        rewardId: (_a = o['rewardId']) !== null && _a !== void 0 ? _a : '',
        amount: o['amount'] ? moneyFromJson(o['amount']) : undefined,
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'REWARD_STATUS_INVALID',
        claimed: o['claimed'] ? claimedFromJson(o['claimed']) : undefined,
    };
}
export function getRewardRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.rewardId !== undefined)
        o['rewardId'] = m.rewardId;
    return o;
}
export function getRewardRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        rewardId: (_b = o['rewardId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getRewardResponseToJson(m) {
    const o = {};
    if (m.reward !== undefined)
        o['reward'] = rewardToJson(m.reward);
    return o;
}
export function getRewardResponseFromJson(o) {
    return {
        reward: o['reward'] ? rewardFromJson(o['reward']) : undefined,
    };
}
export function addRewardToPartnerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.rewardId !== undefined)
        o['rewardId'] = m.rewardId;
    return o;
}
export function addRewardToPartnerRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        rewardId: (_b = o['rewardId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function attemptRewardClaimRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.rewardId !== undefined)
        o['rewardId'] = m.rewardId;
    return o;
}
export function attemptRewardClaimRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        rewardId: (_b = o['rewardId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function isRewardConditionMetForPartnerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.rewardId !== undefined)
        o['rewardId'] = m.rewardId;
    return o;
}
export function isRewardConditionMetForPartnerRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        rewardId: (_b = o['rewardId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function isRewardConditionMetForPartnerResponseToJson(m) {
    const o = {};
    if (m.rewardConditionsMet !== undefined)
        o['rewardConditionsMet'] = m.rewardConditionsMet;
    return o;
}
export function isRewardConditionMetForPartnerResponseFromJson(o) {
    var _a;
    return {
        rewardConditionsMet: (_a = o['rewardConditionsMet']) !== null && _a !== void 0 ? _a : false,
    };
}
export function salesConfigurationToJson(m) {
    const o = {};
    if (m.hideProducts !== undefined)
        o['hideProducts'] = m.hideProducts;
    if (m.hideRmDemo !== undefined)
        o['hideRmDemo'] = m.hideRmDemo;
    if (m.stTeamActivity !== undefined)
        o['stTeamActivity'] = m.stTeamActivity;
    if (m.stAllowSalespersonCampaignAdd !== undefined)
        o['stAllowSalespersonCampaignAdd'] = m.stAllowSalespersonCampaignAdd;
    if (m.stShowProductsWholesalePrice !== undefined)
        o['stShowProductsWholesalePrice'] = m.stShowProductsWholesalePrice;
    if (m.stShowTrainingResourcesField !== undefined)
        o['stShowTrainingResourcesField'] = m.stShowTrainingResourcesField;
    if (m.stSalespersonSharedAccountAccess !== undefined)
        o['stSalespersonSharedAccountAccess'] = m.stSalespersonSharedAccountAccess;
    if (m.stDefaultDisplayCurrency !== undefined)
        o['stDefaultDisplayCurrency'] = m.stDefaultDisplayCurrency;
    if (m.stEnableSnapshotsPerSalespersonLimit !== undefined)
        o['stEnableSnapshotsPerSalespersonLimit'] = m.stEnableSnapshotsPerSalespersonLimit;
    if (m.stSnapshotsPerSalespersonLimit !== undefined)
        o['stSnapshotsPerSalespersonLimit'] = m.stSnapshotsPerSalespersonLimit;
    if (m.stBusinessCenterAccess !== undefined)
        o['stBusinessCenterAccess'] = m.stBusinessCenterAccess;
    if (m.hideOrders !== undefined)
        o['hideOrders'] = m.hideOrders;
    if (m.sscWhitelabeled !== undefined)
        o['sscWhitelabeled'] = m.sscWhitelabeled;
    if (m.stShowInbox !== undefined)
        o['stShowInbox'] = m.stShowInbox;
    return o;
}
export function salesConfigurationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        hideProducts: (_a = o['hideProducts']) !== null && _a !== void 0 ? _a : false,
        hideRmDemo: (_b = o['hideRmDemo']) !== null && _b !== void 0 ? _b : false,
        stTeamActivity: (_c = o['stTeamActivity']) !== null && _c !== void 0 ? _c : false,
        stAllowSalespersonCampaignAdd: (_d = o['stAllowSalespersonCampaignAdd']) !== null && _d !== void 0 ? _d : false,
        stShowProductsWholesalePrice: (_e = o['stShowProductsWholesalePrice']) !== null && _e !== void 0 ? _e : false,
        stShowTrainingResourcesField: (_f = o['stShowTrainingResourcesField']) !== null && _f !== void 0 ? _f : false,
        stSalespersonSharedAccountAccess: (_g = o['stSalespersonSharedAccountAccess']) !== null && _g !== void 0 ? _g : false,
        stDefaultDisplayCurrency: (_h = o['stDefaultDisplayCurrency']) !== null && _h !== void 0 ? _h : '',
        stEnableSnapshotsPerSalespersonLimit: (_j = o['stEnableSnapshotsPerSalespersonLimit']) !== null && _j !== void 0 ? _j : false,
        stSnapshotsPerSalespersonLimit: (_k = o['stSnapshotsPerSalespersonLimit']) !== null && _k !== void 0 ? _k : 0,
        stBusinessCenterAccess: (_l = o['stBusinessCenterAccess']) !== null && _l !== void 0 ? _l : false,
        hideOrders: (_m = o['hideOrders']) !== null && _m !== void 0 ? _m : false,
        sscWhitelabeled: (_o = o['sscWhitelabeled']) !== null && _o !== void 0 ? _o : false,
        stShowInbox: (_p = o['stShowInbox']) !== null && _p !== void 0 ? _p : false,
    };
}
export function salesConfigInputsToJson(m) {
    const o = {};
    if (m.hideProducts !== undefined)
        o['hideProducts'] = m.hideProducts;
    if (m.hideRmDemo !== undefined)
        o['hideRmDemo'] = m.hideRmDemo;
    if (m.hideOrders !== undefined)
        o['hideOrders'] = m.hideOrders;
    if (m.stTeamActivity !== undefined)
        o['stTeamActivity'] = m.stTeamActivity;
    if (m.stAllowSalespersonCampaignAdd !== undefined)
        o['stAllowSalespersonCampaignAdd'] = m.stAllowSalespersonCampaignAdd;
    if (m.stShowProductsWholesalePrice !== undefined)
        o['stShowProductsWholesalePrice'] = m.stShowProductsWholesalePrice;
    if (m.stShowTrainingResourcesField !== undefined)
        o['stShowTrainingResourcesField'] = m.stShowTrainingResourcesField;
    if (m.stSalespersonSharedAccountAccess !== undefined)
        o['stSalespersonSharedAccountAccess'] = m.stSalespersonSharedAccountAccess;
    if (m.stDefaultDisplayCurrency !== undefined)
        o['stDefaultDisplayCurrency'] = m.stDefaultDisplayCurrency;
    if (m.stEnableSnapshotsPerSalespersonLimit !== undefined)
        o['stEnableSnapshotsPerSalespersonLimit'] = m.stEnableSnapshotsPerSalespersonLimit;
    if (m.stSnapshotsPerSalespersonLimit !== undefined)
        o['stSnapshotsPerSalespersonLimit'] = m.stSnapshotsPerSalespersonLimit;
    if (m.stBusinessCenterAccess !== undefined)
        o['stBusinessCenterAccess'] = m.stBusinessCenterAccess;
    if (m.stShowInbox !== undefined)
        o['stShowInbox'] = m.stShowInbox;
    return o;
}
export function salesConfigInputsFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        hideProducts: (_a = o['hideProducts']) !== null && _a !== void 0 ? _a : 'SALES_SETTING_INVALID',
        hideRmDemo: (_b = o['hideRmDemo']) !== null && _b !== void 0 ? _b : 'SALES_SETTING_INVALID',
        hideOrders: (_c = o['hideOrders']) !== null && _c !== void 0 ? _c : 'SALES_SETTING_INVALID',
        stTeamActivity: (_d = o['stTeamActivity']) !== null && _d !== void 0 ? _d : 'SALES_SETTING_INVALID',
        stAllowSalespersonCampaignAdd: (_e = o['stAllowSalespersonCampaignAdd']) !== null && _e !== void 0 ? _e : 'SALES_SETTING_INVALID',
        stShowProductsWholesalePrice: (_f = o['stShowProductsWholesalePrice']) !== null && _f !== void 0 ? _f : 'SALES_SETTING_INVALID',
        stShowTrainingResourcesField: (_g = o['stShowTrainingResourcesField']) !== null && _g !== void 0 ? _g : 'SALES_SETTING_INVALID',
        stSalespersonSharedAccountAccess: (_h = o['stSalespersonSharedAccountAccess']) !== null && _h !== void 0 ? _h : 'SALES_SETTING_INVALID',
        stDefaultDisplayCurrency: (_j = o['stDefaultDisplayCurrency']) !== null && _j !== void 0 ? _j : '',
        stEnableSnapshotsPerSalespersonLimit: (_k = o['stEnableSnapshotsPerSalespersonLimit']) !== null && _k !== void 0 ? _k : 'SALES_SETTING_INVALID',
        stSnapshotsPerSalespersonLimit: (_l = o['stSnapshotsPerSalespersonLimit']) !== null && _l !== void 0 ? _l : 0,
        stBusinessCenterAccess: (_m = o['stBusinessCenterAccess']) !== null && _m !== void 0 ? _m : 'SALES_SETTING_INVALID',
        stShowInbox: (_o = o['stShowInbox']) !== null && _o !== void 0 ? _o : 'SALES_SETTING_INVALID',
    };
}
export function setSalesConfigRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.config !== undefined)
        o['config'] = salesConfigInputsToJson(m.config);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function setSalesConfigRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        config: o['config'] ? salesConfigInputsFromJson(o['config']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function setSalesConfigResponseToJson(m) {
    const o = {};
    if (m.config !== undefined)
        o['config'] = salesConfigInputsToJson(m.config);
    return o;
}
export function setSalesConfigResponseFromJson(o) {
    return {
        config: o['config'] ? salesConfigInputsFromJson(o['config']) : undefined,
    };
}
export function getSalesConfigRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    return o;
}
export function getSalesConfigRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getSalesConfigResponseToJson(m) {
    const o = {};
    if (m.config !== undefined)
        o['config'] = salesConfigurationToJson(m.config);
    return o;
}
export function getSalesConfigResponseFromJson(o) {
    return {
        config: o['config'] ? salesConfigurationFromJson(o['config']) : undefined,
    };
}
export function referralLinkToJson(m) {
    const o = {};
    if (m.longUrl !== undefined)
        o['longUrl'] = m.longUrl;
    if (m.shortenedUrl !== undefined)
        o['shortenedUrl'] = m.shortenedUrl;
    return o;
}
export function referralLinkFromJson(o) {
    var _a, _b;
    return {
        longUrl: (_a = o['longUrl']) !== null && _a !== void 0 ? _a : '',
        shortenedUrl: (_b = o['shortenedUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function executiveReportConfigurationToJson(m) {
    const o = {};
    if (m.disabledSections !== undefined) {
        o['disabledSections'] = m.disabledSections.map(e => e);
    }
    if (m.sectionOrder !== undefined) {
        o['sectionOrder'] = m.sectionOrder.map(e => e);
    }
    return o;
}
export function executiveReportConfigurationFromJson(o) {
    var _a, _b;
    return {
        disabledSections: ((_a = o['disabledSections']) !== null && _a !== void 0 ? _a : []).map(e => e),
        sectionOrder: ((_b = o['sectionOrder']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function executiveReportSectionToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.disabled !== undefined)
        o['disabled'] = m.disabled;
    return o;
}
export function executiveReportSectionFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        disabled: (_b = o['disabled']) !== null && _b !== void 0 ? _b : false,
    };
}
export function assistantVisibilityConfigurationToJson(m) {
    const o = {};
    if (m.hiddenAssistantTypes !== undefined) {
        o['hiddenAssistantTypes'] = m.hiddenAssistantTypes.map(e => e);
    }
    return o;
}
export function assistantVisibilityConfigurationFromJson(o) {
    var _a;
    return {
        hiddenAssistantTypes: ((_a = o['hiddenAssistantTypes']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function businessCenterConfigurationToJson(m) {
    const o = {};
    if (m.showContentLibrary !== undefined)
        o['showContentLibrary'] = m.showContentLibrary;
    if (m.showLmiDashboard !== undefined)
        o['showLmiDashboard'] = m.showLmiDashboard;
    if (m.showExecutiveReport !== undefined)
        o['showExecutiveReport'] = m.showExecutiveReport;
    if (m.showStore !== undefined)
        o['showStore'] = m.showStore;
    if (m.cancellationNotificationEmail !== undefined)
        o['cancellationNotificationEmail'] = m.cancellationNotificationEmail;
    if (m.globalNotification !== undefined)
        o['globalNotification'] = m.globalNotification;
    if (m.businessAppBranding !== undefined)
        o['businessAppBranding'] = m.businessAppBranding;
    if (m.referralLink !== undefined)
        o['referralLink'] = referralLinkToJson(m.referralLink);
    if (m.accessTrialProducts !== undefined)
        o['accessTrialProducts'] = m.accessTrialProducts;
    if (m.hideQuickbooksConnector !== undefined)
        o['hideQuickbooksConnector'] = m.hideQuickbooksConnector;
    if (m.hideSmbAcademy !== undefined)
        o['hideSmbAcademy'] = m.hideSmbAcademy;
    if (m.showReviewGradeForSmbExecReport !== undefined)
        o['showReviewGradeForSmbExecReport'] = m.showReviewGradeForSmbExecReport;
    if (m.showGetStarted !== undefined)
        o['showGetStarted'] = m.showGetStarted;
    if (m.meetingSchedulerBusinessApp !== undefined)
        o['meetingSchedulerBusinessApp'] = m.meetingSchedulerBusinessApp;
    if (m.showSocialGradeForSmbExecReport !== undefined)
        o['showSocialGradeForSmbExecReport'] = m.showSocialGradeForSmbExecReport;
    if (m.showMyListingInBusinessCenter !== undefined)
        o['showMyListingInBusinessCenter'] = m.showMyListingInBusinessCenter;
    if (m.showInviteTeam !== undefined)
        o['showInviteTeam'] = m.showInviteTeam;
    if (m.disableBusinessNav !== undefined)
        o['disableBusinessNav'] = m.disableBusinessNav;
    if (m.showFulfillment !== undefined)
        o['showFulfillment'] = m.showFulfillment;
    if (m.showOrderPage !== undefined)
        o['showOrderPage'] = m.showOrderPage;
    if (m.showInvoices !== undefined)
        o['showInvoices'] = m.showInvoices;
    if (m.showDashboard !== undefined)
        o['showDashboard'] = m.showDashboard;
    if (m.showFiles !== undefined)
        o['showFiles'] = m.showFiles;
    if (m.showMyProducts !== undefined)
        o['showMyProducts'] = m.showMyProducts;
    if (m.showCustomers !== undefined)
        o['showCustomers'] = m.showCustomers;
    if (m.showRecentActivity !== undefined)
        o['showRecentActivity'] = m.showRecentActivity;
    if (m.showInboxMessage !== undefined)
        o['showInboxMessage'] = m.showInboxMessage;
    if (m.showCustomerJourney !== undefined)
        o['showCustomerJourney'] = m.showCustomerJourney;
    if (m.showOnboardingVideo !== undefined)
        o['showOnboardingVideo'] = m.showOnboardingVideo;
    if (m.onboardingVideoUrl !== undefined)
        o['onboardingVideoUrl'] = m.onboardingVideoUrl;
    if (m.showMarketingFunnel !== undefined)
        o['showMarketingFunnel'] = m.showMarketingFunnel;
    if (m.showCustomGuides !== undefined)
        o['showCustomGuides'] = m.showCustomGuides;
    if (m.customGuidesTags !== undefined) {
        o['customGuidesTags'] = m.customGuidesTags.map(e => e);
    }
    if (m.customGuidesUrl !== undefined)
        o['customGuidesUrl'] = m.customGuidesUrl;
    if (m.sendOnboardingCampaign !== undefined)
        o['sendOnboardingCampaign'] = m.sendOnboardingCampaign;
    if (m.onboardingCampaignId !== undefined)
        o['onboardingCampaignId'] = m.onboardingCampaignId;
    if (m.showRecommendationsBanner !== undefined)
        o['showRecommendationsBanner'] = m.showRecommendationsBanner;
    if (m.singleLocationDefaultTimeRange !== undefined)
        o['singleLocationDefaultTimeRange'] = m.singleLocationDefaultTimeRange;
    if (m.showGoogleSearchConsoleCta !== undefined)
        o['showGoogleSearchConsoleCta'] = m.showGoogleSearchConsoleCta;
    if (m.isBusinessProfileEditable !== undefined)
        o['isBusinessProfileEditable'] = m.isBusinessProfileEditable;
    if (m.allowSmbChatWithPartner !== undefined)
        o['allowSmbChatWithPartner'] = m.allowSmbChatWithPartner;
    if (m.showWordPressSalesOrders !== undefined)
        o['showWordPressSalesOrders'] = m.showWordPressSalesOrders;
    if (m.globalNotificationExpiryTime !== undefined)
        o['globalNotificationExpiryTime'] = m.globalNotificationExpiryTime.toISOString();
    if (m.showListingScore !== undefined)
        o['showListingScore'] = m.showListingScore;
    if (m.multiLocationDefaultTimeRange !== undefined)
        o['multiLocationDefaultTimeRange'] = m.multiLocationDefaultTimeRange;
    if (m.hideCreateAccount !== undefined)
        o['hideCreateAccount'] = m.hideCreateAccount;
    if (m.notificationsEnabled !== undefined)
        o['notificationsEnabled'] = m.notificationsEnabled;
    if (m.showListingScoreAsPercent !== undefined)
        o['showListingScoreAsPercent'] = m.showListingScoreAsPercent;
    if (m.customGuidesInlineTitle !== undefined)
        o['customGuidesInlineTitle'] = m.customGuidesInlineTitle;
    if (m.allowExportReviews !== undefined)
        o['allowExportReviews'] = m.allowExportReviews;
    if (m.decoupleProductAndReportAccess !== undefined)
        o['decoupleProductAndReportAccess'] = m.decoupleProductAndReportAccess;
    if (m.showCrmCompanies !== undefined)
        o['showCrmCompanies'] = m.showCrmCompanies;
    if (m.showCrmTasks !== undefined)
        o['showCrmTasks'] = m.showCrmTasks;
    if (m.showCustomForms !== undefined)
        o['showCustomForms'] = m.showCustomForms;
    if (m.showAutomations !== undefined)
        o['showAutomations'] = m.showAutomations;
    if (m.showCrmOpportunities !== undefined)
        o['showCrmOpportunities'] = m.showCrmOpportunities;
    if (m.showDynamicLists !== undefined)
        o['showDynamicLists'] = m.showDynamicLists;
    if (m.showLeaderboard !== undefined)
        o['showLeaderboard'] = m.showLeaderboard;
    if (m.showAiAssistant !== undefined)
        o['showAiAssistant'] = m.showAiAssistant;
    if (m.showLeadScoring !== undefined)
        o['showLeadScoring'] = m.showLeadScoring;
    if (m.showInboxWidgetFooterContent !== undefined)
        o['showInboxWidgetFooterContent'] = m.showInboxWidgetFooterContent;
    if (m.showCrmCustomObjects !== undefined)
        o['showCrmCustomObjects'] = m.showCrmCustomObjects;
    if (m.featuredPackageIds !== undefined) {
        o['featuredPackageIds'] = m.featuredPackageIds.map(e => e);
    }
    if (m.executiveReportSections !== undefined) {
        o['executiveReportSections'] = m.executiveReportSections.map(e => executiveReportSectionToJson(e));
    }
    if (m.showAiPreviewOnSignup !== undefined)
        o['showAiPreviewOnSignup'] = m.showAiPreviewOnSignup;
    if (m.showPromotions !== undefined)
        o['showPromotions'] = m.showPromotions;
    if (m.smbCanEditAutomations !== undefined)
        o['smbCanEditAutomations'] = m.smbCanEditAutomations;
    if (m.showFeaturedTemplates !== undefined)
        o['showFeaturedTemplates'] = m.showFeaturedTemplates;
    if (m.smbShowSystemAutomationTemplates !== undefined)
        o['smbShowSystemAutomationTemplates'] = m.smbShowSystemAutomationTemplates;
    if (m.showPayments !== undefined)
        o['showPayments'] = m.showPayments;
    if (m.showAiWorkCard !== undefined)
        o['showAiWorkCard'] = m.showAiWorkCard;
    if (m.showProductUpgradeCards !== undefined)
        o['showProductUpgradeCards'] = m.showProductUpgradeCards;
    if (m.hideSalespersonContact !== undefined)
        o['hideSalespersonContact'] = m.hideSalespersonContact;
    if (m.showSupportCenterLink !== undefined)
        o['showSupportCenterLink'] = m.showSupportCenterLink;
    if (m.supportCenterLinkUrl !== undefined)
        o['supportCenterLinkUrl'] = m.supportCenterLinkUrl;
    if (m.supportCenterLinkLabel !== undefined)
        o['supportCenterLinkLabel'] = m.supportCenterLinkLabel;
    if (m.contactUsModalDescription !== undefined)
        o['contactUsModalDescription'] = m.contactUsModalDescription;
    if (m.assistantVisibilityConfiguration !== undefined)
        o['assistantVisibilityConfiguration'] = assistantVisibilityConfigurationToJson(m.assistantVisibilityConfiguration);
    return o;
}
export function businessCenterConfigurationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50;
    return {
        showContentLibrary: (_a = o['showContentLibrary']) !== null && _a !== void 0 ? _a : false,
        showLmiDashboard: (_b = o['showLmiDashboard']) !== null && _b !== void 0 ? _b : false,
        showExecutiveReport: (_c = o['showExecutiveReport']) !== null && _c !== void 0 ? _c : false,
        showStore: (_d = o['showStore']) !== null && _d !== void 0 ? _d : false,
        cancellationNotificationEmail: (_e = o['cancellationNotificationEmail']) !== null && _e !== void 0 ? _e : '',
        globalNotification: (_f = o['globalNotification']) !== null && _f !== void 0 ? _f : '',
        businessAppBranding: (_g = o['businessAppBranding']) !== null && _g !== void 0 ? _g : false,
        referralLink: o['referralLink'] ? referralLinkFromJson(o['referralLink']) : undefined,
        accessTrialProducts: (_h = o['accessTrialProducts']) !== null && _h !== void 0 ? _h : false,
        hideQuickbooksConnector: (_j = o['hideQuickbooksConnector']) !== null && _j !== void 0 ? _j : false,
        hideSmbAcademy: (_k = o['hideSmbAcademy']) !== null && _k !== void 0 ? _k : false,
        showReviewGradeForSmbExecReport: (_l = o['showReviewGradeForSmbExecReport']) !== null && _l !== void 0 ? _l : false,
        showGetStarted: (_m = o['showGetStarted']) !== null && _m !== void 0 ? _m : false,
        meetingSchedulerBusinessApp: (_o = o['meetingSchedulerBusinessApp']) !== null && _o !== void 0 ? _o : false,
        showSocialGradeForSmbExecReport: (_p = o['showSocialGradeForSmbExecReport']) !== null && _p !== void 0 ? _p : false,
        showMyListingInBusinessCenter: (_q = o['showMyListingInBusinessCenter']) !== null && _q !== void 0 ? _q : false,
        showInviteTeam: (_r = o['showInviteTeam']) !== null && _r !== void 0 ? _r : false,
        disableBusinessNav: (_s = o['disableBusinessNav']) !== null && _s !== void 0 ? _s : false,
        showFulfillment: (_t = o['showFulfillment']) !== null && _t !== void 0 ? _t : false,
        showOrderPage: (_u = o['showOrderPage']) !== null && _u !== void 0 ? _u : false,
        showInvoices: (_v = o['showInvoices']) !== null && _v !== void 0 ? _v : false,
        showDashboard: (_w = o['showDashboard']) !== null && _w !== void 0 ? _w : false,
        showFiles: (_x = o['showFiles']) !== null && _x !== void 0 ? _x : false,
        showMyProducts: (_y = o['showMyProducts']) !== null && _y !== void 0 ? _y : false,
        showCustomers: (_z = o['showCustomers']) !== null && _z !== void 0 ? _z : false,
        showRecentActivity: (_0 = o['showRecentActivity']) !== null && _0 !== void 0 ? _0 : false,
        showInboxMessage: (_1 = o['showInboxMessage']) !== null && _1 !== void 0 ? _1 : false,
        showCustomerJourney: (_2 = o['showCustomerJourney']) !== null && _2 !== void 0 ? _2 : false,
        showOnboardingVideo: (_3 = o['showOnboardingVideo']) !== null && _3 !== void 0 ? _3 : false,
        onboardingVideoUrl: (_4 = o['onboardingVideoUrl']) !== null && _4 !== void 0 ? _4 : '',
        showMarketingFunnel: (_5 = o['showMarketingFunnel']) !== null && _5 !== void 0 ? _5 : false,
        showCustomGuides: (_6 = o['showCustomGuides']) !== null && _6 !== void 0 ? _6 : false,
        customGuidesTags: ((_7 = o['customGuidesTags']) !== null && _7 !== void 0 ? _7 : []).map(e => e),
        customGuidesUrl: (_8 = o['customGuidesUrl']) !== null && _8 !== void 0 ? _8 : '',
        sendOnboardingCampaign: (_9 = o['sendOnboardingCampaign']) !== null && _9 !== void 0 ? _9 : false,
        onboardingCampaignId: (_10 = o['onboardingCampaignId']) !== null && _10 !== void 0 ? _10 : '',
        showRecommendationsBanner: (_11 = o['showRecommendationsBanner']) !== null && _11 !== void 0 ? _11 : false,
        singleLocationDefaultTimeRange: (_12 = o['singleLocationDefaultTimeRange']) !== null && _12 !== void 0 ? _12 : 'TIME_RANGE_SEVEN_DAYS',
        showGoogleSearchConsoleCta: (_13 = o['showGoogleSearchConsoleCta']) !== null && _13 !== void 0 ? _13 : false,
        isBusinessProfileEditable: (_14 = o['isBusinessProfileEditable']) !== null && _14 !== void 0 ? _14 : false,
        allowSmbChatWithPartner: (_15 = o['allowSmbChatWithPartner']) !== null && _15 !== void 0 ? _15 : false,
        showWordPressSalesOrders: (_16 = o['showWordPressSalesOrders']) !== null && _16 !== void 0 ? _16 : false,
        globalNotificationExpiryTime: o['globalNotificationExpiryTime'] ? new Date(o['globalNotificationExpiryTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        showListingScore: (_17 = o['showListingScore']) !== null && _17 !== void 0 ? _17 : false,
        multiLocationDefaultTimeRange: (_18 = o['multiLocationDefaultTimeRange']) !== null && _18 !== void 0 ? _18 : 'TIME_RANGE_SEVEN_DAYS',
        hideCreateAccount: (_19 = o['hideCreateAccount']) !== null && _19 !== void 0 ? _19 : false,
        notificationsEnabled: (_20 = o['notificationsEnabled']) !== null && _20 !== void 0 ? _20 : false,
        showListingScoreAsPercent: (_21 = o['showListingScoreAsPercent']) !== null && _21 !== void 0 ? _21 : false,
        customGuidesInlineTitle: (_22 = o['customGuidesInlineTitle']) !== null && _22 !== void 0 ? _22 : false,
        allowExportReviews: (_23 = o['allowExportReviews']) !== null && _23 !== void 0 ? _23 : false,
        decoupleProductAndReportAccess: (_24 = o['decoupleProductAndReportAccess']) !== null && _24 !== void 0 ? _24 : false,
        showCrmCompanies: (_25 = o['showCrmCompanies']) !== null && _25 !== void 0 ? _25 : false,
        showCrmTasks: (_26 = o['showCrmTasks']) !== null && _26 !== void 0 ? _26 : false,
        showCustomForms: (_27 = o['showCustomForms']) !== null && _27 !== void 0 ? _27 : false,
        showAutomations: (_28 = o['showAutomations']) !== null && _28 !== void 0 ? _28 : false,
        showCrmOpportunities: (_29 = o['showCrmOpportunities']) !== null && _29 !== void 0 ? _29 : false,
        showDynamicLists: (_30 = o['showDynamicLists']) !== null && _30 !== void 0 ? _30 : false,
        showLeaderboard: (_31 = o['showLeaderboard']) !== null && _31 !== void 0 ? _31 : false,
        showAiAssistant: (_32 = o['showAiAssistant']) !== null && _32 !== void 0 ? _32 : false,
        showLeadScoring: (_33 = o['showLeadScoring']) !== null && _33 !== void 0 ? _33 : false,
        showInboxWidgetFooterContent: (_34 = o['showInboxWidgetFooterContent']) !== null && _34 !== void 0 ? _34 : false,
        showCrmCustomObjects: (_35 = o['showCrmCustomObjects']) !== null && _35 !== void 0 ? _35 : false,
        featuredPackageIds: ((_36 = o['featuredPackageIds']) !== null && _36 !== void 0 ? _36 : []).map(e => e),
        executiveReportSections: ((_37 = o['executiveReportSections']) !== null && _37 !== void 0 ? _37 : []).map(e => executiveReportSectionFromJson(e)),
        showAiPreviewOnSignup: (_38 = o['showAiPreviewOnSignup']) !== null && _38 !== void 0 ? _38 : false,
        showPromotions: (_39 = o['showPromotions']) !== null && _39 !== void 0 ? _39 : false,
        smbCanEditAutomations: (_40 = o['smbCanEditAutomations']) !== null && _40 !== void 0 ? _40 : false,
        showFeaturedTemplates: (_41 = o['showFeaturedTemplates']) !== null && _41 !== void 0 ? _41 : false,
        smbShowSystemAutomationTemplates: (_42 = o['smbShowSystemAutomationTemplates']) !== null && _42 !== void 0 ? _42 : false,
        showPayments: (_43 = o['showPayments']) !== null && _43 !== void 0 ? _43 : false,
        showAiWorkCard: (_44 = o['showAiWorkCard']) !== null && _44 !== void 0 ? _44 : false,
        showProductUpgradeCards: (_45 = o['showProductUpgradeCards']) !== null && _45 !== void 0 ? _45 : false,
        hideSalespersonContact: (_46 = o['hideSalespersonContact']) !== null && _46 !== void 0 ? _46 : false,
        showSupportCenterLink: (_47 = o['showSupportCenterLink']) !== null && _47 !== void 0 ? _47 : false,
        supportCenterLinkUrl: (_48 = o['supportCenterLinkUrl']) !== null && _48 !== void 0 ? _48 : '',
        supportCenterLinkLabel: (_49 = o['supportCenterLinkLabel']) !== null && _49 !== void 0 ? _49 : '',
        contactUsModalDescription: (_50 = o['contactUsModalDescription']) !== null && _50 !== void 0 ? _50 : '',
        assistantVisibilityConfiguration: o['assistantVisibilityConfiguration'] ? assistantVisibilityConfigurationFromJson(o['assistantVisibilityConfiguration']) : undefined,
    };
}
export function setBusinessCenterConfigRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.config !== undefined)
        o['config'] = businessCenterConfigurationToJson(m.config);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function setBusinessCenterConfigRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        config: o['config'] ? businessCenterConfigurationFromJson(o['config']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function setBusinessCenterConfigResponseToJson(m) {
    const o = {};
    if (m.config !== undefined)
        o['config'] = businessCenterConfigurationToJson(m.config);
    return o;
}
export function setBusinessCenterConfigResponseFromJson(o) {
    return {
        config: o['config'] ? businessCenterConfigurationFromJson(o['config']) : undefined,
    };
}
export function businessCenterMarketConfigurationToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.showContentLibrary !== undefined)
        o['showContentLibrary'] = m.showContentLibrary;
    if (m.showLmiDashboard !== undefined)
        o['showLmiDashboard'] = m.showLmiDashboard;
    if (m.showExecutiveReport !== undefined)
        o['showExecutiveReport'] = m.showExecutiveReport;
    if (m.showStore !== undefined)
        o['showStore'] = m.showStore;
    if (m.cancellationNotificationEmail !== undefined)
        o['cancellationNotificationEmail'] = m.cancellationNotificationEmail;
    if (m.globalNotification !== undefined)
        o['globalNotification'] = m.globalNotification;
    if (m.businessAppBranding !== undefined)
        o['businessAppBranding'] = m.businessAppBranding;
    if (m.accessTrialProducts !== undefined)
        o['accessTrialProducts'] = m.accessTrialProducts;
    if (m.hideQuickbooksConnector !== undefined)
        o['hideQuickbooksConnector'] = m.hideQuickbooksConnector;
    if (m.hideSmbAcademy !== undefined)
        o['hideSmbAcademy'] = m.hideSmbAcademy;
    if (m.showReviewGradeForSmbExecReport !== undefined)
        o['showReviewGradeForSmbExecReport'] = m.showReviewGradeForSmbExecReport;
    if (m.showGetStarted !== undefined)
        o['showGetStarted'] = m.showGetStarted;
    if (m.meetingSchedulerBusinessApp !== undefined)
        o['meetingSchedulerBusinessApp'] = m.meetingSchedulerBusinessApp;
    if (m.showSocialGradeForSmbExecReport !== undefined)
        o['showSocialGradeForSmbExecReport'] = m.showSocialGradeForSmbExecReport;
    if (m.showInviteTeam !== undefined)
        o['showInviteTeam'] = m.showInviteTeam;
    if (m.showFulfillment !== undefined)
        o['showFulfillment'] = m.showFulfillment;
    if (m.showOrderPage !== undefined)
        o['showOrderPage'] = m.showOrderPage;
    if (m.showInvoices !== undefined)
        o['showInvoices'] = m.showInvoices;
    if (m.showDashboard !== undefined)
        o['showDashboard'] = m.showDashboard;
    if (m.showFiles !== undefined)
        o['showFiles'] = m.showFiles;
    if (m.showMyProducts !== undefined)
        o['showMyProducts'] = m.showMyProducts;
    if (m.showCustomers !== undefined)
        o['showCustomers'] = m.showCustomers;
    if (m.showRecentActivity !== undefined)
        o['showRecentActivity'] = m.showRecentActivity;
    if (m.showInboxMessage !== undefined)
        o['showInboxMessage'] = m.showInboxMessage;
    if (m.referralLink !== undefined)
        o['referralLink'] = referralLinkToJson(m.referralLink);
    if (m.showCustomerJourney !== undefined)
        o['showCustomerJourney'] = m.showCustomerJourney;
    if (m.showOnboardingVideo !== undefined)
        o['showOnboardingVideo'] = m.showOnboardingVideo;
    if (m.onboardingVideoUrl !== undefined)
        o['onboardingVideoUrl'] = m.onboardingVideoUrl;
    if (m.showMarketingFunnel !== undefined)
        o['showMarketingFunnel'] = m.showMarketingFunnel;
    if (m.showCustomGuides !== undefined)
        o['showCustomGuides'] = m.showCustomGuides;
    if (m.customGuidesTags !== undefined) {
        o['customGuidesTags'] = m.customGuidesTags.map(e => e);
    }
    if (m.customGuidesUrl !== undefined)
        o['customGuidesUrl'] = m.customGuidesUrl;
    if (m.sendOnboardingCampaign !== undefined)
        o['sendOnboardingCampaign'] = m.sendOnboardingCampaign;
    if (m.onboardingCampaignId !== undefined)
        o['onboardingCampaignId'] = m.onboardingCampaignId;
    if (m.showRecommendationsBanner !== undefined)
        o['showRecommendationsBanner'] = m.showRecommendationsBanner;
    if (m.singleLocationDefaultTimeRange !== undefined)
        o['singleLocationDefaultTimeRange'] = m.singleLocationDefaultTimeRange;
    if (m.showGoogleSearchConsoleCta !== undefined)
        o['showGoogleSearchConsoleCta'] = m.showGoogleSearchConsoleCta;
    if (m.isBusinessProfileEditable !== undefined)
        o['isBusinessProfileEditable'] = m.isBusinessProfileEditable;
    if (m.allowSmbChatWithPartner !== undefined)
        o['allowSmbChatWithPartner'] = m.allowSmbChatWithPartner;
    if (m.showWordPressSalesOrders !== undefined)
        o['showWordPressSalesOrders'] = m.showWordPressSalesOrders;
    if (m.globalNotificationExpiryTime !== undefined)
        o['globalNotificationExpiryTime'] = m.globalNotificationExpiryTime.toISOString();
    if (m.showListingScore !== undefined)
        o['showListingScore'] = m.showListingScore;
    if (m.multiLocationDefaultTimeRange !== undefined)
        o['multiLocationDefaultTimeRange'] = m.multiLocationDefaultTimeRange;
    if (m.businessAppName !== undefined)
        o['businessAppName'] = m.businessAppName;
    if (m.hideCreateAccount !== undefined)
        o['hideCreateAccount'] = m.hideCreateAccount;
    if (m.notificationsEnabled !== undefined)
        o['notificationsEnabled'] = m.notificationsEnabled;
    if (m.showListingScoreAsPercent !== undefined)
        o['showListingScoreAsPercent'] = m.showListingScoreAsPercent;
    if (m.customGuidesInlineTitle !== undefined)
        o['customGuidesInlineTitle'] = m.customGuidesInlineTitle;
    if (m.allowExportReviews !== undefined)
        o['allowExportReviews'] = m.allowExportReviews;
    if (m.decoupleProductAndReportAccess !== undefined)
        o['decoupleProductAndReportAccess'] = m.decoupleProductAndReportAccess;
    if (m.showCrmCompanies !== undefined)
        o['showCrmCompanies'] = m.showCrmCompanies;
    if (m.showCrmTasks !== undefined)
        o['showCrmTasks'] = m.showCrmTasks;
    if (m.showCustomForms !== undefined)
        o['showCustomForms'] = m.showCustomForms;
    if (m.showAutomations !== undefined)
        o['showAutomations'] = m.showAutomations;
    if (m.showCrmOpportunities !== undefined)
        o['showCrmOpportunities'] = m.showCrmOpportunities;
    if (m.showDynamicLists !== undefined)
        o['showDynamicLists'] = m.showDynamicLists;
    if (m.showLeaderboard !== undefined)
        o['showLeaderboard'] = m.showLeaderboard;
    if (m.showAiAssistant !== undefined)
        o['showAiAssistant'] = m.showAiAssistant;
    if (m.showLeadScoring !== undefined)
        o['showLeadScoring'] = m.showLeadScoring;
    if (m.showInboxWidgetFooterContent !== undefined)
        o['showInboxWidgetFooterContent'] = m.showInboxWidgetFooterContent;
    if (m.showCrmCustomObjects !== undefined)
        o['showCrmCustomObjects'] = m.showCrmCustomObjects;
    if (m.featuredPackageIds !== undefined) {
        o['featuredPackageIds'] = m.featuredPackageIds.map(e => e);
    }
    if (m.executiveReportConfiguration !== undefined)
        o['executiveReportConfiguration'] = executiveReportConfigurationToJson(m.executiveReportConfiguration);
    if (m.showAiPreviewOnSignup !== undefined)
        o['showAiPreviewOnSignup'] = m.showAiPreviewOnSignup;
    if (m.showPromotions !== undefined)
        o['showPromotions'] = m.showPromotions;
    if (m.smbCanEditAutomations !== undefined)
        o['smbCanEditAutomations'] = m.smbCanEditAutomations;
    if (m.showFeaturedTemplates !== undefined)
        o['showFeaturedTemplates'] = m.showFeaturedTemplates;
    if (m.smbShowSystemAutomationTemplates !== undefined)
        o['smbShowSystemAutomationTemplates'] = m.smbShowSystemAutomationTemplates;
    if (m.showPayments !== undefined)
        o['showPayments'] = m.showPayments;
    if (m.showAiWorkCard !== undefined)
        o['showAiWorkCard'] = m.showAiWorkCard;
    if (m.showProductUpgradeCards !== undefined)
        o['showProductUpgradeCards'] = m.showProductUpgradeCards;
    if (m.hideSalespersonContact !== undefined)
        o['hideSalespersonContact'] = m.hideSalespersonContact;
    if (m.showSupportCenterLink !== undefined)
        o['showSupportCenterLink'] = m.showSupportCenterLink;
    if (m.supportCenterLinkUrl !== undefined)
        o['supportCenterLinkUrl'] = m.supportCenterLinkUrl;
    if (m.supportCenterLinkLabel !== undefined)
        o['supportCenterLinkLabel'] = m.supportCenterLinkLabel;
    if (m.contactUsModalDescription !== undefined)
        o['contactUsModalDescription'] = m.contactUsModalDescription;
    if (m.assistantVisibilityConfiguration !== undefined)
        o['assistantVisibilityConfiguration'] = assistantVisibilityConfigurationToJson(m.assistantVisibilityConfiguration);
    return o;
}
export function businessCenterMarketConfigurationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        showContentLibrary: o['showContentLibrary'],
        showLmiDashboard: o['showLmiDashboard'],
        showExecutiveReport: o['showExecutiveReport'],
        showStore: o['showStore'],
        cancellationNotificationEmail: o['cancellationNotificationEmail'],
        globalNotification: o['globalNotification'],
        businessAppBranding: o['businessAppBranding'],
        accessTrialProducts: o['accessTrialProducts'],
        hideQuickbooksConnector: o['hideQuickbooksConnector'],
        hideSmbAcademy: o['hideSmbAcademy'],
        showReviewGradeForSmbExecReport: o['showReviewGradeForSmbExecReport'],
        showGetStarted: o['showGetStarted'],
        meetingSchedulerBusinessApp: o['meetingSchedulerBusinessApp'],
        showSocialGradeForSmbExecReport: o['showSocialGradeForSmbExecReport'],
        showInviteTeam: o['showInviteTeam'],
        showFulfillment: o['showFulfillment'],
        showOrderPage: o['showOrderPage'],
        showInvoices: o['showInvoices'],
        showDashboard: o['showDashboard'],
        showFiles: o['showFiles'],
        showMyProducts: o['showMyProducts'],
        showCustomers: o['showCustomers'],
        showRecentActivity: o['showRecentActivity'],
        showInboxMessage: o['showInboxMessage'],
        referralLink: o['referralLink'] ? referralLinkFromJson(o['referralLink']) : undefined,
        showCustomerJourney: o['showCustomerJourney'],
        showOnboardingVideo: o['showOnboardingVideo'],
        onboardingVideoUrl: (_c = o['onboardingVideoUrl']) !== null && _c !== void 0 ? _c : '',
        showMarketingFunnel: o['showMarketingFunnel'],
        showCustomGuides: o['showCustomGuides'],
        customGuidesTags: ((_d = o['customGuidesTags']) !== null && _d !== void 0 ? _d : []).map(e => e),
        customGuidesUrl: (_e = o['customGuidesUrl']) !== null && _e !== void 0 ? _e : '',
        sendOnboardingCampaign: o['sendOnboardingCampaign'],
        onboardingCampaignId: (_f = o['onboardingCampaignId']) !== null && _f !== void 0 ? _f : '',
        showRecommendationsBanner: o['showRecommendationsBanner'],
        singleLocationDefaultTimeRange: (_g = o['singleLocationDefaultTimeRange']) !== null && _g !== void 0 ? _g : 'TIME_RANGE_SEVEN_DAYS',
        showGoogleSearchConsoleCta: o['showGoogleSearchConsoleCta'],
        isBusinessProfileEditable: o['isBusinessProfileEditable'],
        allowSmbChatWithPartner: o['allowSmbChatWithPartner'],
        showWordPressSalesOrders: o['showWordPressSalesOrders'],
        globalNotificationExpiryTime: o['globalNotificationExpiryTime'] ? new Date(o['globalNotificationExpiryTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        showListingScore: o['showListingScore'],
        multiLocationDefaultTimeRange: (_h = o['multiLocationDefaultTimeRange']) !== null && _h !== void 0 ? _h : 'TIME_RANGE_SEVEN_DAYS',
        businessAppName: (_j = o['businessAppName']) !== null && _j !== void 0 ? _j : '',
        hideCreateAccount: o['hideCreateAccount'],
        notificationsEnabled: o['notificationsEnabled'],
        showListingScoreAsPercent: o['showListingScoreAsPercent'],
        customGuidesInlineTitle: o['customGuidesInlineTitle'],
        allowExportReviews: o['allowExportReviews'],
        decoupleProductAndReportAccess: o['decoupleProductAndReportAccess'],
        showCrmCompanies: o['showCrmCompanies'],
        showCrmTasks: o['showCrmTasks'],
        showCustomForms: o['showCustomForms'],
        showAutomations: o['showAutomations'],
        showCrmOpportunities: o['showCrmOpportunities'],
        showDynamicLists: o['showDynamicLists'],
        showLeaderboard: o['showLeaderboard'],
        showAiAssistant: o['showAiAssistant'],
        showLeadScoring: o['showLeadScoring'],
        showInboxWidgetFooterContent: o['showInboxWidgetFooterContent'],
        showCrmCustomObjects: o['showCrmCustomObjects'],
        featuredPackageIds: ((_k = o['featuredPackageIds']) !== null && _k !== void 0 ? _k : []).map(e => e),
        executiveReportConfiguration: o['executiveReportConfiguration'] ? executiveReportConfigurationFromJson(o['executiveReportConfiguration']) : undefined,
        showAiPreviewOnSignup: o['showAiPreviewOnSignup'],
        showPromotions: o['showPromotions'],
        smbCanEditAutomations: o['smbCanEditAutomations'],
        showFeaturedTemplates: o['showFeaturedTemplates'],
        smbShowSystemAutomationTemplates: o['smbShowSystemAutomationTemplates'],
        showPayments: o['showPayments'],
        showAiWorkCard: o['showAiWorkCard'],
        showProductUpgradeCards: o['showProductUpgradeCards'],
        hideSalespersonContact: o['hideSalespersonContact'],
        showSupportCenterLink: o['showSupportCenterLink'],
        supportCenterLinkUrl: o['supportCenterLinkUrl'],
        supportCenterLinkLabel: o['supportCenterLinkLabel'],
        contactUsModalDescription: o['contactUsModalDescription'],
        assistantVisibilityConfiguration: o['assistantVisibilityConfiguration'] ? assistantVisibilityConfigurationFromJson(o['assistantVisibilityConfiguration']) : undefined,
    };
}
export function getBusinessCenterMarketConfigurationRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    return o;
}
export function getBusinessCenterMarketConfigurationRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getBusinessCenterMarketConfigurationResponseToJson(m) {
    const o = {};
    if (m.marketConfiguration !== undefined)
        o['marketConfiguration'] = businessCenterMarketConfigurationToJson(m.marketConfiguration);
    return o;
}
export function getBusinessCenterMarketConfigurationResponseFromJson(o) {
    return {
        marketConfiguration: o['marketConfiguration'] ? businessCenterMarketConfigurationFromJson(o['marketConfiguration']) : undefined,
    };
}
export function updateBusinessCenterMarketConfigurationRequestToJson(m) {
    const o = {};
    if (m.marketConfiguration !== undefined)
        o['marketConfiguration'] = businessCenterMarketConfigurationToJson(m.marketConfiguration);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateBusinessCenterMarketConfigurationRequestFromJson(o) {
    return {
        marketConfiguration: o['marketConfiguration'] ? businessCenterMarketConfigurationFromJson(o['marketConfiguration']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function updateBusinessCenterMarketConfigurationResponseToJson(m) {
    const o = {};
    if (m.marketConfiguration !== undefined)
        o['marketConfiguration'] = businessCenterMarketConfigurationToJson(m.marketConfiguration);
    return o;
}
export function updateBusinessCenterMarketConfigurationResponseFromJson(o) {
    return {
        marketConfiguration: o['marketConfiguration'] ? businessCenterMarketConfigurationFromJson(o['marketConfiguration']) : undefined,
    };
}
export function toolkitDataToJson(m) {
    const o = {};
    if (m.sku !== undefined)
        o['sku'] = m.sku;
    if (m.limit !== undefined)
        o['limit'] = m.limit;
    return o;
}
export function toolkitDataFromJson(o) {
    var _a, _b;
    return {
        sku: (_a = o['sku']) !== null && _a !== void 0 ? _a : '',
        limit: (_b = o['limit']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function tierUsageLimitsToJson(m) {
    const o = {};
    if (m.teamMembers !== undefined)
        o['teamMembers'] = m.teamMembers;
    if (m.emailsPerMonth !== undefined)
        o['emailsPerMonth'] = m.emailsPerMonth;
    if (m.annualFee !== undefined)
        o['annualFee'] = m.annualFee;
    if (m.newSeatCost !== undefined)
        o['newSeatCost'] = m.newSeatCost;
    if (m.wholesaleDiscount !== undefined)
        o['wholesaleDiscount'] = m.wholesaleDiscount;
    if (m.snapshots !== undefined)
        o['snapshots'] = m.snapshots;
    if (m.toolkits !== undefined)
        o['toolkits'] = m.toolkits;
    if (m.toolkitData !== undefined) {
        o['toolkitData'] = m.toolkitData.map(e => toolkitDataToJson(e));
    }
    if (m.monthlyFee !== undefined)
        o['monthlyFee'] = m.monthlyFee;
    if (m.onboardingFee !== undefined)
        o['onboardingFee'] = m.onboardingFee;
    if (m.automationsPerMonth !== undefined)
        o['automationsPerMonth'] = m.automationsPerMonth;
    return o;
}
export function tierUsageLimitsFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        teamMembers: (_a = o['teamMembers']) !== null && _a !== void 0 ? _a : 0,
        emailsPerMonth: (_b = o['emailsPerMonth']) !== null && _b !== void 0 ? _b : 0,
        annualFee: (_c = o['annualFee']) !== null && _c !== void 0 ? _c : 0,
        newSeatCost: (_d = o['newSeatCost']) !== null && _d !== void 0 ? _d : 0,
        wholesaleDiscount: (_e = o['wholesaleDiscount']) !== null && _e !== void 0 ? _e : 0,
        snapshots: (_f = o['snapshots']) !== null && _f !== void 0 ? _f : 0,
        toolkits: (_g = o['toolkits']) !== null && _g !== void 0 ? _g : 0,
        toolkitData: ((_h = o['toolkitData']) !== null && _h !== void 0 ? _h : []).map(e => toolkitDataFromJson(e)),
        monthlyFee: (_j = o['monthlyFee']) !== null && _j !== void 0 ? _j : 0,
        onboardingFee: (_k = o['onboardingFee']) !== null && _k !== void 0 ? _k : 0,
        automationsPerMonth: (_l = o['automationsPerMonth']) !== null && _l !== void 0 ? _l : 0,
    };
}
export function appIdentifierToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    return o;
}
export function appIdentifierFromJson(o) {
    var _a, _b;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        editionId: (_b = o['editionId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function subscriptionUpdateToJson(m) {
    const o = {};
    if (m.salesOrderAppId !== undefined)
        o['salesOrderAppId'] = appIdentifierToJson(m.salesOrderAppId);
    if (m.subscriptionSkus !== undefined) {
        o['subscriptionSkus'] = m.subscriptionSkus.map(e => e);
    }
    if (m.oneTimeSubscriptionSkus !== undefined) {
        o['oneTimeSubscriptionSkus'] = m.oneTimeSubscriptionSkus.map(e => e);
    }
    if (m.monthlySubscriptionSkus !== undefined) {
        o['monthlySubscriptionSkus'] = m.monthlySubscriptionSkus.map(e => e);
    }
    return o;
}
export function subscriptionUpdateFromJson(o) {
    var _a, _b, _c;
    return {
        salesOrderAppId: o['salesOrderAppId'] ? appIdentifierFromJson(o['salesOrderAppId']) : undefined,
        subscriptionSkus: ((_a = o['subscriptionSkus']) !== null && _a !== void 0 ? _a : []).map(e => e),
        oneTimeSubscriptionSkus: ((_b = o['oneTimeSubscriptionSkus']) !== null && _b !== void 0 ? _b : []).map(e => e),
        monthlySubscriptionSkus: ((_c = o['monthlySubscriptionSkus']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function subscriptionTierToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.partnerModelLevel !== undefined)
        o['partnerModelLevel'] = m.partnerModelLevel;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.pricingPlanId !== undefined)
        o['pricingPlanId'] = m.pricingPlanId;
    if (m.tierVersion !== undefined)
        o['tierVersion'] = m.tierVersion;
    if (m.archived !== undefined)
        o['archived'] = m.archived;
    if (m.enabledFeatures !== undefined) {
        o['enabledFeatures'] = m.enabledFeatures.map(e => e);
    }
    if (m.allowTrials !== undefined)
        o['allowTrials'] = m.allowTrials;
    if (m.rank !== undefined)
        o['rank'] = m.rank;
    if (m.usageLimits !== undefined)
        o['usageLimits'] = tierUsageLimitsToJson(m.usageLimits);
    if (m.subscriptionUpdate !== undefined)
        o['subscriptionUpdate'] = subscriptionUpdateToJson(m.subscriptionUpdate);
    if (m.allowSelfUpgrade !== undefined)
        o['allowSelfUpgrade'] = m.allowSelfUpgrade;
    if (m.allowFreeTrials !== undefined)
        o['allowFreeTrials'] = m.allowFreeTrials;
    return o;
}
export function subscriptionTierFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        partnerModelLevel: (_b = o['partnerModelLevel']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        pricingPlanId: (_d = o['pricingPlanId']) !== null && _d !== void 0 ? _d : '',
        tierVersion: (_e = o['tierVersion']) !== null && _e !== void 0 ? _e : '',
        archived: (_f = o['archived']) !== null && _f !== void 0 ? _f : false,
        enabledFeatures: ((_g = o['enabledFeatures']) !== null && _g !== void 0 ? _g : []).map(e => e),
        allowTrials: (_h = o['allowTrials']) !== null && _h !== void 0 ? _h : false,
        rank: (_j = o['rank']) !== null && _j !== void 0 ? _j : 0,
        usageLimits: o['usageLimits'] ? tierUsageLimitsFromJson(o['usageLimits']) : undefined,
        subscriptionUpdate: o['subscriptionUpdate'] ? subscriptionUpdateFromJson(o['subscriptionUpdate']) : undefined,
        allowSelfUpgrade: (_k = o['allowSelfUpgrade']) !== null && _k !== void 0 ? _k : false,
        allowFreeTrials: (_l = o['allowFreeTrials']) !== null && _l !== void 0 ? _l : false,
    };
}
export function getSubscriptionTierRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getSubscriptionTierRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getSubscriptionTierResponseToJson(m) {
    const o = {};
    if (m.subscriptionTier !== undefined)
        o['subscriptionTier'] = subscriptionTierToJson(m.subscriptionTier);
    return o;
}
export function getSubscriptionTierResponseFromJson(o) {
    return {
        subscriptionTier: o['subscriptionTier'] ? subscriptionTierFromJson(o['subscriptionTier']) : undefined,
    };
}
export function listSubscriptionTiersRequestToJson(m) {
    const o = {};
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function listSubscriptionTiersRequestFromJson(o) {
    var _a, _b, _c;
    return {
        pageSize: (_a = o['pageSize']) !== null && _a !== void 0 ? _a : 0,
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : 0,
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listSubscriptionTiersResponseToJson(m) {
    const o = {};
    if (m.subscriptionTier !== undefined) {
        o['subscriptionTier'] = m.subscriptionTier.map(e => subscriptionTierToJson(e));
    }
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function listSubscriptionTiersResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        subscriptionTier: ((_a = o['subscriptionTier']) !== null && _a !== void 0 ? _a : []).map(e => subscriptionTierFromJson(e)),
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : 0,
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
        totalResults: (_d = o['totalResults']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function tierCostConstraintToJson(m) {
    const o = {};
    if (m.cost !== undefined)
        o['cost'] = m.cost;
    if (m.currencyCode !== undefined)
        o['currencyCode'] = m.currencyCode;
    if (m.isFree !== undefined)
        o['isFree'] = m.isFree;
    return o;
}
export function tierCostConstraintFromJson(o) {
    var _a, _b, _c;
    return {
        cost: (_a = o['cost']) !== null && _a !== void 0 ? _a : 0,
        currencyCode: (_b = o['currencyCode']) !== null && _b !== void 0 ? _b : '',
        isFree: (_c = o['isFree']) !== null && _c !== void 0 ? _c : false,
    };
}
export function countConstraintToJson(m) {
    const o = {};
    if (m.included !== undefined)
        o['included'] = m.included;
    if (m.additionalCost !== undefined)
        o['additionalCost'] = tierCostConstraintToJson(m.additionalCost);
    return o;
}
export function countConstraintFromJson(o) {
    var _a;
    return {
        included: (_a = o['included']) !== null && _a !== void 0 ? _a : 0,
        additionalCost: o['additionalCost'] ? tierCostConstraintFromJson(o['additionalCost']) : undefined,
    };
}
export function comparisonCellToJson(m) {
    const o = {};
    if (m.value !== undefined) {
        if (m.value.type === 'count') {
            o['count'] = countConstraintToJson(m.value.count);
        }
        if (m.value.type === 'isIncluded') {
            o['isIncluded'] = m.value.isIncluded;
        }
        if (m.value.type === 'isLimited') {
            o['isLimited'] = m.value.isLimited;
        }
    }
    else {
        if (m.count !== undefined)
            o['count'] = countConstraintToJson(m.count);
        if (m.isIncluded !== undefined)
            o['isIncluded'] = m.isIncluded;
        if (m.isLimited !== undefined)
            o['isLimited'] = m.isLimited;
    }
    return o;
}
export function comparisonCellFromJson(o) {
    return {
        value: (() => {
            if (o['count'] !== undefined)
                return { type: 'count', count: o['count'] ? countConstraintFromJson(o['count']) : undefined };
            if (o['isIncluded'] !== undefined)
                return { type: 'isIncluded', isIncluded: o['isIncluded'] };
            if (o['isLimited'] !== undefined)
                return { type: 'isLimited', isLimited: o['isLimited'] };
            return undefined;
        })(),
        count: o['count'] !== undefined ? o['count'] ? countConstraintFromJson(o['count']) : undefined : undefined,
        isIncluded: o['isIncluded'] !== undefined ? o['isIncluded'] : undefined,
        isLimited: o['isLimited'] !== undefined ? o['isLimited'] : undefined,
    };
}
export function comparisonRowToJson(m) {
    const o = {};
    if (m.rowId !== undefined)
        o['rowId'] = m.rowId;
    if (m.sectionId !== undefined)
        o['sectionId'] = m.sectionId;
    if (m.cells !== undefined) {
        o['cells'] = m.cells.map(e => comparisonCellToJson(e));
    }
    return o;
}
export function comparisonRowFromJson(o) {
    var _a, _b, _c;
    return {
        rowId: (_a = o['rowId']) !== null && _a !== void 0 ? _a : '',
        sectionId: (_b = o['sectionId']) !== null && _b !== void 0 ? _b : '',
        cells: ((_c = o['cells']) !== null && _c !== void 0 ? _c : []).map(e => comparisonCellFromJson(e)),
    };
}
export function compareSubscriptionTiersRequestToJson(m) {
    const o = {};
    if (m.subscriptionTierIds !== undefined) {
        o['subscriptionTierIds'] = m.subscriptionTierIds.map(e => e);
    }
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function compareSubscriptionTiersRequestFromJson(o) {
    var _a, _b;
    return {
        subscriptionTierIds: ((_a = o['subscriptionTierIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function compareSubscriptionTiersResponseToJson(m) {
    const o = {};
    if (m.rows !== undefined) {
        o['rows'] = m.rows.map(e => comparisonRowToJson(e));
    }
    return o;
}
export function compareSubscriptionTiersResponseFromJson(o) {
    var _a;
    return {
        rows: ((_a = o['rows']) !== null && _a !== void 0 ? _a : []).map(e => comparisonRowFromJson(e)),
    };
}
export function getTermsOfServiceRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.feature !== undefined)
        o['feature'] = m.feature;
    return o;
}
export function getTermsOfServiceRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        feature: (_c = o['feature']) !== null && _c !== void 0 ? _c : '',
    };
}
export function termsOfServiceToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.termsOfService !== undefined)
        o['termsOfService'] = m.termsOfService;
    if (m.product !== undefined)
        o['product'] = m.product;
    if (m.language !== undefined)
        o['language'] = m.language;
    if (m.createdOn !== undefined)
        o['createdOn'] = m.createdOn.toISOString();
    if (m.feature !== undefined)
        o['feature'] = m.feature;
    return o;
}
export function termsOfServiceFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        termsOfService: (_c = o['termsOfService']) !== null && _c !== void 0 ? _c : '',
        product: (_d = o['product']) !== null && _d !== void 0 ? _d : '',
        language: (_e = o['language']) !== null && _e !== void 0 ? _e : '',
        createdOn: o['createdOn'] ? new Date(o['createdOn']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        feature: (_f = o['feature']) !== null && _f !== void 0 ? _f : '',
    };
}
export function getTermsOfServiceResponseToJson(m) {
    const o = {};
    if (m.termsOfService !== undefined)
        o['termsOfService'] = termsOfServiceToJson(m.termsOfService);
    return o;
}
export function getTermsOfServiceResponseFromJson(o) {
    return {
        termsOfService: o['termsOfService'] ? termsOfServiceFromJson(o['termsOfService']) : undefined,
    };
}
export function createTermsOfServiceRequestToJson(m) {
    const o = {};
    if (m.termsOfService !== undefined)
        o['termsOfService'] = termsOfServiceToJson(m.termsOfService);
    return o;
}
export function createTermsOfServiceRequestFromJson(o) {
    return {
        termsOfService: o['termsOfService'] ? termsOfServiceFromJson(o['termsOfService']) : undefined,
    };
}
export function userAgreementTermsOfServiceToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.accepted !== undefined)
        o['accepted'] = m.accepted;
    if (m.acceptedAt !== undefined)
        o['acceptedAt'] = m.acceptedAt.toISOString();
    if (m.feature !== undefined)
        o['feature'] = m.feature;
    return o;
}
export function userAgreementTermsOfServiceFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        accepted: (_c = o['accepted']) !== null && _c !== void 0 ? _c : false,
        acceptedAt: o['acceptedAt'] ? new Date(o['acceptedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        feature: (_d = o['feature']) !== null && _d !== void 0 ? _d : '',
    };
}
export function getUserAgreementTermsOfServiceRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.feature !== undefined)
        o['feature'] = m.feature;
    return o;
}
export function getUserAgreementTermsOfServiceRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        feature: (_c = o['feature']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getUserAgreementTermsOfServiceResponseToJson(m) {
    const o = {};
    if (m.userAgreementTermsOfService !== undefined)
        o['userAgreementTermsOfService'] = userAgreementTermsOfServiceToJson(m.userAgreementTermsOfService);
    return o;
}
export function getUserAgreementTermsOfServiceResponseFromJson(o) {
    return {
        userAgreementTermsOfService: o['userAgreementTermsOfService'] ? userAgreementTermsOfServiceFromJson(o['userAgreementTermsOfService']) : undefined,
    };
}
export function setUserAgreementTermsOfServiceRequestToJson(m) {
    const o = {};
    if (m.userAgreementTermsOfService !== undefined)
        o['userAgreementTermsOfService'] = userAgreementTermsOfServiceToJson(m.userAgreementTermsOfService);
    return o;
}
export function setUserAgreementTermsOfServiceRequestFromJson(o) {
    return {
        userAgreementTermsOfService: o['userAgreementTermsOfService'] ? userAgreementTermsOfServiceFromJson(o['userAgreementTermsOfService']) : undefined,
    };
}
export function pagingRequestMetadataToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function pagingRequestMetadataFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function pagingResponseMetadataToJson(m) {
    const o = {};
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.pageNumber !== undefined)
        o['pageNumber'] = m.pageNumber;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function pagingResponseMetadataFromJson(o) {
    var _a, _b, _c, _d;
    return {
        nextCursor: (_a = o['nextCursor']) !== null && _a !== void 0 ? _a : '',
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
        pageNumber: (_c = o['pageNumber']) !== null && _c !== void 0 ? _c : 0,
        totalResults: (_d = o['totalResults']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function replaceWizardStatusRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.activeStep !== undefined)
        o['activeStep'] = m.activeStep;
    return o;
}
export function replaceWizardStatusRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        activeStep: (_c = o['activeStep']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getWizardStatusRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function getWizardStatusRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function wizardStatusToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.activeStep !== undefined)
        o['activeStep'] = m.activeStep;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function wizardStatusFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        activeStep: (_c = o['activeStep']) !== null && _c !== void 0 ? _c : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function getWizardStatusResponseToJson(m) {
    const o = {};
    if (m.wizardStatus !== undefined)
        o['wizardStatus'] = wizardStatusToJson(m.wizardStatus);
    return o;
}
export function getWizardStatusResponseFromJson(o) {
    return {
        wizardStatus: o['wizardStatus'] ? wizardStatusFromJson(o['wizardStatus']) : undefined,
    };
}
export function listWizardStatusRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.paging !== undefined)
        o['paging'] = pagingRequestMetadataToJson(m.paging);
    return o;
}
export function listWizardStatusRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        paging: o['paging'] ? pagingRequestMetadataFromJson(o['paging']) : undefined,
    };
}
export function pagedResponseDataToJson(m) {
    const o = {};
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function pagedResponseDataFromJson(o) {
    var _a, _b;
    return {
        nextCursor: (_a = o['nextCursor']) !== null && _a !== void 0 ? _a : '',
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listWizardStatusResponseToJson(m) {
    const o = {};
    if (m.wizardStatuses !== undefined) {
        o['wizardStatuses'] = m.wizardStatuses.map(e => wizardStatusToJson(e));
    }
    if (m.paging !== undefined)
        o['paging'] = pagedResponseDataToJson(m.paging);
    return o;
}
export function listWizardStatusResponseFromJson(o) {
    var _a;
    return {
        wizardStatuses: ((_a = o['wizardStatuses']) !== null && _a !== void 0 ? _a : []).map(e => wizardStatusFromJson(e)),
        paging: o['paging'] ? pagedResponseDataFromJson(o['paging']) : undefined,
    };
}
export function deleteWizardStatusRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function deleteWizardStatusRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function customerSurveyResponseToJson(m) {
    const o = {};
    if (m.customerSurveyResponseId !== undefined)
        o['customerSurveyResponseId'] = m.customerSurveyResponseId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.rating !== undefined)
        o['rating'] = m.rating;
    if (m.feedback !== undefined)
        o['feedback'] = m.feedback;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function customerSurveyResponseFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        customerSurveyResponseId: (_a = o['customerSurveyResponseId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        marketId: (_c = o['marketId']) !== null && _c !== void 0 ? _c : '',
        accountGroupId: (_d = o['accountGroupId']) !== null && _d !== void 0 ? _d : '',
        userId: (_e = o['userId']) !== null && _e !== void 0 ? _e : '',
        rating: (_f = o['rating']) !== null && _f !== void 0 ? _f : 0,
        feedback: (_g = o['feedback']) !== null && _g !== void 0 ? _g : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function customerSurveyPagedResponseMetadataToJson(m) {
    const o = {};
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function customerSurveyPagedResponseMetadataFromJson(o) {
    var _a, _b;
    return {
        nextCursor: (_a = o['nextCursor']) !== null && _a !== void 0 ? _a : '',
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
    };
}
export function customerSurveyPagedRequestOptionsToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function customerSurveyPagedRequestOptionsFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function customerSurveyRespondRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.rating !== undefined)
        o['rating'] = m.rating;
    if (m.email !== undefined)
        o['email'] = m.email;
    return o;
}
export function customerSurveyRespondRequestFromJson(o) {
    var _a, _b, _c;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        rating: (_b = o['rating']) !== null && _b !== void 0 ? _b : 0,
        email: (_c = o['email']) !== null && _c !== void 0 ? _c : '',
    };
}
export function customerSurveyRespondResponseToJson(m) {
    const o = {};
    if (m.customerSurveyResponseId !== undefined)
        o['customerSurveyResponseId'] = m.customerSurveyResponseId;
    return o;
}
export function customerSurveyRespondResponseFromJson(o) {
    var _a;
    return {
        customerSurveyResponseId: (_a = o['customerSurveyResponseId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function customerSurveyAddFeedbackRequestToJson(m) {
    const o = {};
    if (m.customerSurveyResponseId !== undefined)
        o['customerSurveyResponseId'] = m.customerSurveyResponseId;
    if (m.feedback !== undefined)
        o['feedback'] = m.feedback;
    if (m.email !== undefined)
        o['email'] = m.email;
    return o;
}
export function customerSurveyAddFeedbackRequestFromJson(o) {
    var _a, _b, _c;
    return {
        customerSurveyResponseId: (_a = o['customerSurveyResponseId']) !== null && _a !== void 0 ? _a : '',
        feedback: (_b = o['feedback']) !== null && _b !== void 0 ? _b : '',
        email: (_c = o['email']) !== null && _c !== void 0 ? _c : '',
    };
}
export function customerSurveyListResponsesRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = customerSurveyPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function customerSurveyListResponsesRequestFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? customerSurveyPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function customerSurveyListResponsesResponseToJson(m) {
    const o = {};
    if (m.responses !== undefined) {
        o['responses'] = m.responses.map(e => customerSurveyResponseToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = customerSurveyPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function customerSurveyListResponsesResponseFromJson(o) {
    var _a;
    return {
        responses: ((_a = o['responses']) !== null && _a !== void 0 ? _a : []).map(e => customerSurveyResponseFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? customerSurveyPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function brandingV2ToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.faviconUrl !== undefined)
        o['faviconUrl'] = m.faviconUrl;
    if (m.shortcutIconUrl !== undefined)
        o['shortcutIconUrl'] = m.shortcutIconUrl;
    if (m.logoUrl !== undefined)
        o['logoUrl'] = m.logoUrl;
    if (m.uiTheme !== undefined)
        o['uiTheme'] = m.uiTheme;
    if (m.primaryColor !== undefined)
        o['primaryColor'] = m.primaryColor;
    if (m.marketOverrides !== undefined) {
        o['marketOverrides'] = m.marketOverrides.map(e => e);
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.darkModeLogoUrl !== undefined)
        o['darkModeLogoUrl'] = m.darkModeLogoUrl;
    if (m.businessAppUiTheme !== undefined)
        o['businessAppUiTheme'] = m.businessAppUiTheme;
    return o;
}
export function brandingV2FromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        faviconUrl: (_c = o['faviconUrl']) !== null && _c !== void 0 ? _c : '',
        shortcutIconUrl: (_d = o['shortcutIconUrl']) !== null && _d !== void 0 ? _d : '',
        logoUrl: (_e = o['logoUrl']) !== null && _e !== void 0 ? _e : '',
        uiTheme: (_f = o['uiTheme']) !== null && _f !== void 0 ? _f : 'UI_THEME_INVALID',
        primaryColor: (_g = o['primaryColor']) !== null && _g !== void 0 ? _g : '',
        marketOverrides: ((_h = o['marketOverrides']) !== null && _h !== void 0 ? _h : []).map(e => e),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        name: (_j = o['name']) !== null && _j !== void 0 ? _j : '',
        darkModeLogoUrl: (_k = o['darkModeLogoUrl']) !== null && _k !== void 0 ? _k : '',
        businessAppUiTheme: (_l = o['businessAppUiTheme']) !== null && _l !== void 0 ? _l : 'UI_THEME_INVALID',
    };
}
export function getFreeTrialStatusRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getFreeTrialStatusRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getFreeTrialStatusResponseToJson(m) {
    const o = {};
    if (m.onFreeTrial !== undefined)
        o['onFreeTrial'] = m.onFreeTrial;
    if (m.freeTrialEnd !== undefined)
        o['freeTrialEnd'] = m.freeTrialEnd.toISOString();
    return o;
}
export function getFreeTrialStatusResponseFromJson(o) {
    var _a;
    return {
        onFreeTrial: (_a = o['onFreeTrial']) !== null && _a !== void 0 ? _a : false,
        freeTrialEnd: o['freeTrialEnd'] ? new Date(o['freeTrialEnd']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function getFreeTrialRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function getFreeTrialRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function getFreeTrialResponseToJson(m) {
    const o = {};
    if (m.trialStart !== undefined)
        o['trialStart'] = m.trialStart.toISOString();
    if (m.trialEnd !== undefined)
        o['trialEnd'] = m.trialEnd.toISOString();
    if (m.onFreeTrial !== undefined)
        o['onFreeTrial'] = m.onFreeTrial;
    if (m.actionRequiredStatus !== undefined)
        o['actionRequiredStatus'] = m.actionRequiredStatus;
    return o;
}
export function getFreeTrialResponseFromJson(o) {
    var _a, _b;
    return {
        trialStart: o['trialStart'] ? new Date(o['trialStart']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        trialEnd: o['trialEnd'] ? new Date(o['trialEnd']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        onFreeTrial: (_a = o['onFreeTrial']) !== null && _a !== void 0 ? _a : false,
        actionRequiredStatus: (_b = o['actionRequiredStatus']) !== null && _b !== void 0 ? _b : '',
    };
}
export function updateFreeTrialActionRequiredStatusMutationToJson(m) {
    const o = {};
    if (m.actionRequiredStatus !== undefined)
        o['actionRequiredStatus'] = m.actionRequiredStatus;
    return o;
}
export function updateFreeTrialActionRequiredStatusMutationFromJson(o) {
    var _a;
    return {
        actionRequiredStatus: (_a = o['actionRequiredStatus']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateCancelFreeTrialReasonMutationToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.cancelReason !== undefined)
        o['cancelReason'] = m.cancelReason;
    if (m.additionalComment !== undefined)
        o['additionalComment'] = m.additionalComment;
    return o;
}
export function updateCancelFreeTrialReasonMutationFromJson(o) {
    var _a, _b, _c;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
        cancelReason: (_b = o['cancelReason']) !== null && _b !== void 0 ? _b : '',
        additionalComment: (_c = o['additionalComment']) !== null && _c !== void 0 ? _c : '',
    };
}
export function updateFreeTrialMutationToJson(m) {
    const o = {};
    if (m.mutation !== undefined) {
        if (m.mutation.type === 'cancelFreeTrialReason') {
            o['cancelFreeTrialReason'] = updateCancelFreeTrialReasonMutationToJson(m.mutation.cancelFreeTrialReason);
        }
        if (m.mutation.type === 'actionRequiredStatus') {
            o['actionRequiredStatus'] = updateFreeTrialActionRequiredStatusMutationToJson(m.mutation.actionRequiredStatus);
        }
    }
    else {
        if (m.cancelFreeTrialReason !== undefined)
            o['cancelFreeTrialReason'] = updateCancelFreeTrialReasonMutationToJson(m.cancelFreeTrialReason);
        if (m.actionRequiredStatus !== undefined)
            o['actionRequiredStatus'] = updateFreeTrialActionRequiredStatusMutationToJson(m.actionRequiredStatus);
    }
    return o;
}
export function updateFreeTrialMutationFromJson(o) {
    return {
        mutation: (() => {
            if (o['cancelFreeTrialReason'] !== undefined)
                return { type: 'cancelFreeTrialReason', cancelFreeTrialReason: o['cancelFreeTrialReason'] ? updateCancelFreeTrialReasonMutationFromJson(o['cancelFreeTrialReason']) : undefined };
            if (o['actionRequiredStatus'] !== undefined)
                return { type: 'actionRequiredStatus', actionRequiredStatus: o['actionRequiredStatus'] ? updateFreeTrialActionRequiredStatusMutationFromJson(o['actionRequiredStatus']) : undefined };
            return undefined;
        })(),
        cancelFreeTrialReason: o['cancelFreeTrialReason'] !== undefined ? o['cancelFreeTrialReason'] ? updateCancelFreeTrialReasonMutationFromJson(o['cancelFreeTrialReason']) : undefined : undefined,
        actionRequiredStatus: o['actionRequiredStatus'] !== undefined ? o['actionRequiredStatus'] ? updateFreeTrialActionRequiredStatusMutationFromJson(o['actionRequiredStatus']) : undefined : undefined,
    };
}
export function updateFreeTrialRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.mutations !== undefined) {
        o['mutations'] = m.mutations.map(e => updateFreeTrialMutationToJson(e));
    }
    return o;
}
export function updateFreeTrialRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        mutations: ((_b = o['mutations']) !== null && _b !== void 0 ? _b : []).map(e => updateFreeTrialMutationFromJson(e)),
    };
}
export function partnerModelToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.subscriptionTierId !== undefined)
        o['subscriptionTierId'] = m.subscriptionTierId;
    if (m.premiumSupport !== undefined)
        o['premiumSupport'] = m.premiumSupport;
    if (m.standardPrioritySupport !== undefined)
        o['standardPrioritySupport'] = m.standardPrioritySupport;
    if (m.priorityChatSupport !== undefined)
        o['priorityChatSupport'] = m.priorityChatSupport;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.addressLineOne !== undefined)
        o['addressLineOne'] = m.addressLineOne;
    if (m.addressLineTwo !== undefined)
        o['addressLineTwo'] = m.addressLineTwo;
    if (m.city !== undefined)
        o['city'] = m.city;
    if (m.stateCode !== undefined)
        o['stateCode'] = m.stateCode;
    if (m.countryCode !== undefined)
        o['countryCode'] = m.countryCode;
    if (m.postalCode !== undefined)
        o['postalCode'] = m.postalCode;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.website !== undefined)
        o['website'] = m.website;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function partnerModelFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        subscriptionTierId: (_b = o['subscriptionTierId']) !== null && _b !== void 0 ? _b : '',
        premiumSupport: (_c = o['premiumSupport']) !== null && _c !== void 0 ? _c : false,
        standardPrioritySupport: (_d = o['standardPrioritySupport']) !== null && _d !== void 0 ? _d : false,
        priorityChatSupport: (_e = o['priorityChatSupport']) !== null && _e !== void 0 ? _e : false,
        name: (_f = o['name']) !== null && _f !== void 0 ? _f : '',
        addressLineOne: (_g = o['addressLineOne']) !== null && _g !== void 0 ? _g : '',
        addressLineTwo: (_h = o['addressLineTwo']) !== null && _h !== void 0 ? _h : '',
        city: (_j = o['city']) !== null && _j !== void 0 ? _j : '',
        stateCode: (_k = o['stateCode']) !== null && _k !== void 0 ? _k : '',
        countryCode: (_l = o['countryCode']) !== null && _l !== void 0 ? _l : '',
        postalCode: (_m = o['postalCode']) !== null && _m !== void 0 ? _m : '',
        email: (_o = o['email']) !== null && _o !== void 0 ? _o : '',
        phoneNumber: (_p = o['phoneNumber']) !== null && _p !== void 0 ? _p : '',
        website: (_q = o['website']) !== null && _q !== void 0 ? _q : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function navigationItemChildToJson(m) {
    const o = {};
    if (m.locked !== undefined)
        o['locked'] = m.locked;
    if (m.link !== undefined)
        o['link'] = m.link;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.tabId !== undefined)
        o['tabId'] = m.tabId;
    if (m.popOut !== undefined)
        o['popOut'] = m.popOut;
    if (m.ngRoute !== undefined)
        o['ngRoute'] = m.ngRoute;
    if (m.subsectionHeader !== undefined)
        o['subsectionHeader'] = m.subsectionHeader;
    if (m.svgIcon !== undefined)
        o['svgIcon'] = m.svgIcon;
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.badge !== undefined)
        o['badge'] = m.badge;
    if (m.i18nKey !== undefined)
        o['i18nKey'] = m.i18nKey;
    return o;
}
export function navigationItemChildFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        locked: (_a = o['locked']) !== null && _a !== void 0 ? _a : false,
        link: (_b = o['link']) !== null && _b !== void 0 ? _b : '',
        title: (_c = o['title']) !== null && _c !== void 0 ? _c : '',
        tabId: (_d = o['tabId']) !== null && _d !== void 0 ? _d : '',
        popOut: (_e = o['popOut']) !== null && _e !== void 0 ? _e : false,
        ngRoute: (_f = o['ngRoute']) !== null && _f !== void 0 ? _f : false,
        subsectionHeader: (_g = o['subsectionHeader']) !== null && _g !== void 0 ? _g : '',
        svgIcon: (_h = o['svgIcon']) !== null && _h !== void 0 ? _h : false,
        icon: (_j = o['icon']) !== null && _j !== void 0 ? _j : '',
        badge: (_k = o['badge']) !== null && _k !== void 0 ? _k : 'NAVIGATION_ITEM_BADGE_NONE',
        i18nKey: (_l = o['i18nKey']) !== null && _l !== void 0 ? _l : '',
    };
}
export function navigationItemToJson(m) {
    const o = {};
    if (m.locked !== undefined)
        o['locked'] = m.locked;
    if (m.nestedTabs !== undefined) {
        o['nestedTabs'] = m.nestedTabs.map(e => navigationItemChildToJson(e));
    }
    if (m.link !== undefined)
        o['link'] = m.link;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.tabId !== undefined)
        o['tabId'] = m.tabId;
    if (m.popOut !== undefined)
        o['popOut'] = m.popOut;
    if (m.ngRoute !== undefined)
        o['ngRoute'] = m.ngRoute;
    if (m.subsectionHeader !== undefined)
        o['subsectionHeader'] = m.subsectionHeader;
    if (m.svgIcon !== undefined)
        o['svgIcon'] = m.svgIcon;
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.badge !== undefined)
        o['badge'] = m.badge;
    if (m.i18nKey !== undefined)
        o['i18nKey'] = m.i18nKey;
    return o;
}
export function navigationItemFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        locked: (_a = o['locked']) !== null && _a !== void 0 ? _a : false,
        nestedTabs: ((_b = o['nestedTabs']) !== null && _b !== void 0 ? _b : []).map(e => navigationItemChildFromJson(e)),
        link: (_c = o['link']) !== null && _c !== void 0 ? _c : '',
        title: (_d = o['title']) !== null && _d !== void 0 ? _d : '',
        tabId: (_e = o['tabId']) !== null && _e !== void 0 ? _e : '',
        popOut: (_f = o['popOut']) !== null && _f !== void 0 ? _f : false,
        ngRoute: (_g = o['ngRoute']) !== null && _g !== void 0 ? _g : false,
        subsectionHeader: (_h = o['subsectionHeader']) !== null && _h !== void 0 ? _h : '',
        svgIcon: (_j = o['svgIcon']) !== null && _j !== void 0 ? _j : false,
        icon: (_k = o['icon']) !== null && _k !== void 0 ? _k : '',
        badge: (_l = o['badge']) !== null && _l !== void 0 ? _l : 'NAVIGATION_ITEM_BADGE_NONE',
        i18nKey: (_m = o['i18nKey']) !== null && _m !== void 0 ? _m : '',
    };
}
export function taskManagerConfigurationToJson(m) {
    const o = {};
    if (m.tmShowInbox !== undefined)
        o['tmShowInbox'] = m.tmShowInbox;
    return o;
}
export function taskManagerConfigurationFromJson(o) {
    var _a;
    return {
        tmShowInbox: (_a = o['tmShowInbox']) !== null && _a !== void 0 ? _a : false,
    };
}
export function setTaskManagerConfigRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.config !== undefined)
        o['config'] = taskManagerConfigurationToJson(m.config);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function setTaskManagerConfigRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        config: o['config'] ? taskManagerConfigurationFromJson(o['config']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function setTaskManagerConfigResponseToJson(m) {
    const o = {};
    if (m.config !== undefined)
        o['config'] = taskManagerConfigurationToJson(m.config);
    return o;
}
export function setTaskManagerConfigResponseFromJson(o) {
    return {
        config: o['config'] ? taskManagerConfigurationFromJson(o['config']) : undefined,
    };
}
export function getTaskManagerConfigRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getTaskManagerConfigRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getTaskManagerConfigResponseToJson(m) {
    const o = {};
    if (m.config !== undefined)
        o['config'] = taskManagerConfigurationToJson(m.config);
    return o;
}
export function getTaskManagerConfigResponseFromJson(o) {
    return {
        config: o['config'] ? taskManagerConfigurationFromJson(o['config']) : undefined,
    };
}
export function marketToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function marketFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function pagedResponseMetadataToJson(m) {
    const o = {};
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function pagedResponseMetadataFromJson(o) {
    var _a, _b;
    return {
        nextCursor: (_a = o['nextCursor']) !== null && _a !== void 0 ? _a : '',
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
    };
}
export function pagedRequestOptionsToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function pagedRequestOptionsFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function uRLToJson(m) {
    const o = {};
    if (m.secure !== undefined)
        o['secure'] = m.secure;
    if (m.insecure !== undefined)
        o['insecure'] = m.insecure;
    return o;
}
export function uRLFromJson(o) {
    var _a, _b;
    return {
        secure: (_a = o['secure']) !== null && _a !== void 0 ? _a : '',
        insecure: (_b = o['insecure']) !== null && _b !== void 0 ? _b : '',
    };
}
export function themeToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.primaryColor !== undefined)
        o['primaryColor'] = m.primaryColor;
    if (m.primaryHoverColor !== undefined)
        o['primaryHoverColor'] = m.primaryHoverColor;
    if (m.primaryActiveColor !== undefined)
        o['primaryActiveColor'] = m.primaryActiveColor;
    if (m.secondaryColor !== undefined)
        o['secondaryColor'] = m.secondaryColor;
    if (m.secondaryHoverColor !== undefined)
        o['secondaryHoverColor'] = m.secondaryHoverColor;
    if (m.secondaryActiveColor !== undefined)
        o['secondaryActiveColor'] = m.secondaryActiveColor;
    if (m.focusColor !== undefined)
        o['focusColor'] = m.focusColor;
    if (m.fontColor !== undefined)
        o['fontColor'] = m.fontColor;
    if (m.fontDisabledColor !== undefined)
        o['fontDisabledColor'] = m.fontDisabledColor;
    if (m.accentsColor !== undefined)
        o['accentsColor'] = m.accentsColor;
    if (m.accentsActiveColor !== undefined)
        o['accentsActiveColor'] = m.accentsActiveColor;
    if (m.borderColor !== undefined)
        o['borderColor'] = m.borderColor;
    return o;
}
export function themeFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        primaryColor: (_b = o['primaryColor']) !== null && _b !== void 0 ? _b : '',
        primaryHoverColor: (_c = o['primaryHoverColor']) !== null && _c !== void 0 ? _c : '',
        primaryActiveColor: (_d = o['primaryActiveColor']) !== null && _d !== void 0 ? _d : '',
        secondaryColor: (_e = o['secondaryColor']) !== null && _e !== void 0 ? _e : '',
        secondaryHoverColor: (_f = o['secondaryHoverColor']) !== null && _f !== void 0 ? _f : '',
        secondaryActiveColor: (_g = o['secondaryActiveColor']) !== null && _g !== void 0 ? _g : '',
        focusColor: (_h = o['focusColor']) !== null && _h !== void 0 ? _h : '',
        fontColor: (_j = o['fontColor']) !== null && _j !== void 0 ? _j : '',
        fontDisabledColor: (_k = o['fontDisabledColor']) !== null && _k !== void 0 ? _k : '',
        accentsColor: (_l = o['accentsColor']) !== null && _l !== void 0 ? _l : '',
        accentsActiveColor: (_m = o['accentsActiveColor']) !== null && _m !== void 0 ? _m : '',
        borderColor: (_o = o['borderColor']) !== null && _o !== void 0 ? _o : '',
    };
}
export function brandingToJson(m) {
    const o = {};
    if (m.uiTheme !== undefined)
        o['uiTheme'] = m.uiTheme;
    if (m.primaryColor !== undefined)
        o['primaryColor'] = m.primaryColor;
    if (m.assets !== undefined)
        o['assets'] = brandingAssetsToJson(m.assets);
    if (m.apps !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.apps)) {
            map[k] = brandingAppToJson(v);
        }
        o['apps'] = map;
    }
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.partnerName !== undefined)
        o['partnerName'] = m.partnerName;
    if (m.theme !== undefined)
        o['theme'] = themeToJson(m.theme);
    return o;
}
export function brandingFromJson(o) {
    var _a, _b, _c, _d;
    return {
        uiTheme: (_a = o['uiTheme']) !== null && _a !== void 0 ? _a : 'Dark',
        primaryColor: (_b = o['primaryColor']) !== null && _b !== void 0 ? _b : '',
        assets: o['assets'] ? brandingAssetsFromJson(o['assets']) : undefined,
        apps: o['apps']
            ? Object.fromEntries(Object.entries(o['apps']).map(([k, v]) => [k, brandingAppFromJson(v)]))
            : {},
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        partnerName: (_d = o['partnerName']) !== null && _d !== void 0 ? _d : '',
        theme: o['theme'] ? themeFromJson(o['theme']) : undefined,
    };
}
export function brandingAssetsToJson(m) {
    const o = {};
    if (m.faviconUrl !== undefined)
        o['faviconUrl'] = uRLToJson(m.faviconUrl);
    if (m.shortcutIconUrl !== undefined)
        o['shortcutIconUrl'] = uRLToJson(m.shortcutIconUrl);
    if (m.logoUrl !== undefined)
        o['logoUrl'] = uRLToJson(m.logoUrl);
    return o;
}
export function brandingAssetsFromJson(o) {
    return {
        faviconUrl: o['faviconUrl'] ? uRLFromJson(o['faviconUrl']) : undefined,
        shortcutIconUrl: o['shortcutIconUrl'] ? uRLFromJson(o['shortcutIconUrl']) : undefined,
        logoUrl: o['logoUrl'] ? uRLFromJson(o['logoUrl']) : undefined,
    };
}
export function brandingAppToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    return o;
}
export function brandingAppFromJson(o) {
    var _a;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getBrandingRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    return o;
}
export function getBrandingRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getBrandingResponseToJson(m) {
    const o = {};
    if (m.branding !== undefined)
        o['branding'] = brandingToJson(m.branding);
    return o;
}
export function getBrandingResponseFromJson(o) {
    return {
        branding: o['branding'] ? brandingFromJson(o['branding']) : undefined,
    };
}
export function getMultiBrandingRequestToJson(m) {
    const o = {};
    if (m.requests !== undefined) {
        o['requests'] = m.requests.map(e => getBrandingRequestToJson(e));
    }
    return o;
}
export function getMultiBrandingRequestFromJson(o) {
    var _a;
    return {
        requests: ((_a = o['requests']) !== null && _a !== void 0 ? _a : []).map(e => getBrandingRequestFromJson(e)),
    };
}
export function singlePartnerMarketBrandingToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.branding !== undefined)
        o['branding'] = brandingToJson(m.branding);
    return o;
}
export function singlePartnerMarketBrandingFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        branding: o['branding'] ? brandingFromJson(o['branding']) : undefined,
    };
}
export function getMultiBrandingResponseToJson(m) {
    const o = {};
    if (m.brandings !== undefined) {
        o['brandings'] = m.brandings.map(e => singlePartnerMarketBrandingToJson(e));
    }
    return o;
}
export function getMultiBrandingResponseFromJson(o) {
    var _a;
    return {
        brandings: ((_a = o['brandings']) !== null && _a !== void 0 ? _a : []).map(e => singlePartnerMarketBrandingFromJson(e)),
    };
}
export function snapshotConfigurationToJson(m) {
    const o = {};
    if (m.ppc !== undefined)
        o['ppc'] = m.ppc;
    if (m.remarketing !== undefined)
        o['remarketing'] = m.remarketing;
    if (m.useCustomSnapshotHeader !== undefined)
        o['useCustomSnapshotHeader'] = m.useCustomSnapshotHeader;
    if (m.customSnapshotHeader !== undefined)
        o['customSnapshotHeader'] = m.customSnapshotHeader;
    if (m.useCustomSnapshotFooter !== undefined)
        o['useCustomSnapshotFooter'] = m.useCustomSnapshotFooter;
    if (m.customSnapshotFooter !== undefined)
        o['customSnapshotFooter'] = m.customSnapshotFooter;
    if (m.useCustomSnapshotPopupMessage !== undefined)
        o['useCustomSnapshotPopupMessage'] = m.useCustomSnapshotPopupMessage;
    if (m.customSnapshotPopupMessage !== undefined)
        o['customSnapshotPopupMessage'] = m.customSnapshotPopupMessage;
    if (m.allowClaimUser !== undefined)
        o['allowClaimUser'] = m.allowClaimUser;
    if (m.seoAdvertisingDataProvider !== undefined)
        o['seoAdvertisingDataProvider'] = m.seoAdvertisingDataProvider;
    if (m.snapshotReportName !== undefined)
        o['snapshotReportName'] = m.snapshotReportName;
    return o;
}
export function snapshotConfigurationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        ppc: (_a = o['ppc']) !== null && _a !== void 0 ? _a : false,
        remarketing: (_b = o['remarketing']) !== null && _b !== void 0 ? _b : false,
        useCustomSnapshotHeader: (_c = o['useCustomSnapshotHeader']) !== null && _c !== void 0 ? _c : false,
        customSnapshotHeader: (_d = o['customSnapshotHeader']) !== null && _d !== void 0 ? _d : '',
        useCustomSnapshotFooter: (_e = o['useCustomSnapshotFooter']) !== null && _e !== void 0 ? _e : false,
        customSnapshotFooter: (_f = o['customSnapshotFooter']) !== null && _f !== void 0 ? _f : '',
        useCustomSnapshotPopupMessage: (_g = o['useCustomSnapshotPopupMessage']) !== null && _g !== void 0 ? _g : false,
        customSnapshotPopupMessage: (_h = o['customSnapshotPopupMessage']) !== null && _h !== void 0 ? _h : '',
        allowClaimUser: (_j = o['allowClaimUser']) !== null && _j !== void 0 ? _j : false,
        seoAdvertisingDataProvider: (_k = o['seoAdvertisingDataProvider']) !== null && _k !== void 0 ? _k : 0,
        snapshotReportName: (_l = o['snapshotReportName']) !== null && _l !== void 0 ? _l : '',
    };
}
export function exitLinkConfigurationToJson(m) {
    const o = {};
    if (m.exitLinkText !== undefined)
        o['exitLinkText'] = m.exitLinkText;
    if (m.exitLinkUrl !== undefined)
        o['exitLinkUrl'] = m.exitLinkUrl;
    return o;
}
export function exitLinkConfigurationFromJson(o) {
    var _a, _b;
    return {
        exitLinkText: (_a = o['exitLinkText']) !== null && _a !== void 0 ? _a : '',
        exitLinkUrl: (_b = o['exitLinkUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function reputationConfigurationToJson(m) {
    const o = {};
    if (m.maxCompetitors !== undefined)
        o['maxCompetitors'] = m.maxCompetitors;
    if (m.maxServices !== undefined)
        o['maxServices'] = m.maxServices;
    if (m.addressMatchStrictness !== undefined)
        o['addressMatchStrictness'] = m.addressMatchStrictness;
    if (m.companyNameMatchStrictness !== undefined)
        o['companyNameMatchStrictness'] = m.companyNameMatchStrictness;
    if (m.websiteMatchStrictness !== undefined)
        o['websiteMatchStrictness'] = m.websiteMatchStrictness;
    return o;
}
export function reputationConfigurationFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        maxCompetitors: (_a = o['maxCompetitors']) !== null && _a !== void 0 ? _a : 0,
        maxServices: (_b = o['maxServices']) !== null && _b !== void 0 ? _b : 0,
        addressMatchStrictness: (_c = o['addressMatchStrictness']) !== null && _c !== void 0 ? _c : '',
        companyNameMatchStrictness: (_d = o['companyNameMatchStrictness']) !== null && _d !== void 0 ? _d : '',
        websiteMatchStrictness: (_e = o['websiteMatchStrictness']) !== null && _e !== void 0 ? _e : '',
    };
}
export function emailConfigurationToJson(m) {
    const o = {};
    if (m.senderName !== undefined)
        o['senderName'] = m.senderName;
    if (m.senderEmail !== undefined)
        o['senderEmail'] = m.senderEmail;
    if (m.replyEmail !== undefined)
        o['replyEmail'] = m.replyEmail;
    return o;
}
export function emailConfigurationFromJson(o) {
    var _a, _b, _c;
    return {
        senderName: (_a = o['senderName']) !== null && _a !== void 0 ? _a : '',
        senderEmail: (_b = o['senderEmail']) !== null && _b !== void 0 ? _b : '',
        replyEmail: (_c = o['replyEmail']) !== null && _c !== void 0 ? _c : '',
    };
}
export function mailingConfigurationToJson(m) {
    const o = {};
    if (m.mailingCompanyName !== undefined)
        o['mailingCompanyName'] = m.mailingCompanyName;
    if (m.mailingAddress !== undefined)
        o['mailingAddress'] = m.mailingAddress;
    if (m.mailingAddress2 !== undefined)
        o['mailingAddress2'] = m.mailingAddress2;
    if (m.mailingCity !== undefined)
        o['mailingCity'] = m.mailingCity;
    if (m.mailingState !== undefined)
        o['mailingState'] = m.mailingState;
    if (m.mailingCountry !== undefined)
        o['mailingCountry'] = m.mailingCountry;
    if (m.mailingPostalCode !== undefined)
        o['mailingPostalCode'] = m.mailingPostalCode;
    if (m.mailingPhoneNumber !== undefined)
        o['mailingPhoneNumber'] = m.mailingPhoneNumber;
    if (m.mailingWebsiteAddress !== undefined)
        o['mailingWebsiteAddress'] = m.mailingWebsiteAddress;
    if (m.mailingEmailAddress !== undefined)
        o['mailingEmailAddress'] = m.mailingEmailAddress;
    return o;
}
export function mailingConfigurationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        mailingCompanyName: (_a = o['mailingCompanyName']) !== null && _a !== void 0 ? _a : '',
        mailingAddress: (_b = o['mailingAddress']) !== null && _b !== void 0 ? _b : '',
        mailingAddress2: (_c = o['mailingAddress2']) !== null && _c !== void 0 ? _c : '',
        mailingCity: (_d = o['mailingCity']) !== null && _d !== void 0 ? _d : '',
        mailingState: (_e = o['mailingState']) !== null && _e !== void 0 ? _e : '',
        mailingCountry: (_f = o['mailingCountry']) !== null && _f !== void 0 ? _f : '',
        mailingPostalCode: (_g = o['mailingPostalCode']) !== null && _g !== void 0 ? _g : '',
        mailingPhoneNumber: (_h = o['mailingPhoneNumber']) !== null && _h !== void 0 ? _h : '',
        mailingWebsiteAddress: (_j = o['mailingWebsiteAddress']) !== null && _j !== void 0 ? _j : '',
        mailingEmailAddress: (_k = o['mailingEmailAddress']) !== null && _k !== void 0 ? _k : '',
    };
}
export function configurationToJson(m) {
    const o = {};
    if (m.geoRegionForPerformanceMetrics !== undefined) {
        o['geoRegionForPerformanceMetrics'] = m.geoRegionForPerformanceMetrics.map(e => e);
    }
    if (m.snapshotConfiguration !== undefined)
        o['snapshotConfiguration'] = snapshotConfigurationToJson(m.snapshotConfiguration);
    if (m.enabledFeatures !== undefined) {
        o['enabledFeatures'] = m.enabledFeatures.map(e => e);
    }
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    if (m.subscriptionLevel !== undefined)
        o['subscriptionLevel'] = m.subscriptionLevel;
    if (m.socialProfileGroupId !== undefined)
        o['socialProfileGroupId'] = m.socialProfileGroupId;
    if (m.reputationConfiguration !== undefined)
        o['reputationConfiguration'] = reputationConfigurationToJson(m.reputationConfiguration);
    if (m.salesConfiguration !== undefined)
        o['salesConfiguration'] = salesConfigurationToJson(m.salesConfiguration);
    if (m.businessCenterConfiguration !== undefined)
        o['businessCenterConfiguration'] = businessCenterConfigurationToJson(m.businessCenterConfiguration);
    if (m.hasBrandsEnabled !== undefined)
        o['hasBrandsEnabled'] = m.hasBrandsEnabled;
    if (m.hasProductMarketplace !== undefined)
        o['hasProductMarketplace'] = m.hasProductMarketplace;
    if (m.adintelIsEnabled !== undefined)
        o['adintelIsEnabled'] = m.adintelIsEnabled;
    if (m.msAlwaysEnabled !== undefined)
        o['msAlwaysEnabled'] = m.msAlwaysEnabled;
    if (m.subscriptionFailure !== undefined)
        o['subscriptionFailure'] = m.subscriptionFailure;
    if (m.emailConfiguration !== undefined)
        o['emailConfiguration'] = emailConfigurationToJson(m.emailConfiguration);
    if (m.mailingConfiguration !== undefined)
        o['mailingConfiguration'] = mailingConfigurationToJson(m.mailingConfiguration);
    if (m.subscriptionTierId !== undefined)
        o['subscriptionTierId'] = m.subscriptionTierId;
    if (m.segmentedOnboardingConfiguration !== undefined)
        o['segmentedOnboardingConfiguration'] = m.segmentedOnboardingConfiguration;
    if (m.taskManagerConfiguration !== undefined)
        o['taskManagerConfiguration'] = taskManagerConfigurationToJson(m.taskManagerConfiguration);
    if (m.msChatWidgetEnabled !== undefined)
        o['msChatWidgetEnabled'] = m.msChatWidgetEnabled;
    if (m.disableBusinessNav !== undefined)
        o['disableBusinessNav'] = m.disableBusinessNav;
    if (m.exitLinkConfiguration !== undefined)
        o['exitLinkConfiguration'] = exitLinkConfigurationToJson(m.exitLinkConfiguration);
    if (m.disableProductSwitcher !== undefined)
        o['disableProductSwitcher'] = m.disableProductSwitcher;
    return o;
}
export function configurationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return {
        geoRegionForPerformanceMetrics: ((_a = o['geoRegionForPerformanceMetrics']) !== null && _a !== void 0 ? _a : []).map(e => e),
        snapshotConfiguration: o['snapshotConfiguration'] ? snapshotConfigurationFromJson(o['snapshotConfiguration']) : undefined,
        enabledFeatures: ((_b = o['enabledFeatures']) !== null && _b !== void 0 ? _b : []).map(e => e),
        tags: ((_c = o['tags']) !== null && _c !== void 0 ? _c : []).map(e => e),
        subscriptionLevel: (_d = o['subscriptionLevel']) !== null && _d !== void 0 ? _d : 'SUBSCRIPTION_LEVEL_BASIC',
        socialProfileGroupId: (_e = o['socialProfileGroupId']) !== null && _e !== void 0 ? _e : '',
        reputationConfiguration: o['reputationConfiguration'] ? reputationConfigurationFromJson(o['reputationConfiguration']) : undefined,
        salesConfiguration: o['salesConfiguration'] ? salesConfigurationFromJson(o['salesConfiguration']) : undefined,
        businessCenterConfiguration: o['businessCenterConfiguration'] ? businessCenterConfigurationFromJson(o['businessCenterConfiguration']) : undefined,
        hasBrandsEnabled: (_f = o['hasBrandsEnabled']) !== null && _f !== void 0 ? _f : false,
        hasProductMarketplace: (_g = o['hasProductMarketplace']) !== null && _g !== void 0 ? _g : false,
        adintelIsEnabled: (_h = o['adintelIsEnabled']) !== null && _h !== void 0 ? _h : false,
        msAlwaysEnabled: (_j = o['msAlwaysEnabled']) !== null && _j !== void 0 ? _j : false,
        subscriptionFailure: (_k = o['subscriptionFailure']) !== null && _k !== void 0 ? _k : 'SUBSCRIPTION_FAILURE_NONE',
        emailConfiguration: o['emailConfiguration'] ? emailConfigurationFromJson(o['emailConfiguration']) : undefined,
        mailingConfiguration: o['mailingConfiguration'] ? mailingConfigurationFromJson(o['mailingConfiguration']) : undefined,
        subscriptionTierId: (_l = o['subscriptionTierId']) !== null && _l !== void 0 ? _l : '',
        segmentedOnboardingConfiguration: (_m = o['segmentedOnboardingConfiguration']) !== null && _m !== void 0 ? _m : 'SEGMENTED_ONBOARDING_UNSET',
        taskManagerConfiguration: o['taskManagerConfiguration'] ? taskManagerConfigurationFromJson(o['taskManagerConfiguration']) : undefined,
        msChatWidgetEnabled: (_o = o['msChatWidgetEnabled']) !== null && _o !== void 0 ? _o : false,
        disableBusinessNav: (_p = o['disableBusinessNav']) !== null && _p !== void 0 ? _p : false,
        exitLinkConfiguration: o['exitLinkConfiguration'] ? exitLinkConfigurationFromJson(o['exitLinkConfiguration']) : undefined,
        disableProductSwitcher: (_q = o['disableProductSwitcher']) !== null && _q !== void 0 ? _q : false,
    };
}
export function getConfigurationRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    return o;
}
export function getConfigurationRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getConfigurationResponseToJson(m) {
    const o = {};
    if (m.configuration !== undefined)
        o['configuration'] = configurationToJson(m.configuration);
    return o;
}
export function getConfigurationResponseFromJson(o) {
    return {
        configuration: o['configuration'] ? configurationFromJson(o['configuration']) : undefined,
    };
}
export function createTrialRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.subscriptionLevel !== undefined)
        o['subscriptionLevel'] = m.subscriptionLevel;
    if (m.start !== undefined)
        o['start'] = m.start.toISOString();
    if (m.end !== undefined)
        o['end'] = m.end.toISOString();
    if (m.subscriptionTierId !== undefined)
        o['subscriptionTierId'] = m.subscriptionTierId;
    return o;
}
export function createTrialRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        subscriptionLevel: (_b = o['subscriptionLevel']) !== null && _b !== void 0 ? _b : 'SUBSCRIPTION_LEVEL_BASIC',
        start: o['start'] ? new Date(o['start']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        end: o['end'] ? new Date(o['end']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        subscriptionTierId: (_c = o['subscriptionTierId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getTrialRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getTrialRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getTrialResponseToJson(m) {
    const o = {};
    if (m.trialId !== undefined)
        o['trialId'] = m.trialId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.subscriptionLevel !== undefined)
        o['subscriptionLevel'] = m.subscriptionLevel;
    if (m.start !== undefined)
        o['start'] = m.start.toISOString();
    if (m.end !== undefined)
        o['end'] = m.end.toISOString();
    if (m.cancel !== undefined)
        o['cancel'] = m.cancel.toISOString();
    if (m.trial !== undefined)
        o['trial'] = trialToJson(m.trial);
    return o;
}
export function getTrialResponseFromJson(o) {
    var _a, _b, _c;
    return {
        trialId: (_a = o['trialId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        subscriptionLevel: (_c = o['subscriptionLevel']) !== null && _c !== void 0 ? _c : 'SUBSCRIPTION_LEVEL_BASIC',
        start: o['start'] ? new Date(o['start']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        end: o['end'] ? new Date(o['end']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        cancel: o['cancel'] ? new Date(o['cancel']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        trial: o['trial'] ? trialFromJson(o['trial']) : undefined,
    };
}
export function cancelTrialRequestToJson(m) {
    const o = {};
    if (m.trialId !== undefined)
        o['trialId'] = m.trialId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function cancelTrialRequestFromJson(o) {
    var _a, _b;
    return {
        trialId: (_a = o['trialId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listTrialRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    return o;
}
export function listTrialRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        cursor: (_c = o['cursor']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listTrialResponseToJson(m) {
    const o = {};
    if (m.trials !== undefined) {
        o['trials'] = m.trials.map(e => trialToJson(e));
    }
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.hits !== undefined)
        o['hits'] = m.hits;
    return o;
}
export function listTrialResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        trials: ((_a = o['trials']) !== null && _a !== void 0 ? _a : []).map(e => trialFromJson(e)),
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
        hits: (_d = o['hits']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function activateAddonRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.addonId !== undefined)
        o['addonId'] = m.addonId;
    if (m.quantity !== undefined)
        o['quantity'] = m.quantity;
    return o;
}
export function activateAddonRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        addonId: (_b = o['addonId']) !== null && _b !== void 0 ? _b : '',
        quantity: (_c = o['quantity']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function activateAddonResponseToJson(m) {
    const o = {};
    if (m.activation !== undefined)
        o['activation'] = addonActivationToJson(m.activation);
    return o;
}
export function activateAddonResponseFromJson(o) {
    return {
        activation: o['activation'] ? addonActivationFromJson(o['activation']) : undefined,
    };
}
export function deactivateAddonRequestToJson(m) {
    const o = {};
    if (m.activationId !== undefined)
        o['activationId'] = m.activationId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.addonId !== undefined)
        o['addonId'] = m.addonId;
    return o;
}
export function deactivateAddonRequestFromJson(o) {
    var _a, _b, _c;
    return {
        activationId: (_a = o['activationId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        addonId: (_c = o['addonId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listAddonActivationsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listAddonActivationsRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listAddonActivationsResponseToJson(m) {
    const o = {};
    if (m.activations !== undefined) {
        o['activations'] = m.activations.map(e => addonActivationToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listAddonActivationsResponseFromJson(o) {
    var _a;
    return {
        activations: ((_a = o['activations']) !== null && _a !== void 0 ? _a : []).map(e => addonActivationFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getAddonActivationRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.addonId !== undefined)
        o['addonId'] = m.addonId;
    if (m.activationId !== undefined)
        o['activationId'] = m.activationId;
    return o;
}
export function getAddonActivationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        addonId: (_b = o['addonId']) !== null && _b !== void 0 ? _b : '',
        activationId: (_c = o['activationId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getAddonActivationResponseToJson(m) {
    const o = {};
    if (m.activation !== undefined)
        o['activation'] = addonActivationToJson(m.activation);
    return o;
}
export function getAddonActivationResponseFromJson(o) {
    return {
        activation: o['activation'] ? addonActivationFromJson(o['activation']) : undefined,
    };
}
export function listPartnerAddonsRequestToJson(m) {
    const o = {};
    return o;
}
export function listPartnerAddonsRequestFromJson(o) {
    return {};
}
export function listPartnerAddonsResponseToJson(m) {
    const o = {};
    if (m.addons !== undefined) {
        o['addons'] = m.addons.map(e => partnerAddonToJson(e));
    }
    return o;
}
export function listPartnerAddonsResponseFromJson(o) {
    var _a;
    return {
        addons: ((_a = o['addons']) !== null && _a !== void 0 ? _a : []).map(e => partnerAddonFromJson(e)),
    };
}
export function resetPartnerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.cancelAllProducts !== undefined)
        o['cancelAllProducts'] = m.cancelAllProducts;
    return o;
}
export function resetPartnerRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        cancelAllProducts: (_b = o['cancelAllProducts']) !== null && _b !== void 0 ? _b : false,
    };
}
export function generateAccountGroupSessionRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.writeAccess !== undefined)
        o['writeAccess'] = m.writeAccess;
    if (m.deleteAccess !== undefined)
        o['deleteAccess'] = m.deleteAccess;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function generateAccountGroupSessionRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        email: (_c = o['email']) !== null && _c !== void 0 ? _c : '',
        writeAccess: (_d = o['writeAccess']) !== null && _d !== void 0 ? _d : false,
        deleteAccess: (_e = o['deleteAccess']) !== null && _e !== void 0 ? _e : false,
        userId: (_f = o['userId']) !== null && _f !== void 0 ? _f : '',
    };
}
export function generateAccountGroupSessionResponseToJson(m) {
    const o = {};
    if (m.idToken !== undefined)
        o['idToken'] = m.idToken;
    return o;
}
export function generateAccountGroupSessionResponseFromJson(o) {
    var _a;
    return {
        idToken: (_a = o['idToken']) !== null && _a !== void 0 ? _a : '',
    };
}
export function partnerCanDoActionRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.actionId !== undefined)
        o['actionId'] = m.actionId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function partnerCanDoActionRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        actionId: (_b = o['actionId']) !== null && _b !== void 0 ? _b : 'ACTION_UNSPECIFIED',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function partnerCanDoActionResponseToJson(m) {
    const o = {};
    if (m.result !== undefined)
        o['result'] = m.result;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    return o;
}
export function partnerCanDoActionResponseFromJson(o) {
    var _a, _b;
    return {
        result: (_a = o['result']) !== null && _a !== void 0 ? _a : false,
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getPartnerAccountGroupMappingRequestToJson(m) {
    const o = {};
    if (m.accountGroupPartnerId !== undefined)
        o['accountGroupPartnerId'] = m.accountGroupPartnerId;
    if (m.identifier !== undefined) {
        if (m.identifier.type === 'partnerId') {
            o['partnerId'] = m.identifier.partnerId;
        }
        if (m.identifier.type === 'accountGroupId') {
            o['accountGroupId'] = m.identifier.accountGroupId;
        }
        if (m.identifier.type === 'primaryAccountGroupId') {
            o['primaryAccountGroupId'] = m.identifier.primaryAccountGroupId;
        }
    }
    else {
        if (m.partnerId !== undefined)
            o['partnerId'] = m.partnerId;
        if (m.accountGroupId !== undefined)
            o['accountGroupId'] = m.accountGroupId;
        if (m.primaryAccountGroupId !== undefined)
            o['primaryAccountGroupId'] = m.primaryAccountGroupId;
    }
    return o;
}
export function getPartnerAccountGroupMappingRequestFromJson(o) {
    var _a;
    return {
        accountGroupPartnerId: (_a = o['accountGroupPartnerId']) !== null && _a !== void 0 ? _a : '',
        identifier: (() => {
            if (o['partnerId'] !== undefined)
                return { type: 'partnerId', partnerId: o['partnerId'] };
            if (o['accountGroupId'] !== undefined)
                return { type: 'accountGroupId', accountGroupId: o['accountGroupId'] };
            if (o['primaryAccountGroupId'] !== undefined)
                return { type: 'primaryAccountGroupId', primaryAccountGroupId: o['primaryAccountGroupId'] };
            return undefined;
        })(),
        partnerId: o['partnerId'] !== undefined ? o['partnerId'] : undefined,
        accountGroupId: o['accountGroupId'] !== undefined ? o['accountGroupId'] : undefined,
        primaryAccountGroupId: o['primaryAccountGroupId'] !== undefined ? o['primaryAccountGroupId'] : undefined,
    };
}
export function deletePartnerAccountGroupRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function deletePartnerAccountGroupRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getPartnerAccountGroupMappingResponseToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.accountGroupPartnerId !== undefined)
        o['accountGroupPartnerId'] = m.accountGroupPartnerId;
    if (m.primaryAccountGroupId !== undefined)
        o['primaryAccountGroupId'] = m.primaryAccountGroupId;
    return o;
}
export function getPartnerAccountGroupMappingResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        accountGroupPartnerId: (_c = o['accountGroupPartnerId']) !== null && _c !== void 0 ? _c : '',
        primaryAccountGroupId: (_d = o['primaryAccountGroupId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function updatePartnerAccountGroupRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.primaryAccountGroupId !== undefined)
        o['primaryAccountGroupId'] = m.primaryAccountGroupId;
    return o;
}
export function updatePartnerAccountGroupRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        primaryAccountGroupId: (_c = o['primaryAccountGroupId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function createPartnerAccountGroupRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.primaryAccountGroupId !== undefined)
        o['primaryAccountGroupId'] = m.primaryAccountGroupId;
    return o;
}
export function createPartnerAccountGroupRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        primaryAccountGroupId: (_c = o['primaryAccountGroupId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function swapPartnerAccountGroupRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.withPartnerId !== undefined)
        o['withPartnerId'] = m.withPartnerId;
    if (m.withAccountGroupId !== undefined)
        o['withAccountGroupId'] = m.withAccountGroupId;
    return o;
}
export function swapPartnerAccountGroupRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        withPartnerId: (_c = o['withPartnerId']) !== null && _c !== void 0 ? _c : '',
        withAccountGroupId: (_d = o['withAccountGroupId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function resendPartnerAdminWelcomeEmailRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.usePlatformDefaultDomain !== undefined)
        o['usePlatformDefaultDomain'] = m.usePlatformDefaultDomain;
    return o;
}
export function resendPartnerAdminWelcomeEmailRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        usePlatformDefaultDomain: (_c = o['usePlatformDefaultDomain']) !== null && _c !== void 0 ? _c : false,
    };
}
export function updatePartnerAdminRequestToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.permissions !== undefined)
        o['permissions'] = partnerAdminPermissionsToJson(m.permissions);
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function updatePartnerAdminRequestFromJson(o) {
    var _a, _b;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        permissions: o['permissions'] ? partnerAdminPermissionsFromJson(o['permissions']) : undefined,
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function createFeatureFlagRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.accessLevel !== undefined)
        o['accessLevel'] = m.accessLevel;
    if (m.moreInfoUrl !== undefined)
        o['moreInfoUrl'] = m.moreInfoUrl;
    if (m.whitelist !== undefined) {
        o['whitelist'] = m.whitelist.map(e => partnerAccessToJson(e));
    }
    if (m.blacklist !== undefined) {
        o['blacklist'] = m.blacklist.map(e => partnerAccessToJson(e));
    }
    if (m.experimentSettings !== undefined)
        o['experimentSettings'] = experimentSettingToJson(m.experimentSettings);
    if (m.ownerName !== undefined)
        o['ownerName'] = m.ownerName;
    if (m.expiration !== undefined)
        o['expiration'] = m.expiration;
    return o;
}
export function createFeatureFlagRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        accessLevel: (_d = o['accessLevel']) !== null && _d !== void 0 ? _d : 'ACCESS_LEVEL_ALPHA',
        moreInfoUrl: (_e = o['moreInfoUrl']) !== null && _e !== void 0 ? _e : '',
        whitelist: ((_f = o['whitelist']) !== null && _f !== void 0 ? _f : []).map(e => partnerAccessFromJson(e)),
        blacklist: ((_g = o['blacklist']) !== null && _g !== void 0 ? _g : []).map(e => partnerAccessFromJson(e)),
        experimentSettings: o['experimentSettings'] ? experimentSettingFromJson(o['experimentSettings']) : undefined,
        ownerName: (_h = o['ownerName']) !== null && _h !== void 0 ? _h : '',
        expiration: (_j = o['expiration']) !== null && _j !== void 0 ? _j : 'EXPIRATION_INVALID',
    };
}
export function updateFeatureFlagRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.mutations !== undefined) {
        o['mutations'] = m.mutations.map(e => updateFeatureFlagRequestMutationToJson(e));
    }
    return o;
}
export function updateFeatureFlagRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        mutations: ((_b = o['mutations']) !== null && _b !== void 0 ? _b : []).map(e => updateFeatureFlagRequestMutationFromJson(e)),
    };
}
export function updateFeatureFlagRequestMutationToJson(m) {
    const o = {};
    if (m.mutation !== undefined) {
        if (m.mutation.type === 'name') {
            o['name'] = m.mutation.name;
        }
        if (m.mutation.type === 'description') {
            o['description'] = m.mutation.description;
        }
        if (m.mutation.type === 'accessLevel') {
            o['accessLevel'] = m.mutation.accessLevel;
        }
        if (m.mutation.type === 'moreInfoUrl') {
            o['moreInfoUrl'] = m.mutation.moreInfoUrl;
        }
        if (m.mutation.type === 'archived') {
            o['archived'] = m.mutation.archived;
        }
        if (m.mutation.type === 'whitelist') {
            o['whitelist'] = updateFeatureFlagRequestMutationPartnerAccessMutationToJson(m.mutation.whitelist);
        }
        if (m.mutation.type === 'blacklist') {
            o['blacklist'] = updateFeatureFlagRequestMutationPartnerAccessMutationToJson(m.mutation.blacklist);
        }
        if (m.mutation.type === 'experimentSettings') {
            o['experimentSettings'] = experimentSettingToJson(m.mutation.experimentSettings);
        }
        if (m.mutation.type === 'ownerName') {
            o['ownerName'] = m.mutation.ownerName;
        }
        if (m.mutation.type === 'expiration') {
            o['expiration'] = m.mutation.expiration;
        }
        if (m.mutation.type === 'restartExpiry') {
            o['restartExpiry'] = m.mutation.restartExpiry;
        }
    }
    else {
        if (m.name !== undefined)
            o['name'] = m.name;
        if (m.description !== undefined)
            o['description'] = m.description;
        if (m.accessLevel !== undefined)
            o['accessLevel'] = m.accessLevel;
        if (m.moreInfoUrl !== undefined)
            o['moreInfoUrl'] = m.moreInfoUrl;
        if (m.archived !== undefined)
            o['archived'] = m.archived;
        if (m.whitelist !== undefined)
            o['whitelist'] = updateFeatureFlagRequestMutationPartnerAccessMutationToJson(m.whitelist);
        if (m.blacklist !== undefined)
            o['blacklist'] = updateFeatureFlagRequestMutationPartnerAccessMutationToJson(m.blacklist);
        if (m.experimentSettings !== undefined)
            o['experimentSettings'] = experimentSettingToJson(m.experimentSettings);
        if (m.ownerName !== undefined)
            o['ownerName'] = m.ownerName;
        if (m.expiration !== undefined)
            o['expiration'] = m.expiration;
        if (m.restartExpiry !== undefined)
            o['restartExpiry'] = m.restartExpiry;
    }
    return o;
}
export function updateFeatureFlagRequestMutationFromJson(o) {
    return {
        mutation: (() => {
            if (o['name'] !== undefined)
                return { type: 'name', name: o['name'] };
            if (o['description'] !== undefined)
                return { type: 'description', description: o['description'] };
            if (o['accessLevel'] !== undefined)
                return { type: 'accessLevel', accessLevel: o['accessLevel'] };
            if (o['moreInfoUrl'] !== undefined)
                return { type: 'moreInfoUrl', moreInfoUrl: o['moreInfoUrl'] };
            if (o['archived'] !== undefined)
                return { type: 'archived', archived: o['archived'] };
            if (o['whitelist'] !== undefined)
                return { type: 'whitelist', whitelist: o['whitelist'] ? updateFeatureFlagRequestMutationPartnerAccessMutationFromJson(o['whitelist']) : undefined };
            if (o['blacklist'] !== undefined)
                return { type: 'blacklist', blacklist: o['blacklist'] ? updateFeatureFlagRequestMutationPartnerAccessMutationFromJson(o['blacklist']) : undefined };
            if (o['experimentSettings'] !== undefined)
                return { type: 'experimentSettings', experimentSettings: o['experimentSettings'] ? experimentSettingFromJson(o['experimentSettings']) : undefined };
            if (o['ownerName'] !== undefined)
                return { type: 'ownerName', ownerName: o['ownerName'] };
            if (o['expiration'] !== undefined)
                return { type: 'expiration', expiration: o['expiration'] };
            if (o['restartExpiry'] !== undefined)
                return { type: 'restartExpiry', restartExpiry: o['restartExpiry'] };
            return undefined;
        })(),
        name: o['name'] !== undefined ? o['name'] : undefined,
        description: o['description'] !== undefined ? o['description'] : undefined,
        accessLevel: o['accessLevel'] !== undefined ? o['accessLevel'] : undefined,
        moreInfoUrl: o['moreInfoUrl'] !== undefined ? o['moreInfoUrl'] : undefined,
        archived: o['archived'] !== undefined ? o['archived'] : undefined,
        whitelist: o['whitelist'] !== undefined ? o['whitelist'] ? updateFeatureFlagRequestMutationPartnerAccessMutationFromJson(o['whitelist']) : undefined : undefined,
        blacklist: o['blacklist'] !== undefined ? o['blacklist'] ? updateFeatureFlagRequestMutationPartnerAccessMutationFromJson(o['blacklist']) : undefined : undefined,
        experimentSettings: o['experimentSettings'] !== undefined ? o['experimentSettings'] ? experimentSettingFromJson(o['experimentSettings']) : undefined : undefined,
        ownerName: o['ownerName'] !== undefined ? o['ownerName'] : undefined,
        expiration: o['expiration'] !== undefined ? o['expiration'] : undefined,
        restartExpiry: o['restartExpiry'] !== undefined ? o['restartExpiry'] : undefined,
    };
}
export function updateFeatureFlagRequestMutationPartnerAccessMutationToJson(m) {
    const o = {};
    if (m.accessList !== undefined) {
        o['accessList'] = m.accessList.map(e => partnerAccessToJson(e));
    }
    return o;
}
export function updateFeatureFlagRequestMutationPartnerAccessMutationFromJson(o) {
    var _a;
    return {
        accessList: ((_a = o['accessList']) !== null && _a !== void 0 ? _a : []).map(e => partnerAccessFromJson(e)),
    };
}
export function batchGetStatusFeatureFlagRequestToJson(m) {
    const o = {};
    if (m.featureIds !== undefined) {
        o['featureIds'] = m.featureIds.map(e => e);
    }
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    return o;
}
export function batchGetStatusFeatureFlagRequestFromJson(o) {
    var _a, _b, _c;
    return {
        featureIds: ((_a = o['featureIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        marketId: (_c = o['marketId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function batchGetStatusFeatureFlagResponseToJson(m) {
    const o = {};
    if (m.hasAccess !== undefined) {
        o['hasAccess'] = m.hasAccess.map(e => e);
    }
    return o;
}
export function batchGetStatusFeatureFlagResponseFromJson(o) {
    var _a;
    return {
        hasAccess: ((_a = o['hasAccess']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function batchGetFeatureFlagRequestToJson(m) {
    const o = {};
    if (m.ids !== undefined) {
        o['ids'] = m.ids.map(e => e);
    }
    return o;
}
export function batchGetFeatureFlagRequestFromJson(o) {
    var _a;
    return {
        ids: ((_a = o['ids']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function batchGetFeatureFlagResponseToJson(m) {
    const o = {};
    if (m.flags !== undefined) {
        o['flags'] = m.flags.map(e => featureFlagToJson(e));
    }
    return o;
}
export function batchGetFeatureFlagResponseFromJson(o) {
    var _a;
    return {
        flags: ((_a = o['flags']) !== null && _a !== void 0 ? _a : []).map(e => featureFlagFromJson(e)),
    };
}
export function listFeatureFlagFiltersToJson(m) {
    const o = {};
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.accessLevel !== undefined) {
        o['accessLevel'] = m.accessLevel.map(e => e);
    }
    return o;
}
export function listFeatureFlagFiltersFromJson(o) {
    var _a, _b;
    return {
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
        accessLevel: ((_b = o['accessLevel']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function listFeatureFlagRequestToJson(m) {
    const o = {};
    if (m.archivedOnly !== undefined)
        o['archivedOnly'] = m.archivedOnly;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.filters !== undefined)
        o['filters'] = listFeatureFlagFiltersToJson(m.filters);
    return o;
}
export function listFeatureFlagRequestFromJson(o) {
    var _a, _b, _c;
    return {
        archivedOnly: (_a = o['archivedOnly']) !== null && _a !== void 0 ? _a : false,
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
        filters: o['filters'] ? listFeatureFlagFiltersFromJson(o['filters']) : undefined,
    };
}
export function listFeatureFlagResponseToJson(m) {
    const o = {};
    if (m.flags !== undefined) {
        o['flags'] = m.flags.map(e => featureFlagToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function listFeatureFlagResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        flags: ((_a = o['flags']) !== null && _a !== void 0 ? _a : []).map(e => featureFlagFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
        totalResults: (_d = o['totalResults']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function createAnalyticsDashboardRequestToJson(m) {
    const o = {};
    if (m.featureFlagId !== undefined)
        o['featureFlagId'] = m.featureFlagId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function createAnalyticsDashboardRequestFromJson(o) {
    var _a, _b;
    return {
        featureFlagId: (_a = o['featureFlagId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function addPartnerToWhitelistRequestToJson(m) {
    const o = {};
    if (m.featureFlagId !== undefined)
        o['featureFlagId'] = m.featureFlagId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function addPartnerToWhitelistRequestFromJson(o) {
    var _a, _b;
    return {
        featureFlagId: (_a = o['featureFlagId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function setPartnerHealthRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.subState !== undefined)
        o['subState'] = m.subState;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.inRetention !== undefined)
        o['inRetention'] = m.inRetention;
    return o;
}
export function setPartnerHealthRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        state: (_b = o['state']) !== null && _b !== void 0 ? _b : 'PARTNER_HEALTH_STATE_HEALTHY',
        subState: (_c = o['subState']) !== null && _c !== void 0 ? _c : 'PARTNER_HEALTH_SUB_STATE_UNSPECIFIED',
        reason: (_d = o['reason']) !== null && _d !== void 0 ? _d : '',
        inRetention: (_e = o['inRetention']) !== null && _e !== void 0 ? _e : false,
    };
}
export function getPartnerHealthRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getPartnerHealthRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getPartnerHealthResponseToJson(m) {
    const o = {};
    if (m.health !== undefined)
        o['health'] = partnerHealthToJson(m.health);
    return o;
}
export function getPartnerHealthResponseFromJson(o) {
    return {
        health: o['health'] ? partnerHealthFromJson(o['health']) : undefined,
    };
}
export function listPartnerHealthRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    return o;
}
export function listPartnerHealthRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        cursor: (_c = o['cursor']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listPartnerHealthResponseToJson(m) {
    const o = {};
    if (m.healths !== undefined) {
        o['healths'] = m.healths.map(e => partnerHealthToJson(e));
    }
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.hits !== undefined)
        o['hits'] = m.hits;
    return o;
}
export function listPartnerHealthResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        healths: ((_a = o['healths']) !== null && _a !== void 0 ? _a : []).map(e => partnerHealthFromJson(e)),
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
        hits: (_d = o['hits']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function getMultiPartnerHealthRequestToJson(m) {
    const o = {};
    if (m.partnerIds !== undefined) {
        o['partnerIds'] = m.partnerIds.map(e => e);
    }
    return o;
}
export function getMultiPartnerHealthRequestFromJson(o) {
    var _a;
    return {
        partnerIds: ((_a = o['partnerIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiPartnerHealthResponseToJson(m) {
    const o = {};
    if (m.healths !== undefined) {
        o['healths'] = m.healths.map(e => partnerHealthToJson(e));
    }
    return o;
}
export function getMultiPartnerHealthResponseFromJson(o) {
    var _a;
    return {
        healths: ((_a = o['healths']) !== null && _a !== void 0 ? _a : []).map(e => partnerHealthFromJson(e)),
    };
}
export function createPreviewEmailRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.templateId !== undefined)
        o['templateId'] = m.templateId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function createPreviewEmailRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        templateId: (_b = o['templateId']) !== null && _b !== void 0 ? _b : '',
        userId: (_c = o['userId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function canSendPreviewEmailRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function canSendPreviewEmailRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function canSendPreviewEmailResponseToJson(m) {
    const o = {};
    if (m.canSendPreviewEmails !== undefined)
        o['canSendPreviewEmails'] = m.canSendPreviewEmails;
    return o;
}
export function canSendPreviewEmailResponseFromJson(o) {
    var _a;
    return {
        canSendPreviewEmails: (_a = o['canSendPreviewEmails']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getBrandingV2RequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    return o;
}
export function getBrandingV2RequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getBrandingV2ResponseToJson(m) {
    const o = {};
    if (m.branding !== undefined)
        o['branding'] = brandingV2ToJson(m.branding);
    return o;
}
export function getBrandingV2ResponseFromJson(o) {
    return {
        branding: o['branding'] ? brandingV2FromJson(o['branding']) : undefined,
    };
}
export function getMultiBrandingV2RequestToJson(m) {
    const o = {};
    if (m.requests !== undefined) {
        o['requests'] = m.requests.map(e => getBrandingV2RequestToJson(e));
    }
    return o;
}
export function getMultiBrandingV2RequestFromJson(o) {
    var _a;
    return {
        requests: ((_a = o['requests']) !== null && _a !== void 0 ? _a : []).map(e => getBrandingV2RequestFromJson(e)),
    };
}
export function getMultiBrandingV2ResponseToJson(m) {
    const o = {};
    if (m.branding !== undefined) {
        o['branding'] = m.branding.map(e => brandingV2ToJson(e));
    }
    return o;
}
export function getMultiBrandingV2ResponseFromJson(o) {
    var _a;
    return {
        branding: ((_a = o['branding']) !== null && _a !== void 0 ? _a : []).map(e => brandingV2FromJson(e)),
    };
}
export function upsertMutationToJson(m) {
    const o = {};
    if (m.mutation !== undefined) {
        if (m.mutation.type === 'faviconUrl') {
            o['faviconUrl'] = m.mutation.faviconUrl;
        }
        if (m.mutation.type === 'shortcutIconUrl') {
            o['shortcutIconUrl'] = m.mutation.shortcutIconUrl;
        }
        if (m.mutation.type === 'logoUrl') {
            o['logoUrl'] = m.mutation.logoUrl;
        }
        if (m.mutation.type === 'uiTheme') {
            o['uiTheme'] = m.mutation.uiTheme;
        }
        if (m.mutation.type === 'primaryColor') {
            o['primaryColor'] = m.mutation.primaryColor;
        }
        if (m.mutation.type === 'marketOverrides') {
            o['marketOverrides'] = upsertMutationMarketOverridesMutationToJson(m.mutation.marketOverrides);
        }
        if (m.mutation.type === 'name') {
            o['name'] = m.mutation.name;
        }
        if (m.mutation.type === 'darkModeLogoUrl') {
            o['darkModeLogoUrl'] = m.mutation.darkModeLogoUrl;
        }
        if (m.mutation.type === 'businessAppUiTheme') {
            o['businessAppUiTheme'] = m.mutation.businessAppUiTheme;
        }
    }
    else {
        if (m.faviconUrl !== undefined)
            o['faviconUrl'] = m.faviconUrl;
        if (m.shortcutIconUrl !== undefined)
            o['shortcutIconUrl'] = m.shortcutIconUrl;
        if (m.logoUrl !== undefined)
            o['logoUrl'] = m.logoUrl;
        if (m.uiTheme !== undefined)
            o['uiTheme'] = m.uiTheme;
        if (m.primaryColor !== undefined)
            o['primaryColor'] = m.primaryColor;
        if (m.marketOverrides !== undefined)
            o['marketOverrides'] = upsertMutationMarketOverridesMutationToJson(m.marketOverrides);
        if (m.name !== undefined)
            o['name'] = m.name;
        if (m.darkModeLogoUrl !== undefined)
            o['darkModeLogoUrl'] = m.darkModeLogoUrl;
        if (m.businessAppUiTheme !== undefined)
            o['businessAppUiTheme'] = m.businessAppUiTheme;
    }
    return o;
}
export function upsertMutationFromJson(o) {
    return {
        mutation: (() => {
            if (o['faviconUrl'] !== undefined)
                return { type: 'faviconUrl', faviconUrl: o['faviconUrl'] };
            if (o['shortcutIconUrl'] !== undefined)
                return { type: 'shortcutIconUrl', shortcutIconUrl: o['shortcutIconUrl'] };
            if (o['logoUrl'] !== undefined)
                return { type: 'logoUrl', logoUrl: o['logoUrl'] };
            if (o['uiTheme'] !== undefined)
                return { type: 'uiTheme', uiTheme: o['uiTheme'] };
            if (o['primaryColor'] !== undefined)
                return { type: 'primaryColor', primaryColor: o['primaryColor'] };
            if (o['marketOverrides'] !== undefined)
                return { type: 'marketOverrides', marketOverrides: o['marketOverrides'] ? upsertMutationMarketOverridesMutationFromJson(o['marketOverrides']) : undefined };
            if (o['name'] !== undefined)
                return { type: 'name', name: o['name'] };
            if (o['darkModeLogoUrl'] !== undefined)
                return { type: 'darkModeLogoUrl', darkModeLogoUrl: o['darkModeLogoUrl'] };
            if (o['businessAppUiTheme'] !== undefined)
                return { type: 'businessAppUiTheme', businessAppUiTheme: o['businessAppUiTheme'] };
            return undefined;
        })(),
        faviconUrl: o['faviconUrl'] !== undefined ? o['faviconUrl'] : undefined,
        shortcutIconUrl: o['shortcutIconUrl'] !== undefined ? o['shortcutIconUrl'] : undefined,
        logoUrl: o['logoUrl'] !== undefined ? o['logoUrl'] : undefined,
        uiTheme: o['uiTheme'] !== undefined ? o['uiTheme'] : undefined,
        primaryColor: o['primaryColor'] !== undefined ? o['primaryColor'] : undefined,
        marketOverrides: o['marketOverrides'] !== undefined ? o['marketOverrides'] ? upsertMutationMarketOverridesMutationFromJson(o['marketOverrides']) : undefined : undefined,
        name: o['name'] !== undefined ? o['name'] : undefined,
        darkModeLogoUrl: o['darkModeLogoUrl'] !== undefined ? o['darkModeLogoUrl'] : undefined,
        businessAppUiTheme: o['businessAppUiTheme'] !== undefined ? o['businessAppUiTheme'] : undefined,
    };
}
export function upsertMutationMarketOverridesMutationToJson(m) {
    const o = {};
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => e);
    }
    return o;
}
export function upsertMutationMarketOverridesMutationFromJson(o) {
    var _a;
    return {
        fields: ((_a = o['fields']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function upsertBrandingV2RequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.mutations !== undefined) {
        o['mutations'] = m.mutations.map(e => upsertMutationToJson(e));
    }
    return o;
}
export function upsertBrandingV2RequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        mutations: ((_c = o['mutations']) !== null && _c !== void 0 ? _c : []).map(e => upsertMutationFromJson(e)),
    };
}
export function listBrandingV2RequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listBrandingV2RequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listBrandingV2ResponseToJson(m) {
    const o = {};
    if (m.brandings !== undefined) {
        o['brandings'] = m.brandings.map(e => brandingV2ToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listBrandingV2ResponseFromJson(o) {
    var _a;
    return {
        brandings: ((_a = o['brandings']) !== null && _a !== void 0 ? _a : []).map(e => brandingV2FromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getPartnerCenterNavigationRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getPartnerCenterNavigationRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getPartnerCenterNavigationResponseToJson(m) {
    const o = {};
    if (m.navigation !== undefined) {
        o['navigation'] = m.navigation.map(e => navigationItemToJson(e));
    }
    return o;
}
export function getPartnerCenterNavigationResponseFromJson(o) {
    var _a;
    return {
        navigation: ((_a = o['navigation']) !== null && _a !== void 0 ? _a : []).map(e => navigationItemFromJson(e)),
    };
}
export function listMarketsForUserRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function listMarketsForUserRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listMarketsForUserResponseToJson(m) {
    const o = {};
    if (m.markets !== undefined) {
        o['markets'] = m.markets.map(e => marketToJson(e));
    }
    return o;
}
export function listMarketsForUserResponseFromJson(o) {
    var _a;
    return {
        markets: ((_a = o['markets']) !== null && _a !== void 0 ? _a : []).map(e => marketFromJson(e)),
    };
}
export function getPartnerModelRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getPartnerModelRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getPartnerModelResponseToJson(m) {
    const o = {};
    if (m.partner !== undefined)
        o['partner'] = partnerModelToJson(m.partner);
    return o;
}
export function getPartnerModelResponseFromJson(o) {
    return {
        partner: o['partner'] ? partnerModelFromJson(o['partner']) : undefined,
    };
}
export function getMultiPartnerModelRequestToJson(m) {
    const o = {};
    if (m.partnerIds !== undefined) {
        o['partnerIds'] = m.partnerIds.map(e => e);
    }
    return o;
}
export function getMultiPartnerModelRequestFromJson(o) {
    var _a;
    return {
        partnerIds: ((_a = o['partnerIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiPartnerModelResponseToJson(m) {
    const o = {};
    if (m.partners !== undefined) {
        o['partners'] = m.partners.map(e => partnerModelToJson(e));
    }
    return o;
}
export function getMultiPartnerModelResponseFromJson(o) {
    var _a;
    return {
        partners: ((_a = o['partners']) !== null && _a !== void 0 ? _a : []).map(e => partnerModelFromJson(e)),
    };
}
export function updatePartnerModelMutationToJson(m) {
    const o = {};
    if (m.mutation !== undefined) {
        if (m.mutation.type === 'premiumSupport') {
            o['premiumSupport'] = m.mutation.premiumSupport;
        }
        if (m.mutation.type === 'standardPrioritySupport') {
            o['standardPrioritySupport'] = m.mutation.standardPrioritySupport;
        }
        if (m.mutation.type === 'priorityChatSupport') {
            o['priorityChatSupport'] = m.mutation.priorityChatSupport;
        }
        if (m.mutation.type === 'name') {
            o['name'] = m.mutation.name;
        }
        if (m.mutation.type === 'addressLineOne') {
            o['addressLineOne'] = m.mutation.addressLineOne;
        }
        if (m.mutation.type === 'addressLineTwo') {
            o['addressLineTwo'] = m.mutation.addressLineTwo;
        }
        if (m.mutation.type === 'city') {
            o['city'] = m.mutation.city;
        }
        if (m.mutation.type === 'countryAndState') {
            o['countryAndState'] = updatePartnerModelMutationCountryStateToJson(m.mutation.countryAndState);
        }
        if (m.mutation.type === 'postalCode') {
            o['postalCode'] = m.mutation.postalCode;
        }
        if (m.mutation.type === 'email') {
            o['email'] = m.mutation.email;
        }
        if (m.mutation.type === 'phoneNumber') {
            o['phoneNumber'] = m.mutation.phoneNumber;
        }
        if (m.mutation.type === 'website') {
            o['website'] = m.mutation.website;
        }
    }
    else {
        if (m.premiumSupport !== undefined)
            o['premiumSupport'] = m.premiumSupport;
        if (m.standardPrioritySupport !== undefined)
            o['standardPrioritySupport'] = m.standardPrioritySupport;
        if (m.priorityChatSupport !== undefined)
            o['priorityChatSupport'] = m.priorityChatSupport;
        if (m.name !== undefined)
            o['name'] = m.name;
        if (m.addressLineOne !== undefined)
            o['addressLineOne'] = m.addressLineOne;
        if (m.addressLineTwo !== undefined)
            o['addressLineTwo'] = m.addressLineTwo;
        if (m.city !== undefined)
            o['city'] = m.city;
        if (m.countryAndState !== undefined)
            o['countryAndState'] = updatePartnerModelMutationCountryStateToJson(m.countryAndState);
        if (m.postalCode !== undefined)
            o['postalCode'] = m.postalCode;
        if (m.email !== undefined)
            o['email'] = m.email;
        if (m.phoneNumber !== undefined)
            o['phoneNumber'] = m.phoneNumber;
        if (m.website !== undefined)
            o['website'] = m.website;
    }
    return o;
}
export function updatePartnerModelMutationFromJson(o) {
    return {
        mutation: (() => {
            if (o['premiumSupport'] !== undefined)
                return { type: 'premiumSupport', premiumSupport: o['premiumSupport'] };
            if (o['standardPrioritySupport'] !== undefined)
                return { type: 'standardPrioritySupport', standardPrioritySupport: o['standardPrioritySupport'] };
            if (o['priorityChatSupport'] !== undefined)
                return { type: 'priorityChatSupport', priorityChatSupport: o['priorityChatSupport'] };
            if (o['name'] !== undefined)
                return { type: 'name', name: o['name'] };
            if (o['addressLineOne'] !== undefined)
                return { type: 'addressLineOne', addressLineOne: o['addressLineOne'] };
            if (o['addressLineTwo'] !== undefined)
                return { type: 'addressLineTwo', addressLineTwo: o['addressLineTwo'] };
            if (o['city'] !== undefined)
                return { type: 'city', city: o['city'] };
            if (o['countryAndState'] !== undefined)
                return { type: 'countryAndState', countryAndState: o['countryAndState'] ? updatePartnerModelMutationCountryStateFromJson(o['countryAndState']) : undefined };
            if (o['postalCode'] !== undefined)
                return { type: 'postalCode', postalCode: o['postalCode'] };
            if (o['email'] !== undefined)
                return { type: 'email', email: o['email'] };
            if (o['phoneNumber'] !== undefined)
                return { type: 'phoneNumber', phoneNumber: o['phoneNumber'] };
            if (o['website'] !== undefined)
                return { type: 'website', website: o['website'] };
            return undefined;
        })(),
        premiumSupport: o['premiumSupport'] !== undefined ? o['premiumSupport'] : undefined,
        standardPrioritySupport: o['standardPrioritySupport'] !== undefined ? o['standardPrioritySupport'] : undefined,
        priorityChatSupport: o['priorityChatSupport'] !== undefined ? o['priorityChatSupport'] : undefined,
        name: o['name'] !== undefined ? o['name'] : undefined,
        addressLineOne: o['addressLineOne'] !== undefined ? o['addressLineOne'] : undefined,
        addressLineTwo: o['addressLineTwo'] !== undefined ? o['addressLineTwo'] : undefined,
        city: o['city'] !== undefined ? o['city'] : undefined,
        countryAndState: o['countryAndState'] !== undefined ? o['countryAndState'] ? updatePartnerModelMutationCountryStateFromJson(o['countryAndState']) : undefined : undefined,
        postalCode: o['postalCode'] !== undefined ? o['postalCode'] : undefined,
        email: o['email'] !== undefined ? o['email'] : undefined,
        phoneNumber: o['phoneNumber'] !== undefined ? o['phoneNumber'] : undefined,
        website: o['website'] !== undefined ? o['website'] : undefined,
    };
}
export function updatePartnerModelMutationCountryStateToJson(m) {
    const o = {};
    if (m.countryCode !== undefined)
        o['countryCode'] = m.countryCode;
    if (m.stateCode !== undefined)
        o['stateCode'] = m.stateCode;
    return o;
}
export function updatePartnerModelMutationCountryStateFromJson(o) {
    var _a, _b;
    return {
        countryCode: (_a = o['countryCode']) !== null && _a !== void 0 ? _a : '',
        stateCode: (_b = o['stateCode']) !== null && _b !== void 0 ? _b : '',
    };
}
export function updatePartnerModelRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.mutations !== undefined) {
        o['mutations'] = m.mutations.map(e => updatePartnerModelMutationToJson(e));
    }
    return o;
}
export function updatePartnerModelRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        mutations: ((_b = o['mutations']) !== null && _b !== void 0 ? _b : []).map(e => updatePartnerModelMutationFromJson(e)),
    };
}
export function searchPartnerModelsFiltersToJson(m) {
    const o = {};
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.subscriptionTierId !== undefined)
        o['subscriptionTierId'] = m.subscriptionTierId;
    return o;
}
export function searchPartnerModelsFiltersFromJson(o) {
    var _a, _b;
    return {
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
        subscriptionTierId: (_b = o['subscriptionTierId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function searchPartnerModelsRequestToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.filters !== undefined)
        o['filters'] = searchPartnerModelsFiltersToJson(m.filters);
    return o;
}
export function searchPartnerModelsRequestFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        filters: o['filters'] ? searchPartnerModelsFiltersFromJson(o['filters']) : undefined,
    };
}
export function searchPartnerModelsResponseToJson(m) {
    const o = {};
    if (m.partners !== undefined) {
        o['partners'] = m.partners.map(e => partnerModelToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function searchPartnerModelsResponseFromJson(o) {
    var _a, _b, _c;
    return {
        partners: ((_a = o['partners']) !== null && _a !== void 0 ? _a : []).map(e => partnerModelFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getSingleSignOnRequestToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function getSingleSignOnRequestFromJson(o) {
    var _a;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getSingleSignOnResponseToJson(m) {
    const o = {};
    if (m.token !== undefined)
        o['token'] = m.token;
    if (m.companyId !== undefined)
        o['companyId'] = m.companyId;
    if (m.roadmapDomain !== undefined)
        o['roadmapDomain'] = m.roadmapDomain;
    return o;
}
export function getSingleSignOnResponseFromJson(o) {
    var _a, _b, _c;
    return {
        token: (_a = o['token']) !== null && _a !== void 0 ? _a : '',
        companyId: (_b = o['companyId']) !== null && _b !== void 0 ? _b : '',
        roadmapDomain: (_c = o['roadmapDomain']) !== null && _c !== void 0 ? _c : '',
    };
}
export function triggerEventRequestToJson(m) {
    const o = {};
    if (m.eventData !== undefined)
        o['eventData'] = m.eventData;
    if (m.eventType !== undefined)
        o['eventType'] = m.eventType;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function triggerEventRequestFromJson(o) {
    var _a, _b, _c;
    return {
        eventData: (_a = o['eventData']) !== null && _a !== void 0 ? _a : {},
        eventType: (_b = o['eventType']) !== null && _b !== void 0 ? _b : '',
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
    };
}
